<template>
    <div>
      <div>
        <div class="main-wrapper">
          <div>
            <!-- <layout-header2></layout-header2> -->
            <layout-header></layout-header>
            <breadcrumb40></breadcrumb40>
            <!-- Page Content -->
            <div class="content">
              <div class="container">
                <div class="row">
                  <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                    <sidebar2></sidebar2>
                  </div>
                  <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
                    <loader></loader>
                  </div>
                  <div class="col-md-7 col-lg-8 col-xl-9" v-else>
                    <!-- Menu Start-->
                    <div class="row ml-md-3">
                      <!-- First column for the image -->
                      <div class="col-lg-2 col-md-3 col-sm-4 col-12 mt-2 text-md-left" style="text-align:center;">
                        <img class="encounter-image"
                          v-bind:src="dashboard_data.patient_image ? config.base_url_for_Image + dashboard_data.patient_image : loadImg('Patient Profile.svg')"
                          alt="User Image" />
                      </div>
  
                      <!-- Second column for patient name, Gender, Mobile No., and DOB -->
                      <div class="col-lg-3 col-md-5 col-sm-8 col-12 mt-2 text-md-left" style="text-align:center;">
                        <div style="font-weight: bold; font-size: 20px;">
                          {{ dashboard_data.patient_name }}
                        </div>
                        <div>Gender: {{ dashboard_data.gender }}</div>
                        <div>Mobile No: {{ dashboard_data.patient_mobile }}</div>
                        <div class="mt-1">
                          <input class="ml-1" type="radio" id="age" value="age" v-model="selectedOption">
                          <label for="age" class="ml-1">Age</label>
                          <input type="radio" id="dob" value="dob" v-model="selectedOption">
                          <label for="dob" class="ml-1">DOB</label>
                          <div v-if="selectedOption === 'dob'">
                            <b-card-text>
                              {{ dashboard_data.dob ? formatDate(dashboard_data.dob) : '---' }}
                            </b-card-text>
                          </div>
                          <div v-else>
                            <b-card-text>{{ patient_age.substring(0, 17) }}</b-card-text>
                          </div>
                        </div>
                      </div>
  
                      <!-- Third column for Visit Type, Date, and Time -->
                      <div class="col-lg-3 col-md-12 col-sm-12 col-12 mt-2 text-md-left" style="text-align:center;">
                        <div style="font-weight: bold; font-size: 20px;">
                          Visit Type: {{ dashboard_data.visit_type }}
                        </div>
                        <div>Date: {{ formatDate(dashboard_data.encounter_date) }}</div>
                        <div>Time: {{ formattedEncounterTime }}</div>
                      </div>
                    </div>
  
                    <nav class="navbar navbar-expand-lg header-nav mt-2 ml-md-4">
                      <div class="main-menu-wrapper patient-encounter">
                        <div class="menu-header" style="width:auto; height:43px;">
                          <a id="menu_close" class="menu-close" href="javascript:void(0);">
                            <i class="fas fa-times"></i>
                          </a>
                        </div>
                        <ul class="main-nav">
                          <li>
                            <a href="javascript:void(0);" :class="active == 'Details' ? 'active_menu' : ''"
                              @click="active_menu('Details'); menu_close()">Complaint
                            </a>
                          </li>
                          <li>
                            <a href="javascript:void(0);" :class="active == 'Medical Records' ? 'active_menu' : ''"
                              @click="active_menu('Medical Records'); menu_close()">Medical Record
                            </a>
                          </li>
  
                          <li>
                            <a href="javascript:void(0);" :class="active == 'Vitals' ? 'active_menu' : ''"
                              @click="active_menu('Vitals'); menu_close()">Vital
                            </a>
                          </li>
                          <li>
                            <a href="javascript:void(0);" :class="active == 'Examinations' ? 'active_menu' : ''"
                              @click="active_menu('Examinations'); menu_close()">Examination
                            </a>
                          </li>
                          <li>
                            <a href="javascript:void(0);" :class="active == 'Treatment' ? 'active_menu' : ''"
                              @click="active_menu('Treatment'); menu_close()">Treatment & Advice
                            </a>
                          </li>
  
                        </ul>
                      </div>
                    </nav>
                    <!-- Menu end-->
  
                    <!-- Details Content Start-->
                    <div v-if="active == 'Details'" class="mt-2 ml-md-4 examination doctor-profile">
                      <div class="row">
                        <div class="col-12 col-md-12 col-lg-6">
                          <!-- Patient's Concerns and Complaints -->
                          <div class="col mt-2" style="text-align: left; margin-bottom: 5px;">
                            <label for="PatientWording">Patient's Concerns and Complaints</label>
                          </div>
                          <div class="col">
                            <textarea id="PatientWording" name="PatientWording" rows="12" cols="50"
                              style="width: 100%; min-height: 200px; height: 250px; border: 1px solid #000;"
                              v-model="dashboard_data.patient_history" disabled></textarea>
  
                          </div>
                        </div>
                        <div class="col-12 col-md-12 col-lg-6">
                          <!-- Reported Symptoms -->
                          <div class="col">
                            <label>Reported Symptoms</label>
                            <div class="row form-row" v-for="(item, index) in complaint" :key="index">
                              <div class="col-md-10">
                                <div class="form-group">
                                  <v-select @change="validateDropdown" class="mr-2" name="name" required label="complaint"
                                    placeholder="Select Symptom" v-model="item.complaint" :reduce="(option) => option.name"
                                    :options="filteredSymptLists[index]" disabled></v-select>
                                </div>
                              </div>
                              <div class="col-md-2" v-if="complaint.length !== 1">
                                <div class="form-group">
                                  <div class="form-group" style="cursor: pointer"
                                    :style="index == 0 ? 'margin-top: 37px' : 'margin-top: 7px'">
                                    <span class="circle" @click="remove_item('complaint', index)"><i
                                        class="fa fa-times"></i></span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="">
                              <a href="javascript:void(0);" @click="add_Information('complaint')" class="add-reg add-more"
                                disabled><i class="fa fa-plus-circle"></i> Add More</a>
                              <a href="#" data-toggle="modal" class="add-reg text-left" data-target="#addsymptoms"
                                disabled><i class="fa fa-plus-circle" tabindex="0"></i> Create New Symptom</a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div id="main" class="mt-3">
                        <!-- ... (rest of the content) ... -->
                      </div>
                      <div class="row"></div>
                      <div class="text-left">
                        <a v-if="currentPath == 'new-patient-encounter'" class="btn btn-primary btn-sm ml-3 mt-1 mr-3" tabindex="0"
                          @click="add_patient_encounter_new('dashboard')" disabled>Save Changes</a>
                        <a v-if="currentPath == 'update-patient-encounter-update' && !closedAppointment"
                          class="btn btn-primary btn-sm ml-3 mt-1 mr-3" tabindex="0" @click="update_patient_encounter('dashboard')"
                          disabled>Update Changes</a>
                      </div>
                    </div>
                    <!-- Details Content End-->
  
                    <!-- Vitals Content Start-->
                    <div v-if="active == 'Vitals'" class="mt-4 ml-md-4">
                      <div class="text-left">
                        <a href="#" data-toggle="modal" data-target="#addvitals" class="btn btn-primary btn-sm mb-2"
                          tabindex="0" disabled>Add Vital</a>
                      </div>
                      <div class="row patient-dashboard-cards">
                        <div class="col-12 col-md-6 col-lg-3 col-xl-3 patient-dashboard-top">
                          <div class="card">
                            <div class="card-body text-center">
                              <div class="mt-2">
                                <h4>Pulse Rate</h4>
                                <h4 v-if="patient_data.pulse_history == 0" style="color: #808080; font-size:medium;">
                                  Not Taken
                                </h4>
                                <h4 v-else>
                                  {{ patient_data.pulse_history }} <sub>bpm</sub>
                                </h4>
                                <img src="@/assets/img/specialities/Pulse.png" alt="" width="70"
                                  style="margin-bottom: 10px;" />
                              </div>
                            </div>
                            <div class="card-footer text-center" style="cursor: pointer;background-color: #f8f8f8; color:black;" href="#" data-toggle="modal"
                              data-target="#pulse-graph">
                              Graph
                            </div>
                          </div>
                        </div>
                        <div class="
                             col-12 col-md-6 col-lg-3 col-xl-3 patient-dashboard-top
                          ">
                          <div class="card">
                            <div class="card-body text-center">
                              <div class="mt-2">
                                <h4>Body Temperature</h4>
                                <h6 v-if="patient_data.temperature_history == 0" style="color: #808080; font-size:medium;">
                                  Not Taken
                                </h6>
                                <h6 v-else>
                                  {{ patient_data.temperature_history }} <sub>C</sub>
                                </h6>
                                <img src="@/assets/img/specialities/Body_temp.jpg" alt="" width="50"
                                  style="margin-top: 10px; margin-bottom: 10px;" />
                              </div>
                            </div>
                            <div class="card-footer text-center" style="cursor: pointer; background-color: #f8f8f8; color:black;" href="#" data-toggle="modal"
                              data-target="#temperature-graph">
                              Graph
                            </div>
                          </div>
                        </div>
                        <div class="
                         col-12 col-md-6 col-lg-3 col-xl-3 patient-dashboard-top
                          ">
                          <div class="card">
                            <div class="card-body text-center">
                              <div class="mt-2">
                                <h4>Blood Pressure</h4>
                                <h6 v-if="patient_data.bp == 0" style="color: #808080; font-size:medium;">
                                  Not Taken
                                </h6>
                                <h6 v-else>
                                  {{ patient_data.bp }}
                                </h6>
                                <img src="@/assets/img/specialities/blood_pressure.png" alt="" width="70"
                                  style="margin-top: 10px; margin-bottom: 10px;" />
                              </div>
                            </div>
                            <div class="card-footer text-center" style="cursor: pointer; background-color: #f8f8f8; color:black;" href="#" data-toggle="modal"
                              data-target="#bp-graph">
                              Graph
                            </div>
                          </div>
                        </div>
                        <div class="
                             col-12 col-md-6 col-lg-3 col-xl-3 patient-dashboard-top
                          ">
                          <div class="card">
                            <div class="card-body text-center">
                              <div class="mt-2">
                                <h4>Fasting Blood Sugar</h4>
  
                                <h6 v-if="patient_data.fasting_blood_sugar_fbs_history == 0"
                                  style="color: #808080; font-size:medium;">
                                  Not Taken
                                </h6>
                                <h6 v-else>
                                  {{ patient_data.fasting_blood_sugar_fbs_history }}
                                </h6>
                                <img src="@/assets/img/specialities/Fasting_blood_sugar.jpg" alt="" width="50"
                                  style="margin-top: 10px; margin-bottom: 10px;" />
                              </div>
                            </div>
                            <div class="card-footer text-center" style="cursor: pointer; background-color: #f8f8f8; color:black;" href="#" data-toggle="modal"
                              data-target="#fasting-graph">
                              Graph
                            </div>
                          </div>
                        </div>
                        <div class="
                             col-12 col-md-6 col-lg-3 col-xl-3 patient-dashboard-top
                          ">
                          <div class="card">
                            <div class="card-body text-center">
                              <div class="mt-2">
                                <h4>Random Blood Sugar</h4>
                                <h4 v-if="patient_data.random_blood_sugar_rbs_history == 0"
                                  style="color: #808080; font-size:medium;">
                                  Not Taken
                                  <sub></sub>
                                </h4>
                                <h4 v-else>
                                  {{ patient_data.random_blood_sugar_rbs_history }}
                                  <sub></sub>
                                </h4>
                                <img src="@/assets/img/specialities/Fasting_blood_sugar.jpg" alt="" width="50"
                                  style="margin-top: 10px; margin-bottom: 10px;" />
                              </div>
                            </div>
                            <div class="card-footer text-center" style="cursor: pointer; background-color: #f8f8f8; color:black;" href="#" data-toggle="modal"
                              data-target="#random-graph">
                              Graph
                            </div>
                          </div>
                        </div>
                        <div class="
                               col-12 col-md-6 col-lg-3 col-xl-3 patient-dashboard-top
                          ">
                          <div class="card">
                            <div class="card-body text-center">
                              <div class="mt-2">
                                <h4>Hba1c</h4>
                                <h4 v-if="patient_data.hba1c_history == 0" style="color: #808080; font-size:medium;">
                                  Not Taken
                                  <sub></sub>
                                </h4>
                                <h4 v-else>
                                  {{ patient_data.hba1c_history }}
                                  <sub></sub>
                                </h4>
                                <img src="@/assets/img/specialities/Hba1c.jpg" alt="" width="70"
                                  style="margin-top: 10px; margin-bottom: 10px;" />
                              </div>
                            </div>
                            <div class="card-footer text-center" style="cursor: pointer; background-color: #f8f8f8; color:black;" href="#" data-toggle="modal"
                              data-target="#Hba1c-graph">
                              Graph
                            </div>
                          </div>
                        </div>
                        <div class="
                              col-12 col-md-6 col-lg-3 col-xl-3 patient-dashboard-top
                          ">
                          <div class="card">
                            <div class="card-body text-center">
                              <div class="mt-2">
                                <h4>Weight (KG)</h4>
                                <h4 v-if="patient_data.weight_history == 0" style="color: #808080; font-size:medium;">
                                  Not Taken
                                  <sub></sub>
                                </h4>
                                <h4 v-else>
                                  {{ patient_data.weight_history }}
                                  <sub></sub>
                                </h4>
                                <img src="@/assets/img/specialities/Weight.jpg" alt="" width="50"
                                  style="margin-top: 10px; margin-bottom: 10px;" />
                              </div>
                            </div>
                            <div class="card-footer text-center" style="cursor: pointer; background-color: #f8f8f8; color:black;" href="#" data-toggle="modal"
                              data-target="#Weight-graph">
                              Graph
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-3 col-xl-3 patient-dashboard-top">
                          <div class="card">
                            <div class="card-body text-center">
                              <div class="mt-2">
                                <h4>BMI</h4>
                                <h4 v-if="patient_data.bmi_history == 0" style="color: #808080; font-size:medium;">
                                  Not Taken
                                  <sub></sub>
                                </h4>
                                <h4 v-else>
                                  {{ patient_data.bmi_history }}
                                  <sub></sub>
                                </h4>
                                <img src="@/assets/img/specialities/BMI.jpg" alt="" width="50"
                                  style="margin-top: 10px; margin-bottom: 10px;" />
                              </div>
                            </div>
                            <div class="card-footer text-center" style="cursor: pointer; background-color: #f8f8f8; color:black;" href="#" data-toggle="modal"
                              data-target="#bmi-graph">
                              {{ patient_data.bmi_unit }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
  
                    <!-- Vitals Content End-->
  
                    <!-- Examinations Content Start -->
  
                    <div v-if="active == 'Examinations'" class="doctor-profile examination ml-md-4">
                      <div id="main">
                        <div class="container">
                          <div class="accordion" id="faq70">
                            <div class="card">
                              <div class="card-header" id="faqhead71">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                  data-target="#faq71" aria-expanded="true" aria-controls="faq71">General Examinations</a>
                              </div>
  
                              <div id="faq71" class="collapse" aria-labelledby="faqhead1" data-parent="#faq70">
                                <div class="card-body">
                                  <div class="row mt-4">
                                    <div class="col-4">
                                      <div class="form-group">
                                        <label>Pallor</label>
                                        <input type="text" class="form-control" v-model="examination_data.pallor"
                                          placeholder="Pallor" disabled/>
                                      </div>
                                    </div>
                                    <div class="col-4">
                                      <div class="form-group">
                                        <label>Cyanosis</label>
                                        <input type="text" class="form-control" v-model="examination_data.cyanosis"
                                          placeholder="Cyanosis" disabled/>
                                      </div>
                                    </div>
                                    <div class="col-4">
                                      <div class="form-group">
                                        <label>Edema</label>
                                        <input type="text" class="form-control" v-model="examination_data.edema"
                                          placeholder="Edema" disabled/>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-4">
                                      <div class="form-group">
                                        <label>Hydration</label>
                                        <input type="text" class="form-control" v-model="examination_data.hydration"
                                          placeholder="Hydration" disabled/>
                                      </div>
                                    </div>
                                    <div class="col-4">
                                      <div class="form-group">
                                        <label>Icterus</label>
                                        <input type="text" class="form-control" v-model="examination_data.icterus"
                                          placeholder="Icterus" disabled/>
                                      </div>
                                    </div>
                                    <div class="col-4">
                                      <div class="form-group">
                                        <label>Clubbing</label>
                                        <input type="text" class="form-control" v-model="examination_data.clubbing"
                                          placeholder="Clubbing" disabled/>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-4">
                                      <div class="form-group">
                                        <label>Dysponea</label>
                                        <input type="text" class="form-control" v-model="examination_data.dysponea"
                                          placeholder="Dysponea" disabled />
                                      </div>
                                    </div>
                                    <div class="col-4">
                                      <div class="form-group">
                                        <label>Thyroid</label>
                                        <input type="text" class="form-control" v-model="examination_data.thyroid"
                                          placeholder="Thyroid" disabled />
                                      </div>
                                    </div>
                                    <div class="col-4">
                                      <div class="form-group">
                                        <label>Lymphadenopathy</label>
                                        <input type="text" class="form-control" v-model="examination_data.lymphadenopathy
                                          " placeholder="Lymphadenopathy" disabled />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-4">
                                      <div class="form-group">
                                        <label>JVP</label>
                                        <input type="text" class="form-control" v-model="examination_data.jvp"
                                          placeholder="JVP" disabled/>
                                      </div>
                                    </div>
                                    <div class="col-4">
                                      <div class="form-group">
                                        <label>Examination Of Breast</label>
                                        <input type="text" class="form-control" v-model="examination_data.examination_of_breast
                                          " placeholder="Examination Of Breast" disabled />
                                        <label class="mt-2">(If applicable)</label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="card">
                              <div class="card-header" id="faqhead72" style="margin-top:15px;">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                  data-target="#faq72" aria-expanded="true" aria-controls="faq72">Sensorium GCS</a>
                              </div>
  
                              <div id="faq72" class="collapse" aria-labelledby="faqhead2" data-parent="#faq70">
                                <div class="card-body">
                                  <div class="row">
                                    <div class="col-6 col-md-3">
                                      <div class="form-group">
                                        <label>Eye Opening (E)</label>
                                        <v-select class="mr-2" v-model="examination_data.eye_opening"
                                          placeholder="Select Eye Opening" :options="eye_opening"
                                          disabled>
                                        </v-select>
                                      </div>
                                    </div>
                                    <div class="col-6 col-md-3">
                                      <div class="form-group">
                                        <label>Verbal Response (V)</label>
                                        <v-select class="mr-2" v-model="examination_data.verbal_response
                                          " placeholder="Select Verbal Response" :options="verbal_response"
                                          disabled>
                                        </v-select>
                                      </div>
                                    </div>
                                    <div class="col-6 col-md-3">
                                      <div class="form-group">
                                        <label>Motar Response (M)</label>
                                        <v-select class="mr-2" name="Motar Response" v-model="examination_data.motor_response
                                          " label="Motar Response" placeholder="Select Motar Response"
                                          :options="motar_response" disabled>
                                        </v-select>
                                      </div>
                                    </div>
                                    <div class="col-6 col-md-3">
                                      <div class="form-group">
                                        <label>Score</label>
                                        <input type="number" class="form-control" disabled v-model="subtotal"
                                          placeholder="Score"/>
                                        <label class="mt-2">Out Of 15</label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="card">
                              <div class="card-header" id="faqhead73" style="margin-top:15px;">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                  data-target="#faq73" aria-expanded="true" aria-controls="faq73">System</a>
                              </div>
  
                              <div id="faq73" class="collapse" aria-labelledby="faqhead73" data-parent="#faq70">
                                <div class="card-body">
                                  <div class="row">
                                    <div class="col">
                                      <div class="form-group">
                                        <label>Cardiovascular System</label>
                                        <v-select class="mr-2" v-model="examination_data.cardiovascular_system
                                          " placeholder="Select Cardiovascular System" :options="cardiovascular_system"
                                          disabled>
                                        </v-select>
                                      </div>
                                    </div>
                                    <div class="col">
                                      <div class="form-group">
                                        <label>Central Nervous System</label>
                                        <v-select class="mr-2" v-model="examination_data.central_nervous_system
                                          " placeholder="Select Central Nervous System" :options="central_nervous_system"
                                          disabled>
                                        </v-select>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col">
                                      <div class="form-group">
                                        <label>Adbomen (P/A)</label>
                                        <v-select class="mr-2" v-model="examination_data.abdomen"
                                          placeholder="Select Adbomen" :options="adbomen" disabled>
                                        </v-select>
                                      </div>
                                    </div>
                                    <div class="col">
                                      <div class="form-group">
                                        <label>Respiratory System</label>
                                        <v-select class="mr-2" v-model="examination_data.respiratory_system
                                          " placeholder="Select Respiratory System" :options="respiratory_system"
                                          disabled>
                                        </v-select>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col offset-md-6">
                                      <div class="form-group">
                                        <label>Local Examination</label>
                                        <input type="text" class="form-control" v-model="examination_data.local_examination
                                          " placeholder="Local Examination" disabled/>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="text-left mt-5">
                                <a v-if="currentPath == 'new-patient-encounter'" class="btn btn-primary btn-sm" tabindex="0"
                                  @click="
                                    add_patient_encounter_new('Examinations')
                                    " disabled>Save Changes</a>
                                <a v-if="currentPath ==
                                  'update-patient-encounter-update' &&
                                  !closedAppointment
                                  " class="btn btn-primary btn-sm" tabindex="0"
                                  @click="update_patient_encounter('Examinations')" disabled>Update
                                  Changes</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Examinations Content End -->
  
                    <!-- Assessment Content Start-->
  
                    <div v-if="active == 'Assessment'" class="mt-2">
                      <div id="main">
                        <div class="container">
                          <div class="row">
                            <div class="col-sm-8">
                              <div class="row">
                                <div>
                                  <label for="xray_diagnosis_left " class="form-text-label kx-label-primary"><strong> Xray
                                      Diagnosis </strong></label>
                                  <div class="row">
                                    <div class="col-sm-6">
                                      <label for="xray_diagnosis_left" class="form-text-label kx-label-secondary">
                                        Diagnosis Left
                                      </label>
  
                                      <v-select class="mr-2" required=""
                                        v-model="pain_analysis_data.knee_xray_diagnosis_left"
                                        placeholder="Xray Diagnosis Left" :options="knee_xray_diagnosis"
                                        disabled>
                                      </v-select>
  
                                      <label for="xray_diagnosis_right" class="form-text-label kx-label-secondary">Diagnosis
                                        Right
                                      </label>
  
                                      <v-select class="mr-2" required=""
                                        v-model="pain_analysis_data.knee_xray_diagnosis_right"
                                        placeholder="Xray Diagnosis Right" :options="knee_xray_diagnosis"
                                        disabled>
                                      </v-select>
                                    </div>
                                    <div class="col-sm-6">
                                      <label for="deformity_left" class="form-text-label kx-label-secondary">
                                        Deformity Left</label>
                                      <v-select class="mr-2" required="" v-model="pain_analysis_data.deformity_left"
                                        placeholder="Xray Deformity Left" :options="knee_xray_deformity"
                                        disabled>
                                      </v-select>
                                      <label for="deformity_right" class="form-text-label kx-label-secondary">
                                        Deformity Right</label>
                                      <v-select class="mr-2" required="" v-model="pain_analysis_data.deformity_right"
                                        placeholder="Xray Deformity Right" :options="knee_xray_deformity"
                                        disabled>
                                      </v-select>
                                    </div>
                                    <div class="col-sm-12">
                                      <div class="form-group">
                                        <label for="xray_diagnosis_remarks" class="form-text-label kx-label-secondary">Xray
                                          Remark</label>
                                        <textarea class="form-control" id="xray_diagnosis_remarks"
                                          v-model="pain_analysis_data.xray_diagnosis_remarks" rows="3" placeholder="Remarks"
                                          disabled></textarea>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="mt-5">
                                  <label for="xray_diagnosis_left" class="form-text-label kx-label-primary">
                                    <strong>MRI Diagnosis </strong>
                                  </label>
                                  <div class="row">
                                    <div class="col-sm-6">
                                      <label for="xray_diagnosis_left" class="form-text-label kx-label-secondary">Diagnosis
                                        Left
                                      </label>
                                      <v-select class="mr-2" required="" v-model="pain_analysis_data.mri_diagnosis_left"
                                        placeholder="Mri Diagnosis Left" :options="mri_diagnosis"
                                        disabled>
                                      </v-select>
                                    </div>
                                    <div class="col-sm-6">
                                      <label for="xray_diagnosis_right" class="form-text-label kx-label-secondary">
                                        Diagnosis Right
                                      </label>
                                      <v-select class="mr-2" required="" v-model="pain_analysis_data.mri_diagnosis_right"
                                        placeholder="Mri Diagnosis Right" :options="mri_diagnosis"
                                        disabled>
                                      </v-select>
                                    </div>
                                    <div class="col-sm-12">
                                      <div class="form-group">
                                        <label for="mri_remark" class="form-text-label kx-label-secondary">MRI
                                          Remark</label>
                                        <textarea class="form-control" id="mri_assessment_remarks"
                                          v-model="pain_analysis_data.mri_assessment_remarks" rows="3" placeholder="Remarks"
                                          disabled></textarea>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-4">
                              <table class="table table-bordered text-center">
                                <thead>
                                  <tr>
                                    <th scope="col">Surgery</th>
                                    <th scope="col">Right</th>
                                    <th scope="col">Left</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <th scope="row">SVF</th>
                                    <td>
                                      <div>
                                        <input class="form-check-input" type="checkbox" value=""
                                          v-model="pain_analysis_data.svf_right" true-value="1" false-value="0"
                                          id="svf_right" disabled/>
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        <input class="form-check-input" type="checkbox" value=""
                                          v-model="pain_analysis_data.svf_left" true-value="1" false-value="0" id="svf_left"
                                          disabled/>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row">PFO</th>
                                    <td>
                                      <div>
                                        <input class="form-check-input" type="checkbox" value=""
                                          v-model="pain_analysis_data.pfo_right" true-value="1" false-value="0"
                                          id="pfo_right" disabled />
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        <input class="form-check-input" type="checkbox" value=""
                                          v-model="pain_analysis_data.pfo_left" true-value="1" false-value="0" id="pfo_left"
                                          disabled />
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row">HTO</th>
                                    <td>
                                      <div>
                                        <input class="form-check-input" type="checkbox" value=""
                                          v-model="pain_analysis_data.hto_right" true-value="1" false-value="0"
                                          id="hto_right" disabled />
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        <input class="form-check-input" type="checkbox" value=""
                                          v-model="pain_analysis_data.hto_left" true-value="1" false-value="0" id="hto_left"
                                          disabled/>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row">DFO</th>
                                    <td>
                                      <div>
                                        <input class="form-check-input" type="checkbox" value=""
                                          v-model="pain_analysis_data.dfo_right" true-value="1" false-value="0"
                                          id="dfo_right" disabled/>
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        <input class="form-check-input" type="checkbox" value=""
                                          v-model="pain_analysis_data.dfo_left" true-value="1" false-value="0" id="dfo_left"
                                          disabled />
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Arthroscopy</th>
                                    <td>
                                      <div>
                                        <input class="form-check-input" type="checkbox" value=""
                                          v-model="pain_analysis_data.arthoscopy_right" true-value="1" false-value="0"
                                          id="arthoscopy_right" disabled />
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        <input class="form-check-input" type="checkbox" value=""
                                          v-model="pain_analysis_data.arthroscopy_left" true-value="1" false-value="0"
                                          id="arthroscopy_left" disabled/>
                                      </div>
                                    </td>
                                  </tr>
                                  <!-- <tr>
                                    <th scope="row" v-if="knee_complain == '1'">TKR</th>
                                    <td v-if="knee_complain == '1'">
                                      <div>
                                        <input class="form-check-input" type="checkbox" value=""
                                          v-model="xray_advise_tkr_right" true-value="1" false-value="0"
                                          id="xray_advise_tkr_right" />
                                      </div>
                                    </td>
                                    <td v-if="knee_complain == '1'">
                                      <div>
                                        <input class="form-check-input" type="checkbox" value="" 
                                         v-model="xray_advise_tkr_left" true-value="1" false-value="0"
                                          id="xray_advise_tkr_left" />
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row" v-if="hip_complain == '1'">THR</th>
                                    <td v-if="hip_complain == '1'">
                                      <div>
                                        <input class="form-check-input" type="checkbox" value="" @change="
                                          update_field(
                                            'Knee Lead',
                                            name,
                                            'xray_advise_thr_right',
                                            xray_advise_thr_right
                                          )
                                          " v-model="xray_advise_thr_right" true-value="1" false-value="0"
                                          id="xray_advise_thr_right" />
                                      </div>
                                    </td>
                                    <td v-if="hip_complain == '1'">
                                      <div>
                                        <input class="form-check-input" type="checkbox" value="" @change="
                                          update_field(
                                            'Knee Lead',
                                            name,
                                            'xray_advise_thr_left',
                                            xray_advise_thr_left
                                          )
                                          " v-model="xray_advise_thr_left" true-value="1" false-value="0"
                                          id="xray_advise_thr_left" />
                                      </div>
                                    </td>
                                  </tr> -->
                                </tbody>
                              </table>
  
                            </div>
                          </div>
                          <div class="text-right mt-5">
                            <a class="btn btn-primary mb-3" tabindex="0" @click="
                              update_patient_encounter(
                                'assessment'
                              )
                              " :disabled="doc_status === 1">Update Changes</a>
                          </div>
                        </div>
                      </div>
                    </div>
  
                    <!-- Assessment Content End-->
  
                    <!-- Joint Assessment start -->
  
                    <div id="main" class="mt-2">
                      <div v-if="active == 'Joint Assessment'" class="Diagnosis mt-4">
                        <div class="modal-body doctor-profile">
                          <div class="card">
                            <div class="card-body">
                              <!-- <div class="row">
                                <div class="col-sm">
                                  <div class="col-md-12" xs="12">
                                    <div class="form-group custom-dropdown">
                                      <label>Pain Scale </label>
                                      <v-select
                                        class="mr-2"
                                        v-model="joint_data.pain_scale"
                                        placeholder="Select Pain Scale"
                                        :options="pain_scales"
                                      >
                                      </v-select>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-sm">
                                  <div class="" xs="12">
                                    <div>
                                      <br />
                                      <br />
                                      <input
                                        type="checkbox"
                                        id="Neurological"
                                        name="Neurological"
                                        :checked="
                                          joint_assessment.neurological_assessment
                                        "
                                        @change="check($event, 'Neurological')"
                                      />
                                      <label for="Neurological">
                                        Neurological Assessment
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-sm">
                                  <div class="" xs="12">
                                    <div>
                                      <br />
                                      <br />
                                      <input
                                        type="checkbox"
                                        id="Muscle Power"
                                        name="Muscle Power"
                                        :checked="
                                          joint_assessment.muscle_power_and_tone_assessment
                                        "
                                        @change="
                                          check(
                                            $event,
                                            'muscle_power_and_tone_assessment'
                                          )
                                        "
                                      />
                                      <label for="Muscle Power">
                                        Muscle Power and Tone Assessment
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div> -->
                              <div id="main">
                                <div class="container">
                                  <div class="accordion" id="faq50">
                                    <div class="card" v-if="joint_data.knee_location">
                                      <div class="card-header" id="faqhead51">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                          data-target="#faq51" aria-expanded="true" aria-controls="faq51">Knee
                                          Assessment</a>
                                      </div>
                                      <div id="faq51" class="collapse" aria-labelledby="faqhead51" data-parent="#faq50">
                                        <div class="row mt-3">
                                          <div class="col-12 col-md-4 offset-4">
                                            <label>Right Knee</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Left Knee</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Deformity</label>
                                          </div>
                                          <div class="col-12 col-md-4 mb-4">
                                            <v-select class="mr-2" required="" v-model="knee_assessment_right.deformity
                                              " placeholder="Select Deformity" :options="all_deformity">
                                            </v-select>
                                          </div>
                                          <div class="col-12 col-md-4 mb-4">
                                            <v-select class="mr-2" required="" v-model="knee_assessment_left.deformity
                                              " placeholder="Select Deformity" :options="all_deformity">
                                            </v-select>
                                          </div>
  
                                          <div class="col-12 col-md-4">
                                            <label>Laxity Status</label>
                                            <p>(By Physical Examination)</p>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <v-select class="mr-2" required="" v-model="knee_assessment_right.laxity_status_examination
                                              " placeholder="Select Laxity Status" :options="all_knee_laxity">
                                            </v-select>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <v-select class="mr-2" required="" v-model="knee_assessment_left.laxity_status_examination
                                              " placeholder="Select Laxity Status" :options="all_knee_laxity">
                                            </v-select>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Laxity </label>
                                            <p>(By Lachmeter)</p>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="knee_assessment_right.laxity_by_lachmeter
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="knee_assessment_left.laxity_by_lachmeter
                                              " />
                                          </div>
                                          <!-- <div class="col-12 col-md-4">
                                            <label>Joint Space Measurement</label>
                                            <p>(By Verniar Calipers)</p>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="knee_assessment_right.measurement_by_verniar_calipers
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="knee_assessment_left.measurement_by_verniar_calipers
                                              " />
                                          </div> -->
  
                                          <div class="col-12 col-md-4">
                                            <label>Effusion</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="checkbox" id="Effusion" name="Effusion" :checked="knee_assessment_right.effusion
                                              " @change="check($event, 'knee_assessment_right_effusion')" />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="checkbox" id="Effusion" name="Effusion" :checked="knee_assessment_left.effusion
                                              " @change="check($event, 'knee_assessment_left_effusion')" />
                                          </div>
                                          <div class="col-12 col-md-4 mb-3">
                                            <label>Tenderness Status</label>
                                          </div>
                                          <div class="col-12 col-md-4 mb-3">
                                            <v-select class="mr-2" required="" v-model="knee_assessment_right.tenderness_status
                                              " placeholder="Select Tenderness Status" :options="all_knee_tenderness">
                                            </v-select>
                                          </div>
                                          <div class="col-12 col-md-4 mb-3">
                                            <v-select class="mr-2" required="" v-model="knee_assessment_left.tenderness_status
                                              " placeholder="Select Tenderness Status" :options="all_knee_tenderness">
                                            </v-select>
                                          </div>
                                          <!-- <div class="col-12 col-md-4">
                                            <label>Muscle Girth </label>
                                            <p>(4 Inches Above Joint Line)</p>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="knee_assessment_right.muscle_girth_4_inches_above_joint_line
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="knee_assessment_left.muscle_girth_4_inches_above_joint_line
                                              " />
                                          </div> -->
                                          <div class="col-12 col-md-4">
                                            <label>Range of Motion</label>
                                          </div>
  
                                          <div class="col-12 col-md-4">
                                            <v-select class="mr-2" required="" v-model="knee_assessment_right.range_of_motion
                                              " placeholder="Select Range of Motion" :options="all_range_motion">
                                            </v-select>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <v-select class="mr-2" required="" v-model="knee_assessment_left.range_of_motion
                                              " placeholder="Select Range of Motion" :options="all_range_motion">
                                            </v-select>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Muscle Girth </label>
                                            <p>(4 Inches Below Joint Line)</p>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="knee_assessment_right.muscle_girth_4_inches_below_joint_line
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="knee_assessment_left.muscle_girth_4_inches_below_joint_line
                                              " />
                                          </div>
                                          <div class="col-12 col-md-12">
                                            <b class="clinical_bold mt-3">Clinical Assessment Tool</b>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <label>Visual Analog Scale</label>
                                            <p>
                                              (Visual Analog Scale (VAS) 0-10)
                                            </p>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="knee_assessment_right.visual_analog_scale
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="knee_assessment_left.visual_analog_scale
                                              " />
                                          </div>
                                          <!-- <div class="col-12 col-md-4">
                                            <label>Extension Deformity</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="knee_assessment_right.extension_deformity
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="knee_assessment_left.extension_deformity
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Medial Rotation</label>
                                            <p>
                                              (Knee Left Medial Rotation : 0-25A)
                                            </p>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="knee_assessment_right.medial_rotation
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="knee_assessment_left.medial_rotation
                                              " />
                                          </div> -->
                                          <div class="col-12 col-md-4">
                                            <label>Flexion Deformity</label>
                                            <p>(Knee Left Flexion : 0-130A)</p>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="knee_assessment_right.flexion_deformity
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="knee_assessment_left.flexion_deformity
                                              " />
                                          </div>
                                          <!-- <div class="col-12 col-md-4">
                                            <label>Lateral Rotation</label>
                                            <p>
                                              (Knee Left Lateral Rotation : 0-45A)
                                            </p>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="knee_assessment_right.lateral_rotation
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="knee_assessment_left.lateral_rotation
                                              " />
                                          </div> -->
                                          <div class="col-12 col-md-12">
                                            <b class="clinical_bold mt-3">Range of Motion</b>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <label>Extension</label>
                                            <p>(Knee Left Extension : 0-120A)</p>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="checkbox" id="Extension" name="Extension" :checked="knee_assessment_right.extension
                                              " @change="check($event, 'knee_assessment_right_extension')" />
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="checkbox" id="Extension" name="Extension" :checked="knee_assessment_left.extension
                                              " @change="check($event, 'knee_assessment_left_extension')" />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Flexion</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="knee_assessment_right.flexion
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="knee_assessment_left.flexion
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <label>Osteophytes</label>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="checkbox" id="osteophytes" name="osteophytes" :checked="knee_assessment_right.osteophytes
                                              " @change="check($event, 'knee_assessment_right_osteophytes')" />
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="checkbox" id="osteophytes" name="osteophytes" :checked="knee_assessment_left.osteophytes
                                              " @change="check($event, 'knee_assessment_left_osteophytes')" />
                                          </div>
  
                                          <div class="col-12 col-md-4 mt-3">
                                            <label>Loose Body</label>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="checkbox" id="loose_body" name="loose_body" :checked="knee_assessment_right.loose_body
                                              " @change="check($event, 'knee_assessment_right_loose_body')" />
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="checkbox" id="loose_body" name="loose_body" :checked="knee_assessment_left.loose_body
                                              " @change="check($event, 'knee_assessment_left_loose_body')" />
                                          </div>
  
                                          <div class="col-12 col-md-4 mt-3">
                                            <label>KOOS Score</label>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="knee_assessment_right.koos_score
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="knee_assessment_left.koos_score
                                              " />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
  
                                    <div class="card" v-if="joint_data.hip_location">
                                      <div class="card-header" id="faqhead52">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                          data-target="#faq52" aria-expanded="true" aria-controls="faq52">Hip Assessment</a>
                                      </div>
  
                                      <div id="faq52" class="collapse" aria-labelledby="faqhead52" data-parent="#faq50">
                                        <div class="row mt-3">
                                          <div class="col-12 col-md-4 offset-4">
                                            <label>Right Hip</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Left Hip</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Visual Analog Scale</label>
                                            <p>
                                              (Visual Analog Scale (VAS) 0-10)
                                            </p>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="hip_assessment_right.visual_analog_scale
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="hip_assessment_left.visual_analog_scale
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Abduction</label>
                                            <p>(Abduction : 0-45A)</p>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="hip_assessment_right.abduction
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="hip_assessment_left.abduction
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Extension</label>
                                            <p>(Knee Left Extension : 0-120A)</p>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="checkbox" id="Effusion" name="Effusion" :checked="hip_assessment_right.extension
                                              " @change="check($event, 'hip_assessment_right_extension')" />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="checkbox" id="Effusion" name="Effusion" :checked="hip_assessment_left.extension
                                              " @change="check($event, 'hip_assessment_left_extension')" />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Flexion</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="hip_assessment_right.flexion
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="hip_assessment_left.flexion
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Adduction</label>
                                            <p>(Adduction : 0-30A)</p>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="hip_assessment_right.adduction
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="hip_assessment_left.adduction
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Range of Motion</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <v-select class="mr-2" required="" v-model="hip_assessment_right.range_of_motion
                                              " placeholder="Select Range of Motion" :options="all_range_motion">
                                            </v-select>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <v-select class="mr-2" required="" v-model="hip_assessment_left.range_of_motion
                                              " placeholder="Select Range of Motion" :options="all_range_motion">
                                            </v-select>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Hip WOMAC</label>
                                            <p>(WOMAC : 0-138)</p>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="hip_assessment_right.hip_womac
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="hip_assessment_left.hip_womac
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Medial Rotation</label>
                                            <p>
                                              (Knee Left Medial Rotation : 0-25A)
                                            </p>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="hip_assessment_right.medial_rotation
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="hip_assessment_left.medial_rotation
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>HOOS</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="hip_assessment_right.hip_hoos
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="hip_assessment_left.hip_hoos
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <label>Extension Deformity</label>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="hip_assessment_right.extension_deformity
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="hip_assessment_left.extension_deformity
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <label>HOOS Junior</label>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="hip_assessment_right.hip_hoos_junior
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="hip_assessment_left.hip_hoos_junior
                                              " />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
  
                                    <div class="card" v-if="joint_data.ankle_location">
                                      <div class="card-header" id="faqhead53">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                          data-target="#faq53" aria-expanded="true" aria-controls="faq53">Ankle
                                          Assessment</a>
                                      </div>
  
                                      <div id="faq53" class="collapse" aria-labelledby="faqhead53" data-parent="#faq50">
                                        <div class="row mt-3">
                                          <div class="col-12 col-md-4 offset-4">
                                            <label>Right Ankle</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Left Ankle</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Visual Analog Scale</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="ankle_assessment_right.visual_analog_scale
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="ankle_assessment_left.visual_analog_scale
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Ankle Eversion</label>
                                            <p>(Eversion : 0-15A)</p>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="ankle_assessment_right.ankle_eversion
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="ankle_assessment_left.ankle_eversion
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Dorsiflexion</label>
                                            <p>(Dorsiflexion : 0-20A)</p>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="ankle_assessment_right.dorsiflexion
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="ankle_assessment_left.dorsiflexion
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Ankle Inversion</label>
                                            <p>(Inversion : 0-35A)</p>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="ankle_assessment_right.ankle_inversion
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="ankle_assessment_left.ankle_inversion
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Foot And Ankle ability Measure
                                              (FAAM)</label>
                                            <p>(FAAM (0-4))</p>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="ankle_assessment_right.faam
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value=""
                                              v-model="ankle_assessment_left.faam" />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Plantarflexion</label>
                                            <p>(Plantarflexion : 0-50A)</p>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="ankle_assessment_right.plantarflexion
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="ankle_assessment_left.plantarflexion
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Munich Ankle Questionnaire
                                              (MAQ)</label>
                                            <p>(MAQ (0-100))</p>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value=""
                                              v-model="ankle_assessment_right.maq" />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value=""
                                              v-model="ankle_assessment_left.maq" />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
  
                                    <div class="card" v-if="joint_data.shoulder_location">
                                      <div class="card-header" id="faqhead54">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                          data-target="#faq54" aria-expanded="true" aria-controls="faq54">Shoulder
                                          Assessment</a>
                                      </div>
  
                                      <div id="faq54" class="collapse" aria-labelledby="faqhead54" data-parent="#faq50">
                                        <div class="row mt-3">
                                          <div class="col-12 col-md-4 offset-4">
                                            <label>Right Shoulder</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Left Shoulder</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Visual Analog Scale</label>
                                            <p>
                                              (Visual Analog Scale (VAS) 0-10)
                                            </p>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="shoulder_assessment_right.visual_analog_scale
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="shoulder_assessment_left.visual_analog_scale
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>External Rotation</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="shoulder_assessment_right.external_rotation
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="shoulder_assessment_left.external_rotation
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Extension</label>
                                            <p>(Knee Left Extension : 0-120A)</p>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="checkbox" id="Extension" name="Extension" :checked="shoulder_assessment_right.extension
                                              " @change="check($event, 'shoulder_assessment_right_extension')" />
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="checkbox" id="Extension" name="Extension" :checked="shoulder_assessment_left.extension
                                              " @change="check($event, 'shoulder_assessment_left_extension')" />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Flexion</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="shoulder_assessment_right.flexion
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="shoulder_assessment_left.flexion
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Internal Rotation</label>
                                            <p>(Internal Rotation : 0-90A)</p>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="shoulder_assessment_right.internal_rotation
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="shoulder_assessment_left.internal_rotation
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Abduction</label>
                                            <p>(Abduction : 0-45A)</p>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="shoulder_assessment_right.abduction
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="shoulder_assessment_left.abduction
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Shoulder Pain & Disability Index
                                              (SPADI)</label>
                                            <p>(SPADI : 0-130)</p>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="shoulder_assessment_right.pain_disability_index
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="shoulder_assessment_left.pain_disability_index
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Adduction</label>
                                            <p>(Adduction : 0-30A)</p>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="shoulder_assessment_right.adduction
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="shoulder_assessment_left.adduction
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>HOOS</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="shoulder_assessment_right.shoulder_hoos
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="shoulder_assessment_left.shoulder_hoos
                                              " />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
  
                                    <div class="card" v-if="joint_data.cervical_spine">
                                      <div class="card-header" id="faqhead55">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                          data-target="#faq55" aria-expanded="true" aria-controls="faq55">Cervical Spine
                                          Assessment</a>
                                      </div>
  
                                      <div id="faq55" class="collapse" aria-labelledby="faqhead55" data-parent="#faq50">
                                        <div class="row mt-3">
                                          <div class="col-md-12">
                                            <div class="row form-row">
                                              <div class="col-12 col-md-6">
                                                <div class="form-group">
                                                  <label>Visual Analog Scale</label>
                                                  <input type="text" class="form-control" value="" v-model="cervical_spine_assessment.visual_analog_scale
                                                    " />
                                                  <p>
                                                    Visual Analog Scale (VAS) 0-10
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-12 col-md-6">
                                                <div class="form-group">
                                                  <label>Rotation</label>
                                                  <input type="text" class="form-control" value="" v-model="cervical_spine_assessment.rotation
                                                    " />
                                                  <p>Rotation : 0-30A</p>
                                                </div>
                                              </div>
                                              <div class="col-12 col-md-6">
                                                <div>
                                                  <input type="checkbox" id="Effusion" name="Effusion" :checked="cervical_spine_assessment.extension
                                                    " @change="check($event, 'cervical_spine_assessment_extension')" />
                                                  <label for="Extension">
                                                    Extension
                                                  </label>
                                                </div>
  
                                                <div class="form-group">
                                                  <label>Knee Left Extension :
                                                    0-120A</label>
                                                  <div>
                                                    <label>Flexion</label>
                                                  </div>
                                                  <input type="text" class="form-control" value="" v-model="cervical_spine_assessment.flexion
                                                    " />
                                                </div>
                                              </div>
                                              <div class="col-12 col-md-6">
                                                <div class="form-group">
                                                  <label>Neck Disability Index</label>
                                                  <input type="text" class="form-control" value="" v-model="cervical_spine_assessment.neck_disability_index
                                                    " />
                                                  <p>
                                                    Neck Disability Index : 0-130
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-12 col-md-6">
                                                <div class="form-group">
                                                  <label>Lateral Flexion</label>
                                                  <input type="text" class="form-control" value="" v-model="cervical_spine_assessment.lateral_flexion
                                                    " />
                                                  <p>
                                                    Left Side Lateral Flexion
                                                    0-25A
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-12 col-md-6">
                                                <div class="form-group">
                                                  <label>Bournemouth
                                                    Questionnaire</label>
                                                  <input type="text" class="form-control" value="" v-model="cervical_spine_assessment.bournemouth_questionnaire
                                                    " />
                                                  <p>
                                                    Bournemouth Questionnaire
                                                    (0-70)
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
  
                                    <div class="card" v-if="joint_data.lumbar_spine">
                                      <div class="card-header" id="faqhead56">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                          data-target="#faq56" aria-expanded="true" aria-controls="faq56">Lumar Spine
                                          Assessment</a>
                                      </div>
  
                                      <div id="faq56" class="collapse" aria-labelledby="faqhead56" data-parent="#faq50">
                                        <div class="row mt-3">
                                          <div class="col-md-12">
                                            <div class="row form-row">
                                              <div class="col-12 col-md-6">
                                                <div class="form-group">
                                                  <label>Visual Analog Scale</label>
                                                  <input type="text" class="form-control" value="" v-model="lumbar_spine_assessment.visual_analog_scale
                                                    " />
                                                  <p>
                                                    Visual Analog Scale (VAS) 0-10
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-12 col-md-6">
                                                <div class="form-group">
                                                  <label>Lumbar Spine Pain-Quebec
                                                    Disability Scale</label>
                                                  <input type="text" class="form-control" value="" v-model="lumbar_spine_assessment.quebec_disability_scale
                                                    " />
                                                  <p>
                                                    Back Pain-Quebec Disability
                                                    Scale (0-200)
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-12 col-md-6">
                                                <div>
                                                  <input type="checkbox" id="Effusion" name="Effusion" :checked="lumbar_spine_assessment.extension
                                                    " @change="check($event, 'lumbar_spine_assessment_extension')" />
                                                  <label for="Extension">
                                                    Extension
                                                  </label>
                                                </div>
  
                                                <div class="form-group">
                                                  <label>Knee Left Extension :
                                                    0-120A</label>
                                                  <div>
                                                    <label>Flexion</label>
                                                  </div>
                                                  <input type="text" class="form-control" value="" v-model="lumbar_spine_assessment.flexion
                                                    " />
                                                </div>
                                              </div>
                                              <div class="col-12 col-md-6">
                                                <div class="form-group">
                                                  <label>Lumar Spine Muscle
                                                    Power</label>
                                                  <input type="text" class="form-control" value="" v-model="lumbar_spine_assessment.lumbar_spine_muscle_power
                                                    " />
                                                  <p>Back Muscle Power (0-5)</p>
                                                </div>
                                              </div>
                                              <div class="col-12 col-md-6">
                                                <div class="form-group">
                                                  <label>Lateral Flexion</label>
                                                  <input type="text" class="form-control" value="" v-model="lumbar_spine_assessment.lateral_flexion
                                                    " />
                                                  <p>
                                                    Left Side Lateral Flexion
                                                    0-25A
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-12 col-md-6">
                                                <div class="form-group">
                                                  <label>Lumar Spine
                                                    Fingertip-to-floor(FTP)
                                                    Test</label>
                                                  <input type="text" class="form-control" value="" v-model="lumbar_spine_assessment.fingertip_to_floor
                                                    " />
                                                  <p>
                                                    Back Fingertip-to-Floo(FTP)
                                                    Test (0-3)
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-12 col-md-6">
                                                <div class="form-group">
                                                  <label>Rotation</label>
                                                  <input type="text" class="form-control" value="" v-model="lumbar_spine_assessment.rotation
                                                    " />
                                                  <p>Rotation : 0-30A</p>
                                                </div>
                                              </div>
                                              <div class="col-12 col-md-6">
                                                <div class="form-group">
                                                  <label>Lumar Spine Pain Functional
                                                    Scale</label>
                                                  <input type="text" class="form-control" value="" v-model="lumbar_spine_assessment.lumbar_spine_pain_functional_scale
                                                    " />
                                                  <p>
                                                    Back Pain Functional Scale :
                                                    0-60A
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-12 col-md-6">
                                                <div class="form-group">
                                                  <label>Lumbar Spine Lateral
                                                    Flexion</label>
                                                  <input type="text" class="form-control" value="" v-model="lumbar_spine_assessment.lumbar_spine_lateral_flexion
                                                    " />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
  
                                    <div class="card" v-if="joint_data.wrist_location">
                                      <div class="card-header" id="faqhead57">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                          data-target="#faq57" aria-expanded="true" aria-controls="faq57">Wrist
                                          Assessment</a>
                                      </div>
  
                                      <div id="faq57" class="collapse" aria-labelledby="faqhead57" data-parent="#faq50">
                                        <div class="row mt-3">
                                          <div class="col-12 col-md-4 offset-4">
                                            <label>Right Wrist</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Left Wrist</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Visual Analog Scale</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="wrist_assessment_right.visual_analog_scale
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="wrist_assessment_left.visual_analog_scale
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Wrist Ulner Deviation</label>
                                            <p>(Ulner Deviation : 0-30A)</p>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="wrist_assessment_right.ulner_deviation_0_to_30
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="wrist_assessment_left.ulner_deviation_0_to_30
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Range of Motion</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <v-select class="mr-2" required="" v-model="wrist_assessment_right.range_of_motion
                                              " placeholder="Select Range of Motion" :options="all_range_motion">
                                            </v-select>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <v-select class="mr-2" required="" v-model="wrist_assessment_left.range_of_motion
                                              " placeholder="Select Range of Motion" :options="all_range_motion">
                                            </v-select>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Wrist Radial Deviaton</label>
                                            <p>(Radial Deviaton : 0-20A)</p>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="wrist_assessment_right.radial_deviation_0_to_20
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="wrist_assessment_left.radial_deviation_0_to_20
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Wrist Dorsi Flexion</label>
                                            <p>(Dorsi Flexion: 0-60A)</p>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="wrist_assessment_right.dorsi_flexion_0_to_60
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="wrist_assessment_left.dorsi_flexion_0_to_60
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Disabilities of Arm,Shoulder and
                                              Hand (DASH)</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="wrist_assessment_right.disabilities_of_arm_shoulder_and_hand_dash
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="wrist_assessment_left.disabilities_of_arm_shoulder_and_hand_dash
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Wrist Palmer Flexion</label>
                                            <p>(Palmer Flexion : 0-60A)</p>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="wrist_assessment_right.palmer_flexion_0_to_60
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="wrist_assessment_left.palmer_flexion_0_to_60
                                              " />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
  
                                    <div class="card" v-if="joint_data.elbow_location">
                                      <div class="card-header" id="faqhead58">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                          data-target="#faq58" aria-expanded="true" aria-controls="faq58">Elbow
                                          Assessment</a>
                                      </div>
  
                                      <div id="faq58" class="collapse" aria-labelledby="faqhead58" data-parent="#faq50">
                                        <div class="row mt-3">
                                          <div class="col-12 col-md-4 offset-4">
                                            <label>Right Elbow</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Left Elbow</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Visual Analog Scale</label>
                                            <p>
                                              (Visual Analog Scale (VAS) 0-10)
                                            </p>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="elbow_assessment_right.visual_analog_scale
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="elbow_assessment_left.visual_analog_scale
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Extension</label>
                                            <p>(Knee Left Extension : 0-120A)</p>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="checkbox" id="Effusion" name="Effusion" :checked="elbow_assessment_right.extension
                                              " @change="check($event, 'elbow_assessment_right_extension')" />
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="checkbox" id="Effusion" name="Effusion" :checked="elbow_assessment_left.extension
                                              " @change="check($event, 'elbow_assessment_left_extension')" />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Flexion</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="elbow_assessment_right.flexion
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="elbow_assessment_left.flexion
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Disabilities of Arm, Shouder and
                                              Hand (DASH)</label>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="elbow_assessment_right.disabilities_of_arm_shoulder_and_hand_dash
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="elbow_assessment_left.disabilities_of_arm_shoulder_and_hand_dash
                                              " />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
  
                                    <div class="card" v-if="joint_data.foot_location">
                                      <div class="card-header" id="faqhead59">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                          data-target="#faq59" aria-expanded="true" aria-controls="faq59">Foot
                                          Assessment</a>
                                      </div>
  
                                      <div id="faq59" class="collapse" aria-labelledby="faqhead59" data-parent="#faq50">
                                        <div class="row mt-3">
                                          <div class="col-12 col-md-4 offset-4">
                                            <label>Right Foot</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Left Foot</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Visual Analog Scale</label>
                                            <p>
                                              (Visual Analog Scale (VAS) 0-10)
                                            </p>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="foot_assessment_right.visual_analog_scale
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="foot_assessment_left.visual_analog_scale
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Foot Function Index</label>
                                            <p>(Foot Index : 0-230)</p>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="foot_assessment_right.function_index
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <input type="text" class="form-control" value="" v-model="foot_assessment_left.function_index
                                              " />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
  
                                    <div class="card" v-if="joint_assessment.neurological_assessment
                                      ">
                                      <div class="card-header" id="faqhead61">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                          data-target="#faq61" aria-expanded="true" aria-controls="faq61">Neurological
                                          Assessment</a>
                                      </div>
  
                                      <div id="faq61" class="collapse" aria-labelledby="faqhead61" data-parent="#faq50">
                                        <div class="row mt-3">
                                          <div class="col-12 col-md-4 offset-4">
                                            <label>Right</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Left</label>
                                          </div>
                                          <div class="col-12 col-md-4 mt-2">
                                            <label>Neuro Condition Type</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <v-select class="mr-2" required="" v-model="neuro_conditions_assessment_right.neuro_condition_type
                                              " placeholder="Select Neuro Condition Type"
                                              :options="all_neuro_condition_type">
                                            </v-select>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <v-select class="mr-2" required="" v-model="neuro_conditions_assessment_left.neuro_condition_type
                                              " placeholder="Select Neuro Condition Type"
                                              :options="all_neuro_condition_type">
                                            </v-select>
                                          </div>
                                          <div class="col-12 col-md-4 mt-4">
                                            <label>Date</label>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <datepicker input-class="datepicker-here form-control digits" :format="format"
                                              v-model="neuro_conditions_assessment_right.date_of_assessment
                                                " @input="changedneuroRightDate()"></datepicker>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <datepicker input-class="datepicker-here form-control digits" :format="format"
                                              v-model="neuro_conditions_assessment_left.date_of_assessment
                                                " @input="changedneuroLeftDate()"></datepicker>
                                          </div>
                                          <div class="col-12 col-md-4 mt-4">
                                            <label>Period</label>
                                          </div>
  
                                          <div class="col-12 col-md-4 mt-3">
                                            <v-select class="mr-2" required="" v-model="neuro_conditions_assessment_right.period
                                              " placeholder="Select Period" :options="all_power">
                                            </v-select>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <v-select class="mr-2" required="" v-model="neuro_conditions_assessment_left.period
                                              " placeholder="Select Period" :options="all_power">
                                            </v-select>
                                          </div>
                                          <div class="col-12 col-md-4 mt-4">
                                            <label>Observation</label>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="neuro_conditions_assessment_right.observation
                                              " />
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <input type="text" class="form-control" value="" v-model="neuro_conditions_assessment_left.observation
                                              " />
                                          </div>
                                        </div>
                                        <div class="row form-row">
                                          <div class="col-12 col-md-12">
                                            <hr />
                                            <b>Neurological Reflexes Assessment</b>
                                          </div>
                                          <div class="col-12 col-md-6">
                                            <div class="form-group">
                                              <input type="checkbox" id="Deep Tendon" name="Deep Tendon" :checked="deep_tendon_reflexes_status
                                                " @change="check($event, 'deep_tendon_reflexes_status')" />
                                              <label for="Deep Tendon">
                                                Deep Tendon Reflexes Status
                                              </label>
                                            </div>
                                          </div>
                                          <div class="col-12 col-md-6">
                                            <div class="form-group">
                                              <input type="checkbox" id="Superfecial Cremastric"
                                                name="Superfecial Cremastric" :checked="superfecial_cremastric_reflexes_status
                                                  " @change="check($event, 'superfecial_cremastric_reflexes_status')" />
                                              <label for="Superfecial Cremastric">
                                                Superfecial Cremastric Reflexes
                                                Status
                                              </label>
                                            </div>
                                          </div>
                                          <div class="col-12 col-md-6">
                                            <div class="form-group">
                                              <input type="checkbox" id="Superfecial Abdominal" name="Superfecial Abdominal"
                                                :checked="superfecial_abdominal_reflexes_status
                                                  " @change="check($event, 'superfecial_abdominal_reflexes_status')" />
                                              <label for="Superfecial Abdominal">
                                                Superfecial Abdominal Reflexes
                                                Status
                                              </label>
                                            </div>
                                          </div>
                                          <div class="col-12 col-md-6">
                                            <div class="form-group">
                                              <input type="checkbox" id="Superfecial Extensor" name="Superfecial Extensor"
                                                :checked="superfecial_extensor_planter_reflexes_status
                                                  "
                                                @change="check($event, 'superfecial_extensor_planter_reflexes_status')" />
                                              <label for="Superfecial Extensor">
                                                Superfecial Extensor Reflexes
                                                Status
                                              </label>
                                            </div>
                                          </div>
                                          <div class="col-12 col-md-6">
                                            <div class="form-group">
                                              <input type="checkbox" id="Superfecial Flexor Planter"
                                                name="Superfecial Flexor Planter" :checked="superfecial_flexor_planter_reflexes_status
                                                  "
                                                @change="check($event, 'superfecial_flexor_planter_reflexes_status')" />
                                              <label for="Superfecial Flexor Planter">
                                                Superfecial Flexor Planter
                                                Reflexes Status
                                              </label>
                                            </div>
                                          </div>
  
                                          <div class="row mt-3 ml-0">
                                            <div class="col-12 col-md-12">
                                              <b>Neurological Reflexes Grading</b>
                                            </div>
                                            <div class="col-12 col-md-4 offset-4">
                                              <label>Right </label>
                                            </div>
                                            <div class="col-12 col-md-4">
                                              <label>Left </label>
                                            </div>
                                            <div class="col-12 col-md-4 mt-2">
                                              <label>Reflex</label>
                                            </div>
                                            <div class="col-12 col-md-4 custom-dropdown">
                                              <v-select class="mr-2" required="" v-model="neurological_reflexes_grading_right.reflex
                                                " placeholder="Select Reflex" :options="all_neuro_reflex">
                                              </v-select>
                                            </div>
                                            <div class="col-12 col-md-4 custom-dropdown">
                                              <v-select class="mr-2" required="" v-model="neurological_reflexes_grading_left.reflex
                                                " placeholder="Select Reflex" :options="all_neuro_reflex">
                                              </v-select>
                                            </div>
                                            <div class="col-12 col-md-4 mt-4">
                                              <label>Grading</label>
                                            </div>
                                            <div class="col-12 col-md-4 mt-3 custom-dropdown">
                                              <v-select class="mr-2" required="" v-model="neurological_reflexes_grading_right.grading
                                                " placeholder="Select Grading" :options="all_power">
                                              </v-select>
                                            </div>
                                            <div class="col-12 col-md-4 mt-3 custom-dropdown">
                                              <v-select class="mr-2" required="" v-model="neurological_reflexes_grading_left.grading
                                                " placeholder="Select Grading" :options="all_power">
                                              </v-select>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
  
                                    <div class="card" v-if="joint_assessment.muscle_power_and_tone_assessment
                                      ">
                                      <div class="card-header" id="faqhead60">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                          data-target="#faq60" aria-expanded="true" aria-controls="faq60">Muscle Power and
                                          Tone Assessment</a>
                                      </div>
  
                                      <div id="faq60" class="collapse" aria-labelledby="faqhead60" data-parent="#faq50">
                                        <div class="row mt-3">
                                          <div class="col-12 col-md-4 offset-4">
                                            <label>Right Muscle Power and Tone</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <label>Left Muscle Power and Tone</label>
                                          </div>
                                          <div class="col-12 col-md-4 mt-2">
                                            <label>Joint</label>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <v-select class="mr-2" name="name" required="" label="name" v-model="muscle_power_and_tone_right.joint
                                              " placeholder="Select Joint" :reduce="(option) => option.name"
                                              :options="all_joint">
                                            </v-select>
                                          </div>
                                          <div class="col-12 col-md-4">
                                            <v-select class="mr-2" name="name" required="" label="name" v-model="muscle_power_and_tone_left.joint
                                              " placeholder="Select Joint" :reduce="(option) => option.name"
                                              :options="all_joint">
                                            </v-select>
                                          </div>
                                          <!-- <div class="col-12 col-md-4 mt-4">
                                  <label>Location</label>
                                </div>
                                <div class="col-12 col-md-4 mt-3">
                                  <v-select
                                    class="mr-2"
                                    required=""
                                    placeholder="Select Location"
                                    :options="all_muscle_location"
                                  >
                                  </v-select>
                                </div>
                                <div class="col-12 col-md-4 mt-3">
                                  <v-select
                                    class="mr-2"
                                    required=""
                                    placeholder="Select Location"
                                    :options="all_muscle_location"
                                  >
                                  </v-select>
                                </div> -->
                                          <div class="col-12 col-md-4 mt-4">
                                            <label>Muscle</label>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <v-select class="mr-2" name="muscle" required="" label="muscle" v-model="muscle_power_and_tone_right.muscle
                                              " placeholder="Select Muscle" :reduce="(option) => option.muscle"
                                              :options="all_muscle">
                                            </v-select>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3">
                                            <v-select class="mr-2" name="muscle" required="" label="muscle"
                                              placeholder="Select Muscle" v-model="muscle_power_and_tone_left.muscle
                                                " :reduce="(option) => option.muscle" :options="all_muscle">
                                            </v-select>
                                          </div>
                                          <div class="col-12 col-md-4 mt-4">
                                            <label>Tone</label>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3 custom-dropdown">
                                            <v-select class="mr-2" required="" v-model="muscle_power_and_tone_right.tone
                                              " placeholder="Select Tone" :options="all_muscle_tone">
                                            </v-select>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3 custom-dropdown">
                                            <v-select class="mr-2" required="" v-model="muscle_power_and_tone_left.tone
                                              " placeholder="Select Tone" :options="all_muscle_tone">
                                            </v-select>
                                          </div>
                                          <div class="col-12 col-md-4 mt-4">
                                            <label>Power</label>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3 custom-dropdown">
                                            <v-select class="mr-2" required="" v-model="muscle_power_and_tone_right.power
                                              " placeholder="Select Power" :options="all_power">
                                            </v-select>
                                          </div>
                                          <div class="col-12 col-md-4 mt-3 custom-dropdown">
                                            <v-select class="mr-2" required="" v-model="muscle_power_and_tone_left.power
                                              " placeholder="Select Power" :options="all_power">
                                            </v-select>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
  
                                    <div class="card">
                                      <div class="card-header" id="faqhead62">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                          data-target="#faq62" aria-expanded="true" aria-controls="faq62">Observation and
                                          Remark</a>
                                      </div>
  
                                      <div id="faq62" class="collapse" aria-labelledby="faqhead62" data-parent="#faq50">
                                        <div class="row mt-3">
                                          <div class="card-body">
                                            <ckeditor :editor="editor" v-model="observation_and_remarks"></ckeditor>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
  
                              <div class="submit-section" style="text-align: right">
                                <button @click="add_joint_assessment()" class="btn btn-primary submit-btn"
                                  data-dismiss="modal" aria-label="Close" v-if="joint_assessment_id === null">
                                  Save
                                </button>
                                <button @click="update_joint_assessment()" class="btn btn-primary submit-btn"
                                  data-dismiss="modal" aria-label="Close" v-if="joint_assessment_id !== null">
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
  
                        <!-- test -->
                      </div>
                    </div>
  
                    <!-- Joint Assessment end -->
  
                    <!-- Joints Content Start-->
                    <div v-if="active == 'Joints'" class="Diagnosis mt-2">
                      <div id="main" class="mt-3">
                        <div class="container">
                          <div class="accordion" id="faq100">
                            <div class="card">
                              <div class="card-header" id="faqhead101">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                  data-target="#faq101" aria-expanded="true" aria-controls="faq101">Joint Pain Analysis</a>
                              </div>
  
                              <div id="faq101" class="collapse" aria-labelledby="faqhead101" data-parent="#faq100">
                                <div class="card-body doctor-profile">
                                  <div class="experience-info" v-for="(item, index) in pain_analysis" :key="index">
                                    <div class="row form-row experience-cont">
                                      <div class="col-12 col-md-10 col-lg-11">
                                        <div class="row form-row">
                                          <div class="col-12 col-md-6 col-lg-3">
                                            <div class="form-group">
                                              <label>Joint </label>
                                              <input type="text" class="form-control" value="" disabled v-model="item.joint"
                                                placeholder="Joint" />
                                            </div>
                                          </div>
                                          <div class="col-12 col-md-6 col-lg-3">
                                            <div class="form-group">
                                              <label>Location </label>
                                              <v-select class="mr-2" disabled name="Location" required="" label="Location"
                                                v-model="item.location" placeholder="Select Location"
                                                :options="knee_locations">
                                              </v-select>
                                            </div>
                                          </div>
  
                                          <div class="col-12 col-md-6 col-lg-3">
                                            <div class="form-group">
                                              <label>Intensity </label>
                                              <v-select class="mr-2" required="" v-model="item.intensity"
                                                placeholder="Select Pain Intensity" :options="pain_intensity">
                                              </v-select>
                                            </div>
                                          </div>
  
                                          <div class="col-12 col-md-6 col-lg-3">
                                            <div class="form-group">
                                              <label>Nature </label>
                                              <v-select class="mr-2" required="" v-model="item.nature"
                                                placeholder="Select Pain Nature" :options="pain_nature">
                                              </v-select>
                                            </div>
                                          </div>
  
                                          <div class="col-12 col-md-6 col-lg-3">
                                            <div class="form-group">
                                              <label>Period </label>
                                              <input type="text" class="form-control" value="" v-model="item.period"
                                                placeholder="Period" />
                                            </div>
                                          </div>
  
                                          <div class="col-12 col-md-6 col-lg-3">
                                            <div class="form-group">
                                              <label>Since </label>
                                              <v-select class="mr-2" required="" v-model="item.pain_since"
                                                placeholder="Select Pain Since" :options="pain_since">
                                              </v-select>
                                            </div>
                                          </div>
  
                                          <div class="col-12 col-md-6 col-lg-3">
                                            <div class="form-group">
                                              <label>Timing </label>
                                              <v-select class="mr-2" required="" v-model="item.timing"
                                                placeholder="Select Pain Timing" :options="pain_timing">
                                              </v-select>
                                            </div>
                                          </div>
  
                                          <div class="col-12 col-md-6 col-lg-1" v-if="pain_analysis.length !== 1">
                                            <div class="form-group" style="
                                                margin-top: 43px;
                                                cursor: pointer;
                                              ">
                                              <span class="circle" @click="
                                                remove_item(
                                                  'pain_analysis',
                                                  index
                                                )
                                                "><i class="fa fa-times" /></span>
                                            </div>
                                          </div>
                                        </div>
                                        <hr v-if="pain_analysis.length - 1 &&
                                          pain_analysis.length > 1
                                          " />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="add-more">
                                    <a href="javascript:void(0);" @click="add_Information('pain_analysis')"
                                      class="add-membership"><i class="fa fa-plus-circle"></i> Add
                                      More</a>
                                  </div>
                                  <div class="col-4 mt-4">
                                    <div class="form-group">
                                      <h3>INJURY HISTORY</h3>
                                    </div>
                                  </div>
  
                                  <div class="experience-info" v-for="(item, index) in injury_history" :key="index">
                                    <div class="row form-row experience-cont">
                                      <div class="col-12 col-md-10 col-lg-11">
                                        <div class="row form-row">
                                          <div class="col-12 col-md-6 col-lg-4">
                                            <div class="form-group">
                                              <label>Injury Type </label>
                                              <v-select class="mr-2" name="injury_type" required="" label="injury_type"
                                                v-model="item.injury_type" placeholder="Select Injury Type" :reduce="(option) => option.injury_type
                                                  " :options="injury_types">
                                              </v-select>
                                            </div>
                                          </div>
                                          <div class="col-12 col-md-6 col-lg-2">
                                            <div class="form-group">
                                              <label>Year </label>
                                              <input type="text" class="form-control" value="" v-model="item.year"
                                                placeholder="Year" />
                                            </div>
                                          </div>
                                          <div class="col-12 col-md-6 col-lg-1" v-if="injury_history.length !== 1">
                                            <div class="form-group" style="
                                                margin-top: 43px;
                                                cursor: pointer;
                                              ">
                                              <span class="circle" @click="
                                                remove_item(
                                                  'injury_history',
                                                  index
                                                )
                                                "><i class="fa fa-times" /></span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="add-more">
                                    <a href="javascript:void(0);" @click="add_Information('injury_history')"
                                      class="add-membership"><i class="fa fa-plus-circle"></i> Add
                                      More</a>
                                  </div>
  
                                  <div class="col-6 mt-4">
                                    <div class="form-group">
                                      <h3>ASSISTIVE DEVICE STATUS</h3>
                                    </div>
                                  </div>
  
                                  <div class="experience-info custom-dropdown" v-for="(item,
                                    index) in assistive_device_using" :key="index">
                                    <div class="row form-row experience-cont">
                                      <div class="col-12 col-md-10 col-lg-11">
                                        <div class="row form-row">
                                          <div class="col-12 col-md-6 col-lg-4">
                                            <div class="form-group">
                                              <label>Assistive device used
                                              </label>
                                              <v-select class="mr-2" name="assistive_device_types" required=""
                                                label="assistive_device_types" v-model="item.assistive_device"
                                                placeholder="Select Assistive device used" :reduce="(option) =>
                                                  option.assistive_device_types
                                                  " :options="assistive_device_used">
                                              </v-select>
                                            </div>
                                          </div>
                                          <div class="col-12 col-md-6 col-lg-2" v-if="index === 0">
                                            <div class="form-group">
                                              <label>Period </label>
                                              <input type="text" class="form-control" value="" v-model="item.period"
                                                placeholder="Period" />
                                            </div>
                                          </div>
                                          <div class="col-12 col-md-6 col-lg-3" v-if="index === 0">
                                            <div class="form-group">
                                              <label>Since </label>
                                              <v-select class="mr-2" required="" v-model="item.days"
                                                placeholder="Select Since" :options="pain_since">
                                              </v-select>
                                            </div>
                                          </div>
                                          <div class="col-12 col-md-6 col-lg-1" v-if="assistive_device_using.length !== 1
                                            ">
                                            <div class="form-group" style="
                                                margin-top: 43px;
                                                cursor: pointer;
                                              ">
                                              <span class="circle" @click="
                                                remove_item(
                                                  'assistive_device_using',
                                                  index
                                                )
                                                "><i class="fa fa-times" /></span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="add-more">
                                    <a href="javascript:void(0);" @click="
                                      add_Information('assistive_device_using')
                                      " class="add-membership"><i class="fa fa-plus-circle"></i> Add
                                      More</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
  
                          <div class="text-right mt-5">
                            <a v-if="currentPath == 'new-patient-encounter'" class="btn btn-primary btn-sm mb-3"
                              tabindex="0" @click="add_patient_encounter_new('Joints')">Save Changes</a>
                            <a v-if="currentPath ==
                              'update-patient-encounter-update' &&
                              !closedAppointment
                              " class="btn btn-primary btn-sm mb-3" tabindex="0"
                              @click="update_patient_encounter('Joints')">Update Changes</a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Joints Content End-->
  
                    <!-- Medical Records Content Start-->
                    <div v-if="active == 'Medical Records'" class="Diagnosis ml-md-4">
                      <div id="pat_medicalrecords" class="tab-pane fade show active">
                        <div class="text-left">
                          <a href="#" class="add-new-btn" data-toggle="modal" data-target="#add_medical_records_modal">Add
                            Medical Record
                          </a>
                        </div>
                        <div class="card">
                          <div class="row mt-3 ml-1 mr-1">
                            <div class="card border-0 col-lg-4" v-for="(item, index) in medical_records" :key="index"
                              v-show="setPaginate(index)">
                              <div class="card-body border" style="
                                border-radius: 10px;
                                border-color: #00b3d0 !important;
                                margin-bottom:20px
                              ">
                                <div class="row">
                                  <div class="col-6">
                                    <img style="width: 88px" class="avatar-img" v-bind:src="config.base_url_for_Image + item.image
                                      " alt="User Image" />
                                    <h6 class="
                                      card-subtitle
                                      mt-2
                                      mb-1
                                      text-muted
                                    ">
                                      {{
                                        item.report_type ? item.report_type : "-"
                                      }}
                                    </h6>
                                  </div>
                                  <div class="col">
                                    <div class="message">
                                      <h5 class="card-title">
                                        {{ item.doctor_name ? item.doctor_names : "-" }}
                                      </h5>
                                      <h6 class="card-subtitle mb-2 text-muted">
                                        {{ item.date ? formatDate(item.date) : "-" }}
                                      </h6>
                                      <a href="#" class="btn bg-info-light mt-5 ml-5" data-toggle="modal"
                                        data-target="#add_medical_records_view"
                                        @click="viewMedicalRecordAttachment(item.attachment)">
                                        View
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <h5 v-if="medical_records.length === 0" class="No_data">
                            No Medical Records Found
                          </h5>
                        </div>
                        <div id="pagination" v-if="medical_records.length > 12">
                          <a href="#" v-for="page_index in paginate_total" :key="page_index.id" :class="current === page_index ? 'pagination-active' : ''
                            " class="btn btn-default active-pagination" @click.prevent="updateCurrent(page_index)">
                            {{ page_index }}
                          </a>
                        </div>
                      </div>
                    </div>
  
                    <!-- Medical Records Content Start-->
  
                    <!-- Treatment Content Start-->
                    <div v-if="active == 'Treatment'" class="ml-md-2">
                      <div id="main">
                        <div class="container">
                          <div class="row">
                            <div class="col-md-6">
                              <div class="row form-row" v-for="(item, index) in diagnosis" :key="index">
                                <div class="col-12 col-md-10">
                                  <div class="form-group">
                                    <label v-if="index === 0" class="ml-2">Diagnosis</label>
                                    <v-select @change="validateDropdown" class="m-2" name="name" required label="diagnosis"
                                      placeholder="Select Diagnosis" v-model="item.diagnosis"
                                      :reduce="(option) => option.name" :options="filteredDiagnosisLists[index]"
                                      disabled>
                                    </v-select>
  
  
                                  </div>
                                </div>
                                <div class="col-md-1" v-if="diagnosis.length !== 1">
                                  <div class="form-group">
                                    <div class="form-group" style="cursor: pointer" v-bind:style="index == 0
                                      ? 'margin-top: 37px'
                                      : 'margin-top: 7px'
                                      ">
                                      <span class="circle" @click="remove_item('diagnosis', index)"><i
                                          class="fa fa-times" /></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-6 col-md-6">
                                  <div>
                                    <a href="javascript:void(0);" @click="add_Information('diagnosis')" class="add-reg"
                                      disabled><i class="fa fa-plus-circle"></i> Add
                                      More</a>
                                  </div>
                                </div>
                                <div class="col-6 col-md-6">
                                  <div>
                                    <a href="#" data-toggle="modal" class="add-reg" data-target="#addiagnosis"
                                      disabled tabindex="0"><i class="fa fa-plus-circle"></i> Add
                                      Diagnosis</a>
  
                                    <!-- <a href="#" data-toggle="modal" data-target="#addiagnosis"
                                      class="btn btn-primary btn-sm mb-4" tabindex="0" :disabled="doc_status === 1">Add
                                      Diagnosis</a> -->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="row form-row">
                                <div class="col-12 col-md-10">
                                  <div class="form-group">
                                    <label class="ml-2">Treatment Plan</label>
                                    <v-select class="m-2" name="name" required="" label="treatment_plan_name"
                                      @input="changed_treatment" placeholder="Select Treatment Plan"
                                      :reduce="(option) => option.name" :options="all_treatment_template"
                                      disabled>
                                    </v-select>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-12 col-md-12">
                                  <!-- <a class="btn btn-primary btn-sm" data-toggle="modal"
                                    data-target="#add_treatment_plan_modal" tabindex="0" :disabled="doc_status === 1">Add
                                    Treatment Plan</a> -->
  
                                  <a href="#" data-toggle="modal" class="add-reg" data-target="#add_treatment_plan_modal"
                                    disabled tabindex="0"><i class="fa fa-plus-circle"></i> Add
                                    Treatment Plan</a>
                                </div>
                              </div>
                            </div>
                          </div>
  
                          <div class="accordion" id="faq">
                            <div class="card mt-4">
                              <div class="card-header" id="faqhead3">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#faq3"
                                  aria-expanded="true" aria-controls="faq3">Investigations</a>
                              </div>
  
                              <div id="faq3" class="collapse" aria-labelledby="faqhead3" data-parent="#faq">
                                <div class="row mt-3">
                                  <div class="col-md-6">
                                    <div class="row form-row">
                                      <div class="col-md-10">
                                        <div class="form-group">
                                          <v-select class="mr-2" name="name" required="" label="template_name"
                                            v-model="selected_investigation_plan" @input="changed_investigation"
                                            placeholder="Select Investigation Template" :reduce="(option) => option.name"
                                            :options="all_investigation_template" disabled>
                                          </v-select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <div class="row form-row">
                                      <div class="col-md-12">
                                        <div>
                                          <a href="javascript:void(0);" class="add-reg" data-toggle="modal"
                                            data-target="#addtemplate" @click="
                                              open_treament('Investigation')
                                              " disabled><i class="fa fa-plus-circle"></i> Add
                                            Investigation Template</a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="card-body testimonial">
                                    <ckeditor :editor="editor" v-model="selected_investigation_template"
                                      disabled></ckeditor>
                                  </div>
                                </div>
                              </div>
                            </div>
  
                            <div class="card">
                              <div class="card-header" id="faqhead10">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                  data-target="#faq10" aria-expanded="true" aria-controls="faq10">Medical Prescription</a>
                              </div>
  
                              <div id="faq10" class="collapse" aria-labelledby="faqhead10" data-parent="#faq">
                                <div class="row mt-3">
                                  <div class="col-md-6">
                                    <div class="row form-row">
                                      <div class="col-md-10">
                                        <div class="form-group">
                                          <v-select class="mr-2" name="name" required="" label="template_name"
                                            v-model="selected_prescription_plan" @input="changed_prescription"
                                            placeholder="Select Prescription Plan" :reduce="(option) => option.name"
                                            :options="all_prescription_template" disabled>
                                          </v-select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <div class="row form-row">
                                      <div class="col-md-12">
                                        <div>
                                          <a href="javascript:void(0);" class="add-reg" data-toggle="modal"
                                            data-target="#addtemplate" @click="open_treament('Prescription')"
                                            disabled><i class="fa fa-plus-circle"></i> Add
                                            Prescription Template</a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="card-body testimonial">
                                    <ckeditor :editor="editor" v-model="selected_prescription_template"
                                      disabled></ckeditor>
                                  </div>
                                </div>
                              </div>
                            </div>
  
                            <div class="card">
                              <div class="card-header" id="faqhead11">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                  data-target="#faq11" aria-expanded="true" aria-controls="faq11">Procedure / Surgery
                                  Advice</a>
                              </div>
  
                              <div id="faq11" class="collapse" aria-labelledby="faqhead11" data-parent="#faq">
                                <div class="row mt-3">
                                  <div class="col-md-6">
                                    <div class="row form-row">
                                      <div class="col-md-10">
                                        <div class="form-group">
                                          <v-select class="mr-2" name="name" required="" label="template_name"
                                            v-model="selected_surgery_plan" @input="changed_surgery"
                                            placeholder="Select Surgery Plan" :reduce="(option) => option.name"
                                            :options="all_surgery_template" disabled>
                                          </v-select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <div class="row form-row">
                                      <div class="col-md-12">
                                        <div>
                                          <a href="javascript:void(0);" class="add-reg" data-toggle="modal"
                                            data-target="#addtemplate" @click="open_treament('Surgery')"
                                            disabled><i class="fa fa-plus-circle"></i> Add
                                            Surgery Template</a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="card-body testimonial">
                                    <ckeditor :editor="editor" v-model="selected_surgery_template"
                                      disabled></ckeditor>
                                  </div>
                                </div>
                              </div>
                            </div>
  
                            <div class="card">
                              <div class="card-header" id="faqhead13">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                  data-target="#faq13" aria-expanded="true" aria-controls="faq13">General Advice</a>
                              </div>
  
                              <div id="faq13" class="collapse" aria-labelledby="faqhead13" data-parent="#faq">
                                <div class="row mt-3">
                                  <div class="col-md-6">
                                    <div class="row form-row">
                                      <div class="col-md-10">
                                        <div class="form-group">
                                          <v-select class="mr-2" name="name" required="" label="template_name"
                                            placeholder="Select General Advice" v-model="selected_general_advice_plan"
                                            @input="changed_general_advice" :reduce="(option) => option.name"
                                            :options="all_general_advice_template" disabled>
                                          </v-select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <div class="row form-row">
                                      <div class="col-md-12">
                                        <div>
                                          <a href="javascript:void(0);" class="add-reg" data-toggle="modal"
                                            data-target="#addtemplate" @click="open_treament('General')"
                                            disabled><i class="fa fa-plus-circle"></i> Add
                                            General Advice</a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="card-body testimonial">
                                    <ckeditor :editor="editor" v-model="selected_general_advice_template"
                                      disabled></ckeditor>
                                  </div>
                                </div>
                              </div>
                            </div>
  
                            <div class="card">
                              <div class="card-header" id="faqhead2">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#faq2"
                                  aria-expanded="true" aria-controls="faq2">Exercise Advice</a>
                              </div>
  
                              <div id="faq2" class="collapse" aria-labelledby="faqhead2" data-parent="#faq">
                                <div class="row mt-3">
                                  <div class="col-md-6">
                                    <div class="row form-row">
                                      <div class="col-md-10">
                                        <div class="form-group">
                                          <v-select class="mr-2" name="name" required="" label="template_name" v-model="selected_exercise_advice_plan
                                            " placeholder="Select Exercise Plan" @input="changed_exercise_advice"
                                            :reduce="(option) => option.name" :options="all_exercise_advice_template
                                              " disabled>
                                          </v-select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <div class="row form-row">
                                      <div class="col-md-12">
                                        <div>
                                          <a href="javascript:void(0);" class="add-reg" data-toggle="modal"
                                            data-target="#addtemplate" @click="open_treament('Exercise')"
                                            disabled><i class="fa fa-plus-circle"></i> Add
                                            Exercise Template</a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="card-body testimonial">
                                    <ckeditor :editor="editor" v-model="selected_exercise_advice_template"
                                      disabled></ckeditor>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="text-left ml-3">
                                <a v-if="currentPath == 'new-patient-encounter'" class="btn btn-primary btn-sm mb-3"
                                  tabindex="0" @click="add_patient_encounter_new('Treatment')"
                                  disabled>Save Changes</a>
                                <a v-if="currentPath ==
                                  'update-patient-encounter-update' &&
                                  !closedAppointment
                                  " class="btn btn-primary btn-sm" tabindex="0"
                                  @click="update_patient_encounter('Treatment')" disabled>Update
                                  Changes</a>
                              </div>
                              <div class="text-left ml-2">
                                <a v-if="currentPath ==
                                  'update-patient-encounter-update' &&
                                  !closedAppointment
                                  " class="btn btn-primary btn-sm mb-3" tabindex="0" @click="submit_patient_encounter()"
                                  disabled>Submit Changes</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
  
                    <!-- Treatment Content End-->
  
                    <!-- Physiotheray Content Start-->
  
                    <div v-if="active == 'Physio'" class="mt-2">
                      <div id="main">
                        <div class="container">
                          <div class="accordion" id="faq">
                            <div class="card">
                              <div class="card">
                                <div class="col-md-12">
                                  <div class="row" style="background-color: red;">
                                    <div class="col-sm col-md-12">
                                      <!-- <th> Exercise Plan Template :  {{patient_therapy_plan_template}} </th> -->
                                    </div>
                                  </div>
  
                                  <span></span>
                                </div>
                                <div class="col-md-12">
                                  <table v-if="patient_exercise.length > 0">
                                    <tr>
                                      <th>Exercise Name</th>
                                      <th>Therapy Type</th>
                                      <th>Repetition</th>
                                      <th>Frequency</th>
                                      <th>Days</th>
                                      <th>Remove</th>
                                    </tr>
                                    <tr v-for="ex in patient_exercise">
                                      <td>{{ ex.exercise_name }}</td>
                                      <td>{{ ex.difficulty_level }}</td>
                                      <td>{{ ex.repetition_per_session }}</td>
                                      <td>{{ ex.frequency_per_day }}</td>
                                      <td>{{ ex.no_of_days }}</td>
                                      <td></td>
                                      <!-- <td><a href="javascript:void(0);"  class="add-reg" @click="remove_Ex_to_arr(ex)" ><i class="fa fa-minus-circle"></i> </a></td> -->
                                    </tr>
                                  </table>
                                </div>
                              </div>
  
                              <div class="card">
                                <div class="col-md-12">
                                  <select class="form-control" :required="true" @change="
                                    all_Physio_exercise_advice_template_function(
                                      $event
                                    )
                                    ">
                                    <option :selected="true">Select Exercise Template</option>
                                    <option v-for="option in all_Physio_exercise_advice_template"
                                      v-bind:value="option.name">{{ option.name }}</option>
                                  </select>
                                </div>
                                <div class="col-md-12">
                                  <hr />
                                </div>
  
                                <div class="col-md-12">
                                  <table v-if="final_all_Physio_exercise_advice_template.length >
                                    0
                                    ">
                                    <tr>
                                      <th>Exercise Name</th>
                                      <th>Therapy Type</th>
                                      <th>Repetition</th>
                                      <th>Frequency</th>
                                      <th>Days</th>
                                      <th>Remove</th>
                                    </tr>
                                    <tr v-for="ex in final_all_Physio_exercise_advice_template">
                                      <td>{{ ex.exercise_name }}</td>
                                      <td>{{ ex.difficulty_level }}</td>
                                      <td>{{ ex.repetition_per_session }}</td>
                                      <td>{{ ex.frequency_per_day }}</td>
                                      <td>{{ ex.no_of_days }}</td>
                                      <td>
                                        <a href="javascript:void(0);" class="add-reg" @click="remove_Ex_to_arr(ex)"><i
                                            class="fa fa-minus-circle"></i>
                                        </a>
                                      </td>
                                    </tr>
                                  </table>
  
                                  <div v-else-if="final_all_Physio_exercise_advice_template.length ==
                                    0
                                    ">
                                    <p>No Exercise found..</p>
                                  </div>
                                </div>
                                <div>
                                  <div class="text-right mt-5">
                                    <a class="btn btn-primary btn-sm mb-3" tabindex="0" @click="
                                      update_patient_encounter(
                                        'excercise_template'
                                      )
                                      ">Update Changes</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
  
                    <!-- Physiontherapy Content End-->
                  </div>
                </div>
              </div>
            </div>
            <!-- /Page Content -->
            <layout-footer></layout-footer>
          </div>
        </div>
  
        <!--medical records views start -->
        <div class="modal fade custom-modal custom-medicalrecord-modal" id="add_medical_records_view" style="display: none"
          data-select2-id="add_medical_records_modal" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-md" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Medical Record</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body doctor-profile">
                <div class="row">
                  <div class="col-12 col-md-12">
                    <!-- <img v-if="attachmentUrl" :src="attachmentUrl" alt="Medical Record Attachment" /> -->
                    <img v-if="attachmentUrl" style="width:550px;height:400px;"
                      v-bind:src="attachmentUrl ? config.base_url_for_Image + attachmentUrl : loadImg({ attachmentUrl })"
                      alt="User Image" />
                    <!-- <div class="form-group">
                      <label>Report Type</label>
                      <v-select class="mr-2" name="Report Type" required="" label="Report Type"
                        v-model="add_medical_record_data.report_type" placeholder="Select Report Type"
                        :options="report_types">
                      </v-select>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--medical records views end -->
  
        <div class="modal fade custom-modal show" id="addvitals">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Add Vital</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="card">
                  <div class="card-body">
                    <div class="row form-row">
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label>Pulse (in bpm)</label>
                          <input v-model="add_vitals.pulse" type="text" class="form-control" value=""
                            oninput="this.value = this.value.replace(/[^0-9]/g, '');" maxlength="4" minlength="4" />
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label>Systolic Blood Pressure (in mmHg)</label>
                          <input v-model="add_vitals.bp_systolic" type="text" class="form-control" value=""
                            oninput="this.value = this.value.replace(/[^0-9]/g, '');" maxlength="4" minlength="4" />
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label>Diastolic Blood Pressure</label>
                          <input v-model="add_vitals.bp_diastolic" type="text" class="form-control" value=""
                            oninput="this.value = this.value.replace(/[^0-9]/g, '');" maxlength="4" minlength="4" />
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label>Temperature (C)</label>
                          <input v-model="add_vitals.temperature" type="text" class="form-control" value=""
                            oninput="this.value = this.value.replace(/[^0-9]/g, '');" maxlength="4" minlength="4" />
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label>Height (in feet)</label>
                          <input v-model="add_vitals.height_in_feet" type="text" class="form-control" value=""
                            oninput="this.value = this.value.replace(/[^0-9.]/g, '');" maxlength="3" minlength="3" />
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label>Weight (in Kg)</label>
                          <input v-model="add_vitals.weight" type="text" class="form-control" value=""
                            oninput="this.value = this.value.replace(/[^0-9.]/g, '');" maxlength="5" minlength="5" />
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label>Random Blood Sugar</label>
                          <input v-model="add_vitals.random_blood_sugar_rbs" type="text" class="form-control" value=""
                            oninput="this.value = this.value.replace(/[^0-9]/g, '');" maxlength="4" minlength="4" />
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label>Fasting Blood Sugar</label>
                          <input v-model="add_vitals.fasting_blood_sugar_fbs" type="text" class="form-control" value=""
                            oninput="this.value = this.value.replace(/[^0-9]/g, '');" maxlength="4" minlength="4" />
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label>HbA1C</label>
                          <input v-model="add_vitals.HbA1C" type="text" class="form-control" value=""
                            oninput="this.value = this.value.replace(/[^0-9]/g, '');" maxlength="4" minlength="4" />
                        </div>
                      </div>
                    </div>
                    <div class="submit-section" style="text-align:left">
                      <button @click="add_vitals_signs()" class="btn btn-primary submit-btn" data-dismiss="modal"
                        aria-label="Close">
                        Add Vital
                      </button>
                    </div>
                    <!-- </form> -->
                    <!-- /Profile Settings Form -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade custom-modal show" id="addsymptoms">
          <div class="modal-dialog modal-dialog-centered modal-md">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Add Symptom</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="card">
                  <div class="card-body">
                    <div class="row form-row">
                      <div class="col-12 col-md-12">
                        <div class="form-group">
                          <label>Symptom</label>
                          <input v-model="new_complaint" type="text" class="form-control" value="" oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, ''); 
                          if (this.value.startsWith(' ')) this.value = this.value.trim();" />
                        </div>
                      </div>
                    </div>
                    <div class="submit-section" style="text-align: left">
                      <button @click="add_symptoms()" class="btn btn-primary submit-btn" data-dismiss="modal"
                        aria-label="Close">
                        Add Symptom
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <div class="modal fade custom-modal show" id="addlabtest">
          <div class="modal-dialog modal-dialog-centered modal-md">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Add Lab Test</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="card">
                  <div class="card-body">
                    <div class="row form-row">
                      <div class="col-12 col-md-12">
                        <div class="form-group">
                          <label>Lab Test</label>
                          <input v-model="new_labtest" type="text" class="form-control" value="" />
                        </div>
                      </div>
                    </div>
                    <div class="submit-section" style="text-align: center">
                      <button @click="add_lab_test()" class="btn btn-primary submit-btn" data-dismiss="modal"
                        aria-label="Close">
                        Add Lab Test
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <div class="modal fade custom-modal show" id="addiagnosis">
          <div class="modal-dialog modal-dialog-centered modal-md">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Add Diagnosis</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="card">
                  <div class="card-body">
                    <div class="row form-row">
                      <div class="col-12 col-md-12">
                        <div class="form-group">
                          <label>Diagnosis</label>
                          <input v-model="new_diagnosis" type="text" class="form-control" value="" oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, ''); 
                                      if (this.value.startsWith(' ')) this.value = this.value.trim();" />
                        </div>
                      </div>
                    </div>
                    <div class="submit-section" style="text-align: left">
                      <button @click="add_diagnosis()" disabled class="btn btn-primary submit-btn"
                        data-dismiss="modal" aria-label="Close">
                        Add Diagnosis
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <div class="modal fade custom-modal show" id="addtemplate">
          <div class="modal-dialog modal-dialog-centered modal-md">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Add Template</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body doctor-profile">
                <div class="card">
                  <div class="card-body">
                    <div class="row form-row">
                      <div class="col-12 col-md-12">
                        <div class="form-group">
                          <label>Template Name</label>
                          <input v-model="add_templates.template_name" type="text" class="form-control" value="" oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, ''); 
                          if (this.value.startsWith(' ')) this.value = this.value.trim();" />
                        </div>
                      </div>
                      <!-- <div class="col-12 col-md-12">
                        <div class="form-group">
                          <label>Category</label>
                          <v-select class="mr-2" required="" disabled v-model="add_templates.category"
                            placeholder="Select Category" :options="all_category">
                          </v-select>
                        </div>
                      </div> -->
                      <div class="col-12 col-md-12">
                        <div class="form-group testimonial">
                          <label>Description</label>
                          <ckeditor :editor="editor" v-model="add_templates.description"></ckeditor>
                        </div>
                      </div>
                    </div>
                    <div class="submit-section" style="text-align:left">
                      <button @click="add_new_templates()" disabled
                        class="btn btn-primary submit-btn" data-dismiss="modal" aria-label="Close">
                        Add Template
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <div class="modal fade custom-modal show" id="addsurgery">
          <div class="modal-dialog modal-dialog-centered modal-md">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Add Surgery</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="card">
                  <div class="card-body">
                    <div class="row form-row">
                      <div class="col-12 col-md-12">
                        <div class="form-group">
                          <label>Surgery</label>
                          <input v-model="new_surgery" type="text" class="form-control" value="" oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, ''); 
                              if (this.value.startsWith(' ')) this.value = this.value.trim();" />
                        </div>
                      </div>
                    </div>
                    <div class="submit-section" style="text-align: center">
                      <button @click="add_surgery()" class="btn btn-primary submit-btn" data-dismiss="modal"
                        aria-label="Close">
                        Add Surgery
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <div class="modal fade custom-modal custom-medicalrecord-modal" id="add_medical_records_modal" style="display: none"
          data-select2-id="add_medical_records_modal" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-md" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Add Medical Record</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body doctor-profile">
                <div class="row">
                  <div class="col-12 col-md-12">
                    <div class="form-group">
                      <label>Report Type</label>
                      <v-select class="mr-2" name="Report Type" required="" label="Report Type"
                        v-model="add_medical_record_data.report_type" placeholder="Select Report Type"
                        :options="report_types">
                      </v-select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-md-12">
                    <div class="form-group">
                      <label>Doctor</label>
                      <v-select class="mr-2" name="Report Type" required="" label="practitioner"
                        v-model="add_medical_record_data.doctor" placeholder="Select Doctor"
                        :options="favourite_doctors">
                      </v-select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label>Upload</label>
                      <div class="upload-medical-records">
                        <input class="form-control" type="file" name="user_file" id="user_files_mr"
                          @change="onFileChange" />
                        <div class="upload-content dropzone" v-if="add_medical_record_data.filename === ''">
                          <div class="text-center">
                            <div class="upload-icon mb-2">
                              <img src="@/assets/img/upload-icon.png" alt="" />
                            </div>
                            <h5>Drag &amp; Drop</h5>
                            <h6>or <span class="text-danger">Browse</span></h6>
                          </div>
                        </div>
                        <div class="upload-content dropzone" v-if="add_medical_record_data.filename !== ''">
                          <div class="text-center">
                            <div class="upload-icon mb-2">
                              <img style="width: 64px" src="@/assets/img/file.png" alt="" /><br />
                              {{ add_medical_record_data.filename }}
                            </div>
                            <h6><span class="text-danger">Replace</span></h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label>Document Description</label>
                      <input type="text" data-role="tagsinput" class="input-tags form-control"
                        placeholder="Add document description" name="services" v-model="add_medical_record_data.description"
                        id="services" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <label>Date Of Document</label>
                      <div class="form-group">
                        <input type="date" class="form-control" name="tratment_date" id="tratment_date"
                          v-model="add_medical_record_data.date" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-center mt-4">
                  <div class="submit-section text-left">
                    <button type="submit" id="medical_btn" class="btn btn-primary submit-btn" data-dismiss="modal"
                      aria-label="Close" @click="add_new_medical_record()" :disabled="!isFileUploaded">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade custom-modal custom-medicalrecord-modal" id="add_treatment_plan_modal" style="display: none"
          data-select2-id="add_treatment_plan_modal" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Add Treatment Plan</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body doctor-profile">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Treatment Plan Name</label>
                      <input type="text" class="form-control" v-model="new_treatment.treatment_plan_name"
                        placeholder="Treatment Plan Name" oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, ''); 
                        if (this.value.startsWith(' ')) this.value = this.value.trim();" />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Status</label>
                      <div class="m-1">
                        <input type="radio" value="Active" v-model="new_treatment.status" />&nbsp; Active
  
                        <input type="radio" value="Inactive" v-model="new_treatment.status" class="ml-5" />&nbsp;
                        Inactive
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Medical Prescription</label>
                      <v-select class="mr-2" name="name" required="" label="template_name" placeholder="Select Template"
                        v-model="new_treatment.medical_prescription" :reduce="(option) => option.name"
                        :options="all_prescription_template">
                      </v-select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Surgery Advice</label>
                      <v-select class="mr-2" name="name" required="" label="template_name" placeholder="Select Template"
                        v-model="new_treatment.surgery_advice" :reduce="(option) => option.name"
                        :options="all_surgery_template">
                      </v-select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Exercise Advice</label>
                      <v-select class="mr-2" name="name" required="" label="template_name" v-model="new_treatment.exercise"
                        placeholder="Select Template" :reduce="(option) => option.name"
                        :options="all_exercise_advice_template">
                      </v-select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Investigation Advice</label>
                      <v-select class="mr-2" name="name" required="" label="template_name"
                        v-model="new_treatment.investigation_advice" placeholder="Select Template"
                        :reduce="(option) => option.name" :options="all_investigation_template">
                      </v-select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>General Advice</label>
                      <v-select class="mr-2" name="name" required="" label="template_name"
                        v-model="new_treatment.general_advice" placeholder="Select Template"
                        :reduce="(option) => option.name" :options="all_general_advice_template">
                      </v-select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Description</label>
                      <textarea rows="6" type="text" class="form-control" v-model="new_treatment.description"
                        placeholder="Description" />
                    </div>
                  </div>
                  <div class="col-md-12 offset-md-12">
                    <div class="submit-section text-left">
                      <button @click="add_new_treatment()" disabled
                        class="btn btn-primary btn-sm mb-1" data-dismiss="modal" aria-label="Close">
                        Add Treatment
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- </form> -->
            </div>
          </div>
        </div>
  
        <!-- Pulse-status -->
        <div class="modal fade custom-modal show" id="pulse-graph">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Pulse Status</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body" style="background-color: #f8f8f8;">
                <apexchart type="line" height="350" :series="pulseflow.series" :options="pulseflow.options"></apexchart>
              </div>
            </div>
          </div>
        </div>
        <!-- /Pulse-status-->
  
        <!-- temperature-status -->
        <div class="modal fade custom-modal show" id="temperature-graph">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Temperature Status</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body" style="background-color: #f8f8f8;">
                <apexchart type="line" height="350" :series="tempflow.series" :options="tempflow.options"></apexchart>
              </div>
            </div>
          </div>
        </div>
        <!-- /temperature-status-->
  
        <!-- bp-status -->
        <div class="modal fade custom-modal show" id="bp-graph">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Bp Status</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body" style="background-color: #f8f8f8;">
                <apexchart type="line" height="350" :series="bpflow.series" :options="bpflow.options"></apexchart>
              </div>
            </div>
          </div>
        </div>
        <!-- /bp-status-->
  
        <!-- fasting-status -->
        <div class="modal fade custom-modal show" id="fasting-graph">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Fasting Blood Sugar Status</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body" style="background-color: #f8f8f8;">
                <apexchart type="line" height="350" :series="fbsflow.series" :options="fbsflow.options"></apexchart>
              </div>
            </div>
          </div>
        </div>
        <!-- /fasting-status-->
  
        <!-- random-status -->
        <div class="modal fade custom-modal show" id="random-graph">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Random Blood Sugar Status</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body" style="background-color: #f8f8f8;">
                <apexchart type="line" height="350" :series="rbsflow.series" :options="rbsflow.options"></apexchart>
              </div>
            </div>
          </div>
        </div>
        <!-- /random-status-->
  
        <!-- Hba1c-status -->
        <div class="modal fade custom-modal show" id="Hba1c-graph">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Hba1c Status</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body" style="background-color: #f8f8f8;">
                <apexchart type="line" height="350" :series="Hba1cflow.series" :options="Hba1cflow.options"></apexchart>
              </div>
            </div>
          </div>
        </div>
        <!-- /Hba1c-status-->
  
        <!-- Weight-status -->
        <div class="modal fade custom-modal show" id="Weight-graph">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Weight Status</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body" style="background-color: #f8f8f8;">
                <apexchart type="line" height="350" :series="weightflow.series" :options="weightflow.options"></apexchart>
              </div>
            </div>
          </div>
        </div>
        <!-- /Weight-status-->
  
        <!-- bmi-status -->
        <div class="modal fade custom-modal show" id="bmi-graph">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Bmi Status</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body" style="background-color: #f8f8f8;">
                <apexchart type="line" height="350" :series="bmiflow.series" :options="bmiflow.options"></apexchart>
              </div>
            </div>
          </div>
        </div>
        <!-- /bmi-status-->
      </div>
    </div>
  </template>
  
  <script>
  import CommonApi from "../../../services/CommonApi";
  import config from "../../../services/CommonApi";
  import Datepicker from "vuejs-datepicker";
  import VueTimepicker from "vue2-timepicker";
  import "vue2-timepicker/dist/VueTimepicker.css";
  import CKEditor from "@ckeditor/ckeditor5-vue";
  import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
  import { mapState } from "vuex";
  const images = require.context("@/assets/img/patients");
  export default {
    components: {
      Datepicker,
      VueTimepicker,
      ckeditor: CKEditor.component,
    },
    computed: {
        isFileUploaded() {
    return this.add_medical_record_data.filename !== '';
  },

      formattedEncounterTime() {
        if (this.dashboard_data.encounter_time) {
          const timeParts = this.dashboard_data.encounter_time.split(":");
          const hours = parseInt(timeParts[0]);
          const minutes = parseInt(timeParts[1]);
          const period = hours >= 12 ? "PM" : "AM";
  
          // Convert to 12-hour format
          const formattedHours = hours % 12 || 12;
          const formattedTime = `${formattedHours}:${minutes < 10 ? "0" : ""}${minutes} ${period}`;
  
          return formattedTime;
        }
        return "";
      },
  
      ...mapState({
        user_id: (state) => state.user.user_id,
        closedAppointment: (state) => state.user.closedAppointment,
      }),
      currentPath() {
        return this.$route.name;
      },
  
  
  
      filteredSymptLists() {
        return this.complaint.map((item, index) => {
          // Get all selected diagnoses from previous dropdowns
          const selectedInPrevious = this.complaint.slice(0, index).map(d => d.complaint);
          // Return the diagnosis list excluding the selected ones
          return this.all_symptoms.filter(complaint => !selectedInPrevious.includes(complaint.name));
        });
      },
  
  
  
      filteredDiagnosisLists() {
        return this.diagnosis.map((item, index) => {
          // Get all selected diagnoses from previous dropdowns
          const selectedInPrevious = this.diagnosis.slice(0, index).map(d => d.diagnosis);
          // Return the diagnosis list excluding the selected ones
          return this.diagnosis_list.filter(diagnosis => !selectedInPrevious.includes(diagnosis.name));
        });
      },
      template_validation() {
        return (
          this.add_templates.category &&
          this.add_templates.template_name &&
          this.add_templates.description
        );
      },
  
      new_treatment_validation() {
        return (
          this.new_treatment.treatment_plan_name && this.new_treatment.status
        );
      },
  
      eye: {
        get() {
          return `${this.examination_data.eye_opening}`;
        },
        set(theQuantity) {
          this.examination_data.eye_opening = theQuantity;
        },
      },
      total_eye() {
        return this.examination_data.eye_opening * 1;
      },
  
      verbal: {
        get() {
          return `${this.examination_data.verbal_response}`;
        },
        set(theQuantity) {
          this.examination_data.verbal_response = theQuantity;
        },
      },
      total_verbal() {
        return this.examination_data.verbal_response * 1;
      },
  
      motar: {
        get() {
          return `${this.examination_data.motor_response}`;
        },
        set(theQuantity) {
          this.examination_data.motor_response = theQuantity;
        },
      },
      total_motar() {
        return this.examination_data.motor_response * 1;
      },
  
      subtotal() {
        return this.total_eye + this.total_verbal + this.total_motar;
      },
  
      pulseflow() {
        return {
          series: [
            {
              name: "Pulse",
              data: this.pulse_data,
            },
          ],
          options: {
            chart: {
              height: 350,
              type: "line",
              stacked: false,
              toolbar: {
                show: false,
              },
            },
            dataLabels: {
              enabled: true,
            },
            stroke: {
              width: [4, 4],
            },
            xaxis: {
              categories: this.pulse_dates,
            },
            yaxis: [
              {
                axisTicks: {
                  show: true,
                },
                axisBorder: {
                  show: true,
                  color: "#FF1654",
                },
                labels: {
                  style: {
                    colors: "#FF1654",
                  },
                },
                title: {
                  text: "Pulse",
                  style: {
                    color: "#FF1654",
                  },
                },
              },
            ],
            tooltip: {
              shared: false,
              intersect: true,
              x: {
                show: false,
              },
            },
            legend: {
              horizontalAlign: "left",
              offsetX: 40,
            },
          },
        };
      },
  
      tempflow() {
        return {
          series: [
            {
              name: "Temperature",
              data: this.temp_data,
            },
          ],
          options: {
            chart: {
              height: 350,
              type: "line",
              stacked: false,
              toolbar: {
                show: false,
              },
            },
            dataLabels: {
              enabled: true,
            },
            stroke: {
              width: [4, 4],
            },
            xaxis: {
              categories: this.temp_dates,
            },
            yaxis: [
              {
                axisTicks: {
                  show: true,
                },
                axisBorder: {
                  show: true,
                  color: "#FF1654",
                },
                labels: {
                  style: {
                    colors: "#FF1654",
                  },
                },
                title: {
                  text: "Temperature",
                  style: {
                    color: "#FF1654",
                  },
                },
              },
            ],
            tooltip: {
              shared: false,
              intersect: true,
              x: {
                show: false,
              },
            },
            legend: {
              horizontalAlign: "left",
              offsetX: 40,
            },
          },
        };
      },
  
      bpflow() {
        return {
          series: [
            {
              name: "Bp",
              data: this.bp_data,
            },
          ],
          options: {
            chart: {
              height: 350,
              type: "line",
              stacked: false,
              toolbar: {
                show: false,
              },
            },
            dataLabels: {
              enabled: true,
            },
            stroke: {
              width: [4, 4],
            },
            xaxis: {
              categories: this.bp_dates,
            },
            yaxis: [
              {
                axisTicks: {
                  show: true,
                },
                axisBorder: {
                  show: true,
                  color: "#FF1654",
                },
                labels: {
                  style: {
                    colors: "#FF1654",
                  },
                },
                title: {
                  text: "Bp",
                  style: {
                    color: "#FF1654",
                  },
                },
              },
            ],
            tooltip: {
              shared: false,
              intersect: true,
              x: {
                show: false,
              },
            },
            legend: {
              horizontalAlign: "left",
              offsetX: 40,
            },
          },
        };
      },
  
      fbsflow() {
        return {
          series: [
            {
              name: "Fasting Blood Sugar",
              data: this.fasting_data,
            },
          ],
          options: {
            chart: {
              height: 350,
              type: "line",
              stacked: false,
              toolbar: {
                show: false,
              },
            },
            dataLabels: {
              enabled: true,
            },
            stroke: {
              width: [4, 4],
            },
            xaxis: {
              categories: this.fasting_dates,
            },
            yaxis: [
              {
                axisTicks: {
                  show: true,
                },
                axisBorder: {
                  show: true,
                  color: "#FF1654",
                },
                labels: {
                  style: {
                    colors: "#FF1654",
                  },
                },
                title: {
                  text: "Fasting Blood Sugar",
                  style: {
                    color: "#FF1654",
                  },
                },
              },
            ],
            tooltip: {
              shared: false,
              intersect: true,
              x: {
                show: false,
              },
            },
            legend: {
              horizontalAlign: "left",
              offsetX: 40,
            },
          },
        };
      },
  
      rbsflow() {
        return {
          series: [
            {
              name: "Random Blood Sugar",
              data: this.random_data,
            },
          ],
          options: {
            chart: {
              height: 350,
              type: "line",
              stacked: false,
              toolbar: {
                show: false,
              },
            },
            dataLabels: {
              enabled: true,
            },
            stroke: {
              width: [4, 4],
            },
            xaxis: {
              categories: this.random_dates,
            },
            yaxis: [
              {
                axisTicks: {
                  show: true,
                },
                axisBorder: {
                  show: true,
                  color: "#FF1654",
                },
                labels: {
                  style: {
                    colors: "#FF1654",
                  },
                },
                title: {
                  text: "Random Blood Sugar",
                  style: {
                    color: "#FF1654",
                  },
                },
              },
            ],
            tooltip: {
              shared: false,
              intersect: true,
              x: {
                show: false,
              },
            },
            legend: {
              horizontalAlign: "left",
              offsetX: 40,
            },
          },
        };
      },
  
      Hba1cflow() {
        return {
          series: [
            {
              name: "HbA1C",
              data: this.hba1c_data,
            },
          ],
          options: {
            chart: {
              height: 350,
              type: "line",
              stacked: false,
              toolbar: {
                show: false,
              },
            },
            dataLabels: {
              enabled: true,
            },
            stroke: {
              width: [4, 4],
            },
            xaxis: {
              categories: this.hba1c_dates,
            },
            yaxis: [
              {
                axisTicks: {
                  show: true,
                },
                axisBorder: {
                  show: true,
                  color: "#FF1654",
                },
                labels: {
                  style: {
                    colors: "#FF1654",
                  },
                },
                title: {
                  text: "HbA1C",
                  style: {
                    color: "#FF1654",
                  },
                },
              },
            ],
            tooltip: {
              shared: false,
              intersect: true,
              x: {
                show: false,
              },
            },
            legend: {
              horizontalAlign: "left",
              offsetX: 40,
            },
          },
        };
      },
  
      weightflow() {
        return {
          series: [
            {
              name: "Weight",
              data: this.weight_data,
            },
          ],
          options: {
            chart: {
              height: 350,
              type: "line",
              stacked: false,
              toolbar: {
                show: false,
              },
            },
            dataLabels: {
              enabled: true,
            },
            stroke: {
              width: [4, 4],
            },
            xaxis: {
              categories: this.weight_dates,
            },
            yaxis: [
              {
                axisTicks: {
                  show: true,
                },
                axisBorder: {
                  show: true,
                  color: "#FF1654",
                },
                labels: {
                  style: {
                    colors: "#FF1654",
                  },
                },
                title: {
                  text: "Weight",
                  style: {
                    color: "#FF1654",
                  },
                },
              },
            ],
            tooltip: {
              shared: false,
              intersect: true,
              x: {
                show: false,
              },
            },
            legend: {
              horizontalAlign: "left",
              offsetX: 40,
            },
          },
        };
      },
  
      bmiflow() {
        return {
          series: [
            {
              name: "BMI",
              data: this.bmi_data,
            },
          ],
          options: {
            chart: {
              height: 350,
              type: "line",
              stacked: false,
              toolbar: {
                show: false,
              },
            },
            dataLabels: {
              enabled: true,
            },
            stroke: {
              width: [4, 4],
            },
            xaxis: {
              categories: this.bmi_dates,
            },
            yaxis: [
              {
                axisTicks: {
                  show: true,
                },
                axisBorder: {
                  show: true,
                  color: "#FF1654",
                },
                labels: {
                  style: {
                    colors: "#FF1654",
                  },
                },
                title: {
                  text: "BMI",
                  style: {
                    color: "#FF1654",
                  },
                },
              },
            ],
            tooltip: {
              shared: false,
              intersect: true,
              x: {
                show: false,
              },
            },
            legend: {
              horizontalAlign: "left",
              offsetX: 40,
            },
          },
        };
      },
    },
    watch: {
      template_validation() {
        if (
          this.add_templates.category === "" ||
          this.add_templates.category === null ||
          this.add_templates.template_name === "" ||
          this.add_templates.description === ""
        ) {
          this.disabled_template_button = true;
        } else {
          this.disabled_template_button = false;
        }
      },
      new_treatment_validation() {
        if (
          this.new_treatment.treatment_plan_name === "" ||
          this.new_treatment.status === "" ||
          this.new_treatment.status === null
        ) {
          this.disabled_template_button = true;
        } else {
          this.disabled_template_button = false;
        }
      },
    },
  
    data() {
      return {
        patient_age: "",
        practitioner_names: "Sunil Jain",
        practitioner: "",
        selectedOption: 'age',
        doc_status: "",
        attachmentUrl: null,
        format: "dd-MM-yyyy",
        showspinner: true,
        disabled_template_button: true,
        active: "Details",
        genders: [],
        visit_types: [],
        // assistive_device_using: [],
        complaint: [{ complaint: "" }],
        patient_therapy_plan_template: "",
        patient_exercise: [],
        all_symptoms: [],
        new_complaint: "",
        new_labtest: "",
        new_diagnosis: "",
        new_surgery: "",
        add_templates: {
          category: "",
          template_name: "",
          description: "",
          doctor: this.user_id,
        },
        eye_opening: [],
        verbal_response: [],
        motar_response: [],
        cardiovascular_system: [],
        central_nervous_system: [],
        adbomen: [],
        respiratory_system: [],
        knee_locations: [],
        pain_scales: [],
        // Locations: [],
        pain_intensity: [],
        knee_xray_diagnosis: [],
        knee_xray_deformity: [],
        mri_diagnosis: [],
        pain_nature: [],
        pain_since: [],
        pain_timing: [],
        injury_types: [],
        assistive_device_days: [],
        assistive_device_used: [],
        add_vitals: {
          pulse: "",
          bp_systolic: "",
          bp_diastolic: "",
          temperature: "",
          height_in_feet: "",
          weight: "",
          random_blood_sugar_rbs: "",
          fasting_blood_sugar_fbs: "",
          HbA1C: "",
        },
        lab_tests: [],
        lab_test: [{ lab_test_code: "" }],
        diagnosis_list: [],
        diagnosis: [{ diagnosis: "" }],
        surgery: [],
        surgery_template: [{ procedure: "" }],
        assistive_device_using: [{ assistive_device: "", period: "", days: "" }],
        injury_history: [{ injury_type: "", year: "" }],
        pain_analysis: [
          {
            joint: "",
            location: "",
            intensity: "",
            nature: "",
            period: "",
            pain_since: "",
            timing: "",
          },
        ],
        dashboard_data: {
          patient_image: "",
          patient_id: this.$route.params.patient_id,
          appointment_id: this.$route.params.appointment_id,
          patient_name: "",
          patient_mobile: "",
          dob: "",
          encounter_date: this.convertDate(new Date()),
          encounter_time: "",
          gender: "",
          visit_type: "",
          patient_history: "",
          patient_symptoms: "",
        },
  
  
        // Xray Diagnosis fields
        pain_analysis_data: {
          knee_xray_diagnosis_left: "",
          knee_xray_diagnosis_right: "",
          deformity_left: "",
          deformity_right: "",
          xray_diagnosis_remarks: "",
          mri_diagnosis_left: "",
          mri_diagnosis_right: "",
          mri_deformity_left: "",
          mri_deformity_right: "",
          mri_assessment_remarks: "",
          svf_left: "",
          svf_right: "",
          pfo_left: "",
          pfo_right: "",
          hto_left: "",
          hto_right: "",
          dfo_left: "",
          dfo_right: "",
          arthroscopy_left: "",
          arthoscopy_right: "",
        },
  
        examination_data: {
          pallor: "NAD",
          cyanosis: "NAD",
          edema: "NAD",
          hydration: "NAD",
          icterus: "NAD",
          clubbing: "NAD",
          dysponea: "NAD",
          thyroid: "NAD",
          lymphadenopathy: "NAD",
          jvp: "NAD",
          examination_of_breast: "NAD",
          eye_opening: "",
          verbal_response: "",
          motor_response: "",
          score: "",
          cardiovascular_system: "",
          central_nervous_system: "",
          abdomen: "",
          respiratory_system: "",
          local_examination: "",
        },
        joint_data: {
          knee: false,
          knee_location: "",
          hip: false,
          hip_location: "",
          ankle: false,
          ankle_location: "",
          foot: false,
          foot_location: "",
          cervical_spine: false,
          lumbar_spine: false,
          shoulder: false,
          shoulder_location: "",
          elbow: false,
          elbow_location: "",
          forearm: false,
          forearm_location: "",
          wrist: false,
          wrist_location: "",
          finger: false,
          pain_scale: "",
        },
        joint_assessment_id: "",
        patient_data: {
          pulse_history: "",
          temperature_history: "",
          bp: "",
          fasting_blood_sugar_fbs_history: "",
          random_blood_sugar_rbs_history: "",
          hba1c_history: "",
          weight_history: "",
          bmi_history: "",
          bmi_unit: "",
        },
        editor: ClassicEditor,
        prescription: "",
        advise:
          "Avoid Cross Leg Sitting<br>Wear Proper Footwear<br>Include Protein in your Diet<br>Avoid Carbohydrate<br>Do Exercise Regularly",
        exercise_advice: "",
        selected_joint: "",
        selected_joint_location: "",
        medical_records: [],
        config: config,
        favourite_doctors: [],
        belong_to: [],
        report_types: [],
        speciality: [],
        add_medical_record_data: {
          patient: this.$route.params.patient_id,
          doctor: "",
          // belongs_to: "",
          filename: "",
          report_type: "",
          date: "",
          // speciality: "",
          description: "",
          doc_type: "My Documents",
          decode_base64: 1,
          attached_to_field: "attachment",
          filedata: "",
        },
        user_name: localStorage.getItem("userInfo")
          ? JSON.parse(localStorage.getItem("userInfo")).username
          : null,
        all_category: [],
        all_treatment_template: [],
        all_investigation_template: [],
        all_prescription_template: [],
        all_surgery_template: [],
        all_general_advice_template: [],
        all_exercise_advice_template: [],
        all_Physio_exercise_advice_template: [],
        final_all_Physio_exercise_advice_template: [],
        final_all_Physio_exercise_advice_template_name: "",
  
        selected_treatment: "",
        selected_investigation_plan: "",
        selected_investigation_template: "",
        selected_prescription_plan: "",
        selected_prescription_template: "",
        selected_surgery_plan: "",
        selected_surgery_template: "",
        selected_general_advice_plan: "",
        selected_general_advice_template: "",
        selected_exercise_advice_plan: "",
        selected_exercise_advice_plan_template: "",
        selected_exercise_advice_template: "",
  
        treatment_status: ["Active", "Inactive"],
        new_treatment: {
          treatment_plan_name: "",
          status: "Active",
          medical_prescription: "",
          surgery_advice: "",
          doctor: this.user_id,
          exercise: "",
          investigation_advice: "",
          general_advice: "",
          description: "",
        },
        all_knee_laxity: [],
        all_deformity: [],
        all_knee_tenderness: [],
        all_range_motion: [],
        all_joint: [],
        all_muscle_location: [],
        all_muscle: [],
        all_muscle_tone: [],
        all_power: [1, 2, 3, 4, 5],
        all_neuro_condition_type: [],
        all_neuro_reflex: [],
        joint_assessment: {
          neurological_assessment: false,
          muscle_power_and_tone_assessment: false,
        },
        pulse_data: [],
        pulse_dates: [],
        temp_data: [],
        temp_dates: [],
        bp_data: [],
        bp_dates: [],
        fasting_data: [],
        fasting_dates: [],
        random_data: [],
        random_dates: [],
        hba1c_data: [],
        hba1c_dates: [],
        weight_data: [],
        weight_dates: [],
        bmi_data: [],
        bmi_dates: [],
        knee_assessment_right: {
          location: "Right",
          laxity_status_examination: "",
          deformity: "",
          measurement_by_verniar_calipers: "",
          effusion: "",
          osteophytes: "",
          loose_body: "",
          tenderness_status: "",
          muscle_girth_4_inches_above_joint_line: "",
          range_of_motion: "",
          muscle_girth_4_inches_below_joint_line: "",
          visual_analog_scale: "",
          extension_deformity: "",
          medial_rotation: "",
          flexion_deformity: "",
          lateral_rotation: "",
          laxity_by_lachmeter: "",
          extension: "",
          flexion: "",
          koos_score: "",
        },
        knee_assessment_left: {
          location: "Left",
          laxity_status_examination: "",
          deformity: "",
          measurement_by_verniar_calipers: "",
          effusion: "",
          osteophytes: "",
          loose_body: "",
          tenderness_status: "",
          muscle_girth_4_inches_above_joint_line: "",
          range_of_motion: "",
          muscle_girth_4_inches_below_joint_line: "",
          visual_analog_scale: "",
          extension_deformity: "",
          medial_rotation: "",
          flexion_deformity: "",
          lateral_rotation: "",
          laxity_by_lachmeter: "",
          extension: "",
          flexion: "",
          koos_score: "",
        },
        hip_assessment_right: {
          location: "Right",
          visual_analog_scale: "",
          abduction: "",
          extension: "",
          flexion: "",
          adduction: "",
          range_of_motion: "",
          hip_womac: "",
          medial_rotation: "",
          hip_hoos: "",
          extension_deformity: "",
          hip_hoos_junior: "",
        },
        hip_assessment_left: {
          location: "Left",
          visual_analog_scale: "",
          abduction: "",
          extension: "",
          flexion: "",
          adduction: "",
          range_of_motion: "",
          hip_womac: "",
          medial_rotation: "",
          hip_hoos: "",
          extension_deformity: "",
          hip_hoos_junior: "",
        },
        ankle_assessment_right: {
          location: "Right",
          visual_analog_scale: "",
          ankle_eversion: "",
          dorsiflexion: "",
          ankle_inversion: "",
          faam: "",
          plantarflexion: "",
          maq: "",
        },
        ankle_assessment_left: {
          location: "Left",
          visual_analog_scale: "",
          ankle_eversion: "",
          dorsiflexion: "",
          ankle_inversion: "",
          faam: "",
          plantarflexion: "",
          maq: "",
        },
        shoulder_assessment_right: {
          location: "Right",
          visual_analog_scale: "",
          external_rotation: "",
          extension: "",
          flexion: "",
          internal_rotation: "",
          abduction: "",
          pain_disability_index: "",
          adduction: "",
          shoulder_hoos: "",
        },
        shoulder_assessment_left: {
          location: "Left",
          visual_analog_scale: "",
          external_rotation: "",
          extension: "",
          flexion: "",
          internal_rotation: "",
          abduction: "",
          pain_disability_index: "",
          adduction: "",
          shoulder_hoos: "",
        },
        cervical_spine_assessment: {
          visual_analog_scale: "",
          rotation: "",
          extension: "",
          neck_disability_index: "",
          flexion: "",
          lateral_flexion: "",
          bournemouth_questionnaire: "",
        },
        lumbar_spine_assessment: {
          visual_analog_scale: "",
          quebec_disability_scale: "",
          extension: "",
          lumbar_spine_muscle_power: "",
          flexion: "",
          lateral_flexion: "",
          fingertip_to_floor: "",
          rotation: "",
          lumbar_spine_pain_functional_scale: "",
          lumbar_spine_lateral_flexion: "",
        },
        wrist_assessment_right: {
          location: "Right",
          visual_analog_scale: "",
          ulner_deviation_0_to_30: "",
          range_of_motion: "",
          radial_deviation_0_to_20: "",
          dorsi_flexion_0_to_60: "",
          disabilities_of_arm_shoulder_and_hand_dash: "",
          palmer_flexion_0_to_60: "",
        },
        wrist_assessment_left: {
          location: "Right",
          visual_analog_scale: "",
          ulner_deviation_0_to_30: "",
          range_of_motion: "",
          radial_deviation_0_to_20: "",
          dorsi_flexion_0_to_60: "",
          disabilities_of_arm_shoulder_and_hand_dash: "",
          palmer_flexion_0_to_60: "",
        },
        elbow_assessment_right: {
          location: "Right",
          visual_analog_scale: "",
          extension: "",
          flexion: "",
          disabilities_of_arm_shoulder_and_hand_dash: "",
        },
        elbow_assessment_left: {
          location: "Left",
          visual_analog_scale: "",
          extension: "",
          flexion: "",
          disabilities_of_arm_shoulder_and_hand_dash: "",
        },
        foot_assessment_right: {
          location: "Right",
          visual_analog_scale: "",
          function_index: "",
        },
        foot_assessment_left: {
          location: "Left",
          visual_analog_scale: "",
          function_index: "",
        },
        muscle_power_and_tone_right: {
          location: "Right",
          joint: "",
          muscle: "",
          tone: "",
          power: 0,
        },
        muscle_power_and_tone_left: {
          location: "Left",
          joint: "",
          muscle: "",
          tone: "",
          power: 0,
        },
        neuro_conditions_assessment_right: {
          location: "Right",
          neuro_condition_type: "",
          date_of_assessment: "",
          period: 0,
          observation: "",
        },
        neuro_conditions_assessment_left: {
          location: "Left",
          neuro_condition_type: "",
          date_of_assessment: "",
          period: 0,
          observation: "",
        },
        neurological_reflexes_grading_right: {
          location: "Right",
          reflex: "",
          grading: 0,
        },
        neurological_reflexes_grading_left: {
          location: "Left",
          reflex: "",
          grading: 0,
        },
        deep_tendon_reflexes_status: "",
        superfecial_abdominal_reflexes_status: "",
        superfecial_flexor_planter_reflexes_status: "",
        superfecial_cremastric_reflexes_status: "",
        superfecial_extensor_planter_reflexes_status: "",
        observation_and_remarks: "",
        current: 1,
        paginate: 12,
        paginate_total: 0,
      };
    },
    mounted() {
      let user = localStorage.getItem("userInfo");
    if(!user){
      this.$router.push({name:'login'})
    }
      if (this.$route.params.encounter_id) {
        this.get_patient_encounter_data();
      }
      this.get_physio_exercise_templates_list();
      this.get_patient_key_vital_all();
      this.get_patient_profile();
      this.get_encounter_mode();
      this.get_complaints_dr();
      this.get_gender();
      this.get_eye_opening();
      this.get_verbal_response();
      this.get_motor_response();
      this.get_cardiovascular_system(), this.get_abdomen();
      this.get_central_nervous_system();
      this.get_respiratory_system();
      this.get_joints_location();
      this.get_pain_intensity();
      this.get_knee_xray_diagnosis();
      this.get_knee_xray_deformity();
      this.get_mri_diagnosis();
      this.get_pain_nature();
      this.get_pain_since();
      this.get_pain_timing();
      this.get_injury_type();
      // this.get_assistive_device_days();
      this.get_lab_test();
      this.get_diagnosis();
      this.get_clinical_procedure_template();
      this.get_pain_scale();
      this.get_assistive_device_type();
      this.get_patient_key_vital_last();
      this.get_patient_documents();
      this.get_my_doctors();
      this.get_belongs_to();
      this.get_document_report_type();
      this.get_speciality_list();
      this.get_all_treatment_plan_templates_list();
      this.get_investigation_advice_templates();
      this.get_medical_prescription_templates_list();
      this.get_surgery_advice_templates();
      this.get_general_advice_templates_list();
      this.get_exercise_templates_list();
      this.get_template_category();
      this.get_knee_laxity_status();
      this.get_all_deformity();
      this.get_knee_tenderness_status();
      this.get_range_of_motion();
      this.get_joint();
      this.get_muslce_joints_location();
      this.get_muscle();
      this.get_muslce_tone();
      this.get_neuro_condition_type();
      this.get_neuro_reflex();
  
  
  
      //sidebar open close
      var $wrapper = $(".main-wrapper");
      $(".main-nav a").on("click", function (e) {
        if (
          $(this)
            .parent()
            .hasClass("has-submenu")
        ) {
          e.preventDefault();
        }
        if (!$(this).hasClass("submenu")) {
          $("ul", $(this).parents("ul:first")).slideUp(350);
          $("a", $(this).parents("ul:first")).removeClass("submenu");
          $(this)
            .next("ul")
            .slideDown(350);
          $(this).addClass("submenu");
        } else if ($(this).hasClass("submenu")) {
          $(this).removeClass("submenu");
          $(this)
            .next("ul")
            .slideUp(350);
        }
      });
      $("body").append('<div class="sidebar-overlay"></div>');
      $(document).on("click", "#mobile_btn", function () {
        $wrapper.toggleClass("slide-nav");
        $(".sidebar-overlay").toggleClass("opened");
        $("html").addClass("menu-opened");
        $("#task_window").removeClass("opened");
        return false;
      });
  
      $(document).on("click", "#menu_close", function () {
        $("html").removeClass("menu-opened");
        $(".sidebar-overlay").removeClass("opened");
        $("main-wrapper").removeClass("slide-nav");
      });
      $(".main-nav ul li:not(.submenu) a").click(function () {
        $("html").removeClass("menu-opened");
        $(".sidebar-overlay").removeClass("opened");
      });
    },
    //sidebar open close
  
    destroyed() {
      this.$store.dispatch("user/closedAppointment");
    },
    methods: {

    /* Get My Doctors  */
    async get_my_doctors() {
      const params = new URLSearchParams();
      params.append("hospital", "Ramsnehi Hospital-Bhilwara");
      await CommonApi.get_data("sahaj.hospital.get_hospital_doctor", params).then(
        (res) => {
          this.showspinner = false;
          if (res && res.data) {
            this.favourite_doctors = res.data.doctor_list.filter((data) => data.is_favorite !== 0);
          }
        }
      );
    },
  
      menu_close() {
        // Code to close the sidebar here
        var $wrapper = $(".main-wrapper");
        $("html").removeClass("menu-opened");
        $(".sidebar-overlay").removeClass("opened");
        $wrapper.removeClass("slide-nav");
      },
  
  
      formatDate(dateString) {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      },
      setPaginate(i) {
        if (this.current == 1) {
          return i < this.paginate;
        } else {
          return (
            i >= this.paginate * (this.current - 1) &&
            i < this.current * this.paginate
          );
        }
      },
  
      /* Get Updated date */
      changedneuroRightDate() {
        this.neuro_conditions_assessment_right.date_of_assessment = this.neuro_conditions_assessment_right.date_of_assessment
          .toISOString()
          .split("T")[0];
      },
  
      /* Get Updated date */
      changedneuroLeftDate() {
        this.neuro_conditions_assessment_left.date_of_assessment = this.neuro_conditions_assessment_left.date_of_assessment
          .toISOString()
          .split("T")[0];
      },
  
      updateCurrent(i) {
        this.current = i;
        document.getElementById("pat_medicalrecords").scrollIntoView();
      },
  
      convert_time(time) {
        var time_string = [];
        if (time) {
          Object.entries(time).map((itemArray) => {
            time_string.push(itemArray[1]);
          });
        }
        let string = time_string.slice(0, 2);
        let date = string.join(":");
        return date + " " + time_string[3];
      },
  
      loadImg(imgPath) {
        return images("./" + imgPath);
      },
  
      get_joint_data() {
        return joint_data;
      },
  
      active_menu(menu) {
        this.active = menu;
      },
  
      changed_treatment(e) {
        this.get_treatment_plan_details(e);
      },
  
      changed_investigation(e) {
        this.selected_investigation_template =
          this.all_investigation_template.find((data) => data.name === e)
            .description !== null
            ? this.all_investigation_template.find((data) => data.name === e)
              .description
            : "";
      },
  
      changed_prescription(e) {
        this.selected_prescription_template =
          this.all_prescription_template.find((data) => data.name === e)
            .description !== null
            ? this.all_prescription_template.find((data) => data.name === e)
              .description
            : "";
      },
  
      changed_surgery(e) {
        this.selected_surgery_template =
          this.all_surgery_template.find((data) => data.name === e)
            .description !== null
            ? this.all_surgery_template.find((data) => data.name === e)
              .description
            : "";
      },
  
      changed_general_advice(e) {
        this.selected_general_advice_template =
          this.all_general_advice_template.find((data) => data.name === e)
            .description !== null
            ? this.all_general_advice_template.find((data) => data.name === e)
              .description
            : "";
      },
  
      changed_exercise_advice(e) {
        this.selected_exercise_advice_template =
          this.all_exercise_advice_template.find((data) => data.name === e)
            .description !== null
            ? this.all_exercise_advice_template.find((data) => data.name === e)
              .description
            : "";
      },
  
      open_treament(type) {
        if (type === "Prescription") {
          this.add_templates.category = this.all_category[1];
        } else if (type === "Exercise") {
          this.add_templates.category = this.all_category[2];
        } else if (type === "General") {
          this.add_templates.category = this.all_category[3];
        } else if (type === "Surgery") {
          this.add_templates.category = this.all_category[4];
        } else if (type === "Investigation") {
          this.add_templates.category = this.all_category[5];
        } else if (type === "ExercisePlan") {
          location.replace("./doctor/exercise-plan");
        }
      },
  
  
      viewMedicalRecordAttachment(attachment) {
        // Set the attachment URL to be displayed in the modal
        this.attachmentUrl = attachment;
        // Open the view modal
        $('#add_medical_records_view').modal('show');
      },
  
      /* Add New Treatment  */
      async add_new_treatment() {
        await CommonApi.post_data(
          "sahaj.template.add_treatment_plan",
          JSON.stringify(this.new_treatment)
        ).then((res) => {
          this.showspinner = false;
          if (res && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            });
            (this.new_treatment.treatment_plan_name = ""),
              (this.new_treatment.medical_prescription = ""),
              (this.new_treatment.surgery_advice = ""),
              (this.new_treatment.exercise = ""),
              (this.new_treatment.investigation_advice = "");
            this.new_treatment.general_advice = "";
            this.new_treatment.description = "";
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
        });
      },
  
      /* Get Selected Treatment Plan Details  */
      async get_treatment_plan_details(treatment) {
        const params = new URLSearchParams();
        params.append("name", treatment);
        await CommonApi.get_data(
          "sahaj.template.get_treatment_plan_details",
          params
        ).then((res) => {
          this.showspinner = false;
          if (res && res.treatment_plan_name) {
            this.selected_investigation_plan =
              res.treatment_plan_name.investigation_advice.details.template_name;
            this.selected_investigation_template =
              res.treatment_plan_name.investigation_advice.details.description !==
                null
                ? res.treatment_plan_name.investigation_advice.details.description
                : "";
            this.selected_prescription_plan =
              res.treatment_plan_name.medical_prescription.details.template_name;
            this.selected_prescription_template =
              res.treatment_plan_name.medical_prescription.details.description !==
                null
                ? res.treatment_plan_name.medical_prescription.details.description
                : "";
            this.selected_surgery_plan =
              res.treatment_plan_name.surgery_advice.details.template_name;
            this.selected_surgery_template =
              res.treatment_plan_name.surgery_advice.details.description !== null
                ? res.treatment_plan_name.surgery_advice.details.description
                : "";
            this.selected_general_advice_plan =
              res.treatment_plan_name.general_advice.details.template_name;
            this.selected_general_advice_template =
              res.treatment_plan_name.general_advice.details.description !== null
                ? res.treatment_plan_name.general_advice.details.description
                : "";
            this.selected_exercise_advice_plan =
              res.treatment_plan_name.exercise.details.template_name;
            this.selected_exercise_advice_template =
              res.treatment_plan_name.exercise.details.description !== null
                ? res.treatment_plan_name.exercise.Details.description
                : "";
          }
        });
      },
  
      formatAMPM(date) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        hours = hours < 10 ? "0" + hours : hours;
        minutes = minutes < 10 ? "0" + minutes : minutes;
        var strTime = hours + ":" + minutes + " " + ampm;
        return strTime;
      },
  
      /* Convert Date to Required Format for API */
      convertDate(str) {
        if (str === null || str === "") {
          return "";
        } else {
          var date = new Date(str),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
          return [date.getFullYear(), mnth, day].join("-");
        }
      },
  
      kneedatachanged(e) {
        // this.joint_assessment.knee_location = e
        this.pain_analysis.find((o, i) => {
          if (o.joint === "Knee") {
            this.pain_analysis[i] = {
              joint: "Knee",
              location: e,
            };
            return true;
          }
        });
      },
  
      hipdatachanged(e) {
        // this.joint_assessment.hip_location = e
        this.pain_analysis.find((o, i) => {
          if (o.joint === "Hip") {
            this.pain_analysis[i] = {
              joint: "Hip",
              location: e,
            };
            return true;
          }
        });
      },
  
      ankledatachanged(e) {
        // this.joint_assessment.ankle_location = e
        this.pain_analysis.find((o, i) => {
          if (o.joint === "Ankle") {
            this.pain_analysis[i] = {
              joint: "Ankle",
              location: e,
            };
            return true;
          }
        });
      },
  
      footdatachanged(e) {
        // this.joint_assessment.foot_location = e
        this.pain_analysis.find((o, i) => {
          if (o.joint === "Foot") {
            this.pain_analysis[i] = {
              joint: "Foot",
              location: e,
            };
            return true;
          }
        });
      },
  
      shoulderdatachanged(e) {
        // this.joint_assessment.shoulder_location = e
        this.pain_analysis.find((o, i) => {
          if (o.joint === "Shoulder") {
            this.pain_analysis[i] = {
              joint: "Shoulder",
              location: e,
            };
            return true;
          }
        });
      },
  
      elbowdatachanged(e) {
        // this.joint_assessment.elbow_location = e
        this.pain_analysis.find((o, i) => {
          if (o.joint === "Elbow") {
            this.pain_analysis[i] = {
              joint: "Elbow",
              location: e,
            };
            return true;
          }
        });
      },
  
      forearmdatachanged(e) {
        // this.joint_assessment.forearm_location = e
        this.pain_analysis.find((o, i) => {
          if (o.joint === "Forearm") {
            this.pain_analysis[i] = {
              joint: "Forearm",
              location: e,
            };
            return true;
          }
        });
      },
  
      wristdatachanged(e) {
        // this.joint_assessment.wrist_location = e
        this.pain_analysis.find((o, i) => {
          if (o.joint === "Wrist") {
            this.pain_analysis[i] = {
              joint: "Wrist",
              location: e,
            };
            return true;
          }
        });
      },
  
      check(event, type) {
        if (this.pain_analysis[0].joint === "") {
          this.pain_analysis = [];
        }
        if (type === "Knee") {
          if (event.target.checked) {
            this.joint_data.knee = true;
            // this.joint_assessment.knee_location = type
            this.pain_analysis.push({
              joint: type,
              location: "",
              intensity: "",
              nature: "",
              period: "",
              pain_since: "",
              timing: "",
            });
          } else {
            this.joint_data.knee = false;
            // this.joint_assessment.knee_location = ""
            this.pain_analysis = this.pain_analysis.filter(
              (item) => item.joint !== type
            );
          }
        } else if (type === "Hip") {
          if (event.target.checked) {
            this.joint_data.hip = true;
            // this.joint_assessment.hip_location = type
            this.pain_analysis.push({
              joint: type,
              location: "",
              intensity: "",
              nature: "",
              period: "",
              pain_since: "",
              timing: "",
            });
          } else {
            this.joint_data.hip = false;
            // this.joint_assessment.hip_location = ""
            this.pain_analysis = this.pain_analysis.filter(
              (item) => item.joint !== type
            );
          }
        } else if (type === "Ankle") {
          if (event.target.checked) {
            this.joint_data.ankle = true;
            // this.joint_assessment.ankle_location = type
            this.pain_analysis.push({
              joint: type,
              location: "",
              intensity: "",
              nature: "",
              period: "",
              pain_since: "",
              timing: "",
            });
          } else {
            this.joint_data.ankle = false;
            //  this.joint_assessment.ankle_location = ""
            this.pain_analysis = this.pain_analysis.filter(
              (item) => item.joint !== type
            );
          }
        } else if (type === "Foot") {
          if (event.target.checked) {
            this.joint_data.foot = true;
            // this.joint_assessment.foot_location = type
            this.pain_analysis.push({
              joint: type,
              location: "",
              intensity: "",
              nature: "",
              period: "",
              pain_since: "",
              timing: "",
            });
          } else {
            this.joint_data.foot = false;
            // this.joint_assessment.foot_location = ""
            this.pain_analysis = this.pain_analysis.filter(
              (item) => item.joint !== type
            );
          }
        } else if (type === "Cervical Spine") {
          if (event.target.checked) {
            this.joint_data.cervical_spine = true;
            // this.joint_assessment.cervical_spine = true
            this.pain_analysis.push({
              joint: type,
              location: "",
              intensity: "",
              nature: "",
              period: "",
              pain_since: "",
              timing: "",
            });
          } else {
            this.joint_data.cervical_spine = false;
            // this.joint_assessment.cervical_spine = false
            this.pain_analysis = this.pain_analysis.filter(
              (item) => item.joint !== type
            );
          }
        } else if (type === "Lumbar Spine") {
          if (event.target.checked) {
            this.joint_data.lumbar_spine = true;
            // this.joint_assessment.lumbar_spine = true
            this.pain_analysis.push({
              joint: type,
              location: "",
              intensity: "",
              nature: "",
              period: "",
              pain_since: "",
              timing: "",
            });
          } else {
            this.joint_data.lumbar_spine = false;
            //  this.joint_assessment.lumbar_spine = false
            this.pain_analysis = this.pain_analysis.filter(
              (item) => item.joint !== type
            );
          }
        } else if (type === "Finger") {
          if (event.target.checked) {
            this.joint_data.finger = true;
            // this.joint_assessment.finger = true
            this.pain_analysis.push({
              joint: type,
              location: "",
              intensity: "",
              nature: "",
              period: "",
              pain_since: "",
              timing: "",
            });
          } else {
            this.joint_data.finger = false;
            //  this.joint_assessment.finger = false
            this.pain_analysis = this.pain_analysis.filter(
              (item) => item.joint !== type
            );
          }
        } else if (type === "Shoulder") {
          if (event.target.checked) {
            this.joint_data.shoulder = true;
            // this.joint_assessment.shoulder_location = type
            this.pain_analysis.push({
              joint: type,
              location: "",
              intensity: "",
              nature: "",
              period: "",
              pain_since: "",
              timing: "",
            });
          } else {
            this.joint_data.shoulder = false;
            //  this.joint_assessment.shoulder_location = ""
            this.pain_analysis = this.pain_analysis.filter(
              (item) => item.joint !== type
            );
          }
        } else if (type === "Elbow") {
          if (event.target.checked) {
            this.joint_data.elbow = true;
            // this.joint_assessment.elbow_location = type
            this.pain_analysis.push({
              joint: type,
              location: "",
              intensity: "",
              nature: "",
              period: "",
              pain_since: "",
              timing: "",
            });
          } else {
            this.joint_data.elbow = false;
            //  this.joint_assessment.elbow_location = ""
            this.pain_analysis = this.pain_analysis.filter(
              (item) => item.joint !== type
            );
          }
        } else if (type === "Forearm") {
          if (event.target.checked) {
            this.joint_data.forearm = true;
            // this.joint_assessment.forearm_location = type
            this.pain_analysis.push({
              joint: type,
              location: "",
              intensity: "",
              nature: "",
              period: "",
              pain_since: "",
              timing: "",
            });
          } else {
            this.joint_data.forearm = false;
            //  this.joint_assessment.forearm_location = ""
            this.pain_analysis = this.pain_analysis.filter(
              (item) => item.joint !== type
            );
          }
        } else if (type === "Wrist") {
          if (event.target.checked) {
            this.joint_data.wrist = true;
            // this.joint_assessment.wrist_location = type
            this.pain_analysis.push({
              joint: type,
              location: "",
              intensity: "",
              nature: "",
              period: "",
              pain_since: "",
              timing: "",
            });
          } else {
            this.joint_data.wrist = false;
            // this.joint_assessment.wrist_location = ""
            this.pain_analysis = this.pain_analysis.filter(
              (item) => item.joint !== type
            );
          }
        } else if (type === "Neurological") {
          if (event.target.checked) {
            this.joint_assessment.neurological_assessment = true;
          } else {
            this.joint_assessment.neurological_assessment = false;
          }
        } else if (type === "muscle_power_and_tone_assessment") {
          if (event.target.checked) {
            this.joint_assessment.muscle_power_and_tone_assessment = true;
          } else {
            this.joint_assessment.muscle_power_and_tone_assessment = false;
          }
        } else if (type === "knee_assessment_right_effusion") {
          if (event.target.checked) {
            this.knee_assessment_right.effusion = true;
          } else {
            this.knee_assessment_right.effusion = false;
          }
        } else if (type === "knee_assessment_left_effusion") {
          if (event.target.checked) {
            this.knee_assessment_left.effusion = true;
          } else {
            this.knee_assessment_left.effusion = false;
          }
        } else if (type === "knee_assessment_right_extension") {
          if (event.target.checked) {
            this.knee_assessment_right.extension = true;
          } else {
            this.knee_assessment_right.extension = false;
          }
        } else if (type === "knee_assessment_left_extension") {
          if (event.target.checked) {
            this.knee_assessment_left.extension = true;
          } else {
            this.knee_assessment_left.extension = false;
          }
        }
  
        else if (type === "knee_assessment_right_osteophytes") {
          if (event.target.checked) {
            this.knee_assessment_right.osteophytes = true;
          } else {
            this.knee_assessment_right.osteophytes = false;
          }
        } else if (type === "knee_assessment_left_osteophytes") {
          if (event.target.checked) {
            this.knee_assessment_left.osteophytes = true;
          } else {
            this.knee_assessment_left.osteophytes = false;
          }
        }
        else if (type === "knee_assessment_right_loose_body") {
          if (event.target.checked) {
            this.knee_assessment_right.loose_body = true;
          } else {
            this.knee_assessment_right.loose_body = false;
          }
        } else if (type === "knee_assessment_right_loose_body") {
          if (event.target.checked) {
            this.knee_assessment_left.loose_body = true;
          } else {
            this.knee_assessment_left.loose_body = false;
          }
        }
        else if (type === "hip_assessment_right_extension") {
          if (event.target.checked) {
            this.hip_assessment_right.extension = true;
          } else {
            this.hip_assessment_right.extension = false;
          }
        } else if (type === "hip_assessment_left_extension") {
          if (event.target.checked) {
            this.hip_assessment_left.extension = true;
          } else {
            this.hip_assessment_left.extension = false;
          }
        } else if (type === "shoulder_assessment_right_extension") {
          if (event.target.checked) {
            this.shoulder_assessment_right.extension = true;
          } else {
            this.shoulder_assessment_right.extension = false;
          }
        } else if (type === "shoulder_assessment_left_extension") {
          if (event.target.checked) {
            this.shoulder_assessment_left.extension = true;
          } else {
            this.shoulder_assessment_left.extension = false;
          }
        } else if (type === "cervical_spine_assessment_extension") {
          if (event.target.checked) {
            this.cervical_spine_assessment.extension = true;
          } else {
            this.cervical_spine_assessment.extension = false;
          }
        } else if (type === "lumbar_spine_assessment_extension") {
          if (event.target.checked) {
            this.lumbar_spine_assessment.extension = true;
          } else {
            this.lumbar_spine_assessment.extension = false;
          }
        } else if (type === "elbow_assessment_right_extension") {
          if (event.target.checked) {
            this.elbow_assessment_right.extension = true;
          } else {
            this.elbow_assessment_right.extension = false;
          }
        } else if (type === "deep_tendon_reflexes_status") {
          if (event.target.checked) {
            this.deep_tendon_reflexes_status = true;
          } else {
            this.deep_tendon_reflexes_status = false;
          }
        } else if (type === "superfecial_cremastric_reflexes_status") {
          if (event.target.checked) {
            this.superfecial_cremastric_reflexes_status = true;
          } else {
            this.superfecial_cremastric_reflexes_status = false;
          }
        } else if (type === "superfecial_abdominal_reflexes_status") {
          if (event.target.checked) {
            this.superfecial_abdominal_reflexes_status = true;
          } else {
            this.superfecial_abdominal_reflexes_status = false;
          }
        } else if (type === "superfecial_extensor_planter_reflexes_status") {
          if (event.target.checked) {
            this.superfecial_extensor_planter_reflexes_status = true;
          } else {
            this.superfecial_extensor_planter_reflexes_status = false;
          }
        } else if (type === "superfecial_flexor_planter_reflexes_status") {
          if (event.target.checked) {
            this.superfecial_flexor_planter_reflexes_status = true;
          } else {
            this.superfecial_flexor_planter_reflexes_status = false;
          }
        }
  
        if (this.pain_analysis.length === 0) {
          this.pain_analysis.push({
            joint: "",
            location: "",
            intensity: "",
            nature: "",
            period: "",
            pain_since: "",
            timing: "",
          });
        }
      },
  
      /* Get All Treatment Plan  */
      async get_all_treatment_plan_templates_list(practitionerName) {
        
        const params = new URLSearchParams();
        params.append("doctor", practitionerName);
        await CommonApi.get_data(
          "sahaj.template.get_all_treatment_plan_templates_list_active",
          params
        ).then((res) => {
          this.showspinner = false;
          if (res && res.data) {
            this.all_treatment_template = res.data;
          }
        });
      },
  
      /* Get All Investigation Template Plan  */
      async get_investigation_advice_templates(practitionerName) {
        const params = new URLSearchParams();
        params.append("doctor", practitionerName);
        await CommonApi.get_data(
          "sahaj.template.get_investigation_advice_templates",
          params
        ).then((res) => {
          this.showspinner = false;
          if (res && res.data) {
            this.all_investigation_template = res.data;
          }
        });
      },
  
      /* Get All Prescription Template Plan  */
      async get_medical_prescription_templates_list(practitionerName) {
        const params = new URLSearchParams();
        params.append("doctor", practitionerName);
        await CommonApi.get_data(
          "sahaj.template.get_medical_prescription_templates_list",
          params
        ).then((res) => {
          this.showspinner = false;
          if (res && res.data) {
            this.all_prescription_template = res.data;
          }
        });
      },
  
      /* Get All Surgery Template Plan  */
      async get_surgery_advice_templates(practitionerName) {
        const params = new URLSearchParams();
        params.append("doctor", practitionerName);
        await CommonApi.get_data(
          "sahaj.template.get_surgery_advice_templates",
          params
        ).then((res) => {
          this.showspinner = false;
          if (res && res.data) {
            this.all_surgery_template = res.data;
          }
        });
      },
  
      /* Get All General Advice Template Plan   */
      async get_general_advice_templates_list(practitionerName) {
        const params = new URLSearchParams();
        params.append("doctor", practitionerName);
        await CommonApi.get_data(
          "sahaj.template.get_general_advice_templates_list",
          params
        ).then((res) => {
          this.showspinner = false;
          if (res && res.data) {
            this.all_general_advice_template = res.data;
          }
        });
      },
  
      /* Get All Exercise Advice Template Plan  */
      async get_exercise_templates_list(practitionerName) {
        const params = new URLSearchParams();
        params.append("doctor", practitionerName);
        await CommonApi.get_data(
          "sahaj.template.get_exercise_templates_list",
          params
        ).then((res) => {
          this.showspinner = false;
          if (res && res.data) {
            this.all_exercise_advice_template = res.data;
          }
        });
      },
  
      // remove exercise from selected template
      async remove_Ex_to_arr(rex) {
        const fruits = this.final_all_Physio_exercise_advice_template;
        let index = fruits.indexOf(rex);  
        this.final_all_Physio_exercise_advice_template.splice(index, 1);
      },
  
      async all_Physio_exercise_advice_template_function(e) {
        this.final_all_Physio_exercise_advice_template = [];
        var id = e.target.value;
        this.final_all_Physio_exercise_advice_template_name = id;
        const params = new URLSearchParams();
        params.append("name", id);
  
        await CommonApi.get_data(
          "sahaj.v1.physio.get_therapy_template_Details",
          params
        ).then((res) => {
          this.showspinner = false;
          if (res && res.data) {
            if (res.data[0].exercise.length) {
              this.final_all_Physio_exercise_advice_template =
                res.data[0].exercise;
            } else {
            }
          }
        });
      },
  
      /* Get All Exercise Advice Template Plan  */
      async get_physio_exercise_templates_list(practitionerName) {
        const params = new URLSearchParams();
        params.append("practitioner", practitionerName);
        await CommonApi.get_data(
          // "sahaj.template.get_exercise_templates_list",
          "sahaj.v1.physio.get_therapy_template_plan_dr",
          params
        ).then((res) => {
          this.showspinner = false;
          if (res && res.data) {
            this.all_Physio_exercise_advice_template = res.data;
          }
        });
      },
  
      /* Get All Knee Laxity */
      async get_knee_laxity_status() {
        await CommonApi.get_data("sahaj.joint.get_knee_laxity_status").then(
          (res) => {
            this.showspinner = false;
            if (res && res.message) {
              this.all_knee_laxity = res.message;
            }
          }
        );
      },
  
      /* Get All Deformity */
      async get_all_deformity() {
        await CommonApi.get_data("sahaj.joint.get_deformity").then(
          (res) => {
            this.showspinner = false;
            if (res && res.message) {
              this.all_deformity = res.message;
            }
          }
        );
      },
  
      /* Get All Knee Tenderness  */
      async get_knee_tenderness_status() {
        await CommonApi.get_data("sahaj.joint.get_knee_tenderness_status").then(
          (res) => {
            this.showspinner = false;
            if (res && res.message) {
              this.all_knee_tenderness = res.message;
            }
          }
        );
      },
  
      /* Get All Range Motions  */
      async get_range_of_motion() {
        await CommonApi.get_data("sahaj.joint.get_range_of_motion").then(
          (res) => {
            this.showspinner = false;
            if (res && res.message) {
              this.all_range_motion = res.message;
            }
          }
        );
      },
  
      /* Get All Muscle Joint  */
      async get_joint() {
        await CommonApi.get_data("sahaj.api.get_joint").then((res) => {
          this.showspinner = false;
          if (res && res.data) {
            this.all_joint = res.data;
          }
        });
      },
  
      /* Get All Muscle Location  */
      async get_muslce_joints_location() {
        await CommonApi.get_data("sahaj.joint.get_muslce_joints_location").then(
          (res) => {
            this.showspinner = false;
            if (res && res.message) {
              this.all_muscle_location = res.message;
            }
          }
        );
      },
  
      /* Get All Muscle  */
      async get_muscle() {
        await CommonApi.get_data("sahaj.joint.get_muscle").then((res) => {
          this.showspinner = false;
          if (res && res.data) {
            this.all_muscle = res.data;
          }
        });
      },
  
      /* Get All Muscle Tone  */
      async get_muslce_tone() {
        await CommonApi.get_data("sahaj.joint.get_muslce_tone").then((res) => {
          this.showspinner = false;
          if (res && res.message) {
            this.all_muscle_tone = res.message;
          }
        });
      },
  
      /* Get All Neuro Condition */
      async get_neuro_condition_type() {
        await CommonApi.get_data("sahaj.joint.get_neuro_condition_type").then(
          (res) => {
            this.showspinner = false;
            if (res && res.message) {
              this.all_neuro_condition_type = res.message;
            }
          }
        );
      },
  
      /* Get All Neuro Reflex  */
      async get_neuro_reflex() {
        await CommonApi.get_data("sahaj.joint.get_neuro_reflex").then((res) => {
          this.showspinner = false;
          if (res && res.message) {
            this.all_neuro_reflex = res.message;
          }
        });
      },
  
      /* Get All Template Category  */
      async get_template_category() {
        await CommonApi.get_data("sahaj.template.get_template_category").then(
          (res) => {
            this.showspinner = false;
            if (res && res.message) {
              this.all_category = res.message;
            }
          }
        );
      },
    
      /* Get Belong To  */
      async get_belongs_to() {
        await CommonApi.get_data("sahaj.document.get_belongs_to").then((res) => {
          this.showspinner = false;
          if (res) {
            this.belong_to = res.message;
          }
        });
      },
  
      /* Get Report Types  */
      async get_document_report_type() {
        await CommonApi.get_data("sahaj.document.get_document_report_type").then(
          (res) => {
            this.showspinner = false;
            if (res) {
              this.report_types = res.message;
            }
          }
        );
      },
  
      /* Get Speciality List  */
      async get_speciality_list() {
        await CommonApi.get_data("sahaj.api.get_speciality_list").then((res) => {
          this.showspinner = false;
          if (res && res.data) {
            this.speciality = res.data;
          }
        });
      },
  
      /* Add New Medical Record */
      async add_new_medical_record() {
        await CommonApi.post_data(
          "sahaj.document.upload_document_by_doctor",
          JSON.stringify(this.add_medical_record_data)
        ).then((res) => {
          this.showspinner = false;
          if (res && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            });
            this.get_patient_documents();
            this.$emit("close");
            (this.add_medical_record_data.doctor = ""),
              (this.add_medical_record_data.belongs_to = ""),
              (this.add_medical_record_data.filename = ""),
              (this.add_medical_record_data.report_type = ""),
              (this.add_medical_record_data.date = "");
            this.add_medical_record_data.description = "";
            this.add_medical_record_data.filedata = "";
          }
        });
      },
  
      /* Change Profile Image */
      onFileChange(e) {
        var files = e.target.files;
        if (!files.length) return;
        this.createImage(files[0]);
      },
  
      /* Create Profile Image */
      createImage(file) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.add_medical_record_data.filename = file.name;
          this.add_medical_record_data.filedata = e.target.result;
        };
        reader.readAsDataURL(file);
      },
  
      /* Get Patient Documents  */
      async get_patient_documents(practitionerName) {
        const params = new URLSearchParams();
        params.append("patient", this.$route.params.patient_id);
        params.append("doctor", practitionerName);
        await CommonApi.get_data(
          "sahaj.document.get_patient_shared_documents",
          params
        ).then((res) => {
          this.showspinner = false;
          this.medical_records = res.data;
          this.paginate_total = Math.ceil(
            this.medical_records.length / this.paginate
          );
        });
      },
  
      /* Get pain Scale */
      async get_assistive_device_type() {
        await CommonApi.get_data("sahaj.api.get_assistive_device_type").then(
          (res) => {
            this.assistive_device_used = res.data;
          }
        );
      },
  
      remove_device_option(e) {
        this.assistive_device_used;
        const index = this.assistive_device_used.indexOf(e);
        if (index > -1) {
          // only splice array when item is found
          this.assistive_device_used.splice(index, 1); // 2nd parameter means remove one item only
        }
      },
  
      /* Get Patient Vital  */
      async get_patient_key_vital_last() {
        const params = new URLSearchParams();
        params.append("patient", this.$route.params.patient_id);
        await CommonApi.get_data(
          "sahaj.api.get_patient_key_vital_last",
          params
        ).then((res) => {
          if (res) {
            this.showspinner = false;
            this.patient_data = {
              pulse_history: res.pulse_history.length
                ? res.pulse_history[0].pulse
                : 0,
              temperature_history: res.temperature_history.length
                ? res.temperature_history[0].temperature
                : 0,
              bp: res.bp.length ? res.bp[0].bp : 0,
              fasting_blood_sugar_fbs_history: res.fasting_blood_sugar_fbs_history
                .length
                ? res.fasting_blood_sugar_fbs_history[0].fasting_blood_sugar_fbs
                : 0,
              random_blood_sugar_rbs_history: res.random_blood_sugar_rbs_history
                .length
                ? res.random_blood_sugar_rbs_history[0].random_blood_sugar_rbs
                : 0,
              hba1c_history: res.hba1c_history.length
                ? res.hba1c_history[0].hba1c
                : 0,
              weight_history: res.weight_history.length
                ? res.weight_history[0].weight
                : 0,
              bmi_history: res.bmi_history.length ? res.bmi_history[0].bmi : 0,
              bmi_unit: res.bmi_history.length
                ? res.bmi_history[0].nutrition_note
                : "GRAPH",
            };
          }
        });
      },
  
      /* Get pain Scale */
      async get_pain_scale() {
        await CommonApi.get_data("sahaj.api.get_pain_scale").then((res) => {
          this.pain_scales = res.message;
        });
      },
  
      /* Get Surgery */
      async get_clinical_procedure_template() {
        await CommonApi.get_data(
          "sahaj.api.get_clinical_procedure_template"
        ).then((res) => {
          this.surgery = res.data;
        });
      },
  
      /* Get Diagnosis */
      async get_diagnosis(practitionerName) {
        var bodyFormData = new FormData();
        bodyFormData.append("practitioner", practitionerName);
        await CommonApi.post_data(
          "sahaj.api.get_diagnosis_dr",
          bodyFormData
        ).then((res) => {
          this.diagnosis_list = res.data;
        });
      },
  
      /* Get Lab Tests */
      async get_lab_test() {
        await CommonApi.get_data("sahaj.api.get_lab_test").then((res) => {
          this.lab_tests = res.data;
        });
      },
  
      /* Add Any Information */
      add_Information(type) {
        if (type === "lab_test") {
          this.lab_test.push({ lab_test_code: "" });
        }
        else if (type === "diagnosis") {
          const lastSelectedValue = this.diagnosis[this.diagnosis.length - 1].diagnosis;
          if (!lastSelectedValue || lastSelectedValue.trim() === "") {
            this.$swal.fire({
              icon: "warning",
              title: "Warning",
              text: "Please select a value before adding another dropdown.",
              showConfirmButton: true,
            });
            return;
          }
  
          // Check if all values have been selected
          const validSelectedValues = this.diagnosis
            .map(d => d.diagnosis)
            .filter(value => value && value.trim() !== "");
          if (validSelectedValues.length === this.diagnosis_list.length) {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: "All values have been selected. You cannot add more.",
              showConfirmButton: true,
            });
            return;
          }
  
          // If validations pass, add a new dropdown
          this.diagnosis.push({ diagnosis: "" });
        }
        else if (type === "complaint") {
          const lastSelectedValue = this.complaint[this.complaint.length - 1].complaint;
          if (!lastSelectedValue || lastSelectedValue.trim() === "") {
            this.$swal.fire({
              icon: "warning",
              title: "Warning",
              text: "Please select a value before adding another dropdown.",
              showConfirmButton: true,
            });
            return;
          }
  
          // Check if all values have been selected
          const validSelectedValue = this.complaint
            .map(d => d.complaint)
            .filter(value => value && value.trim() !== "");
  
          if (validSelectedValue.length === this.all_symptoms.length) {
            this.$swal.fire({
              icon: "warning",
              title: "Warning",
              text: "All values have been selected. You cannot add more.",
              showConfirmButton: true,
            });
            return;
          }
  
          // If validations pass, add a new dropdown
          this.complaint.push({ complaint: "" });
        }
        else if (type === "surgery") {
          this.surgery_template.push({ procedure: "" });
        } else if (type === "assistive_device_using") {
          this.assistive_device_using.push({
            assistive_device: "",
          });
        } else if (type === "injury_history") {
          this.injury_history.push({ injury_type: "", year: "" });
        } else if (type === "pain_analysis") {
          this.pain_analysis.push({
            joint: "",
            location: "",
            intensity: "",
            nature: "",
            period: "",
            pain_since: "",
            timing: "",
          });
        }
      },
  
      /* Remove Any Information */
      remove_item(type, id) {
        if (type === "lab_test") {
          this.lab_test.splice(id, 1);
        } else if (type === "diagnosis") {
          this.diagnosis.splice(id, 1);
        } else if (type === "surgery") {
          this.surgery_template.splice(id, 1);
        } else if (type === "assistive_device_using") {
          this.assistive_device_using.splice(id, 1);
        } else if (type === "injury_history") {
          this.injury_history.splice(id, 1);
        } else if (type === "pain_analysis") {
          this.pain_analysis.splice(id, 1);
        } else if (type === "complaint") {
          this.complaint.splice(id, 1);
        }
      },
  
      /* Add Joint Assessment  */
      async add_joint_assessment() {
        this.$swal({
          text: "Creating Joint Assessment...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        var bodyFormData = new FormData();
        let data = {
          patient: this.$route.params.patient_id,
          patient_name: this.dashboard_data.patient_name,
          doctor: this.user_id,
          doctor_name: this.user_name,
          date: new Date().toISOString().split("T")[0],
          patient_encounter: this.$route.params.encounter_id,
          knee_location: this.joint_data.knee_location,
          hip_location: this.joint_data.hip_location,
          ankle_location: this.joint_data.ankle_location,
          foot_location: this.joint_data.foot_location,
          cervical_spine: this.joint_data.cervical_spine,
          lumbar_spine: this.joint_data.lumbar_spine,
          shoulder_location: this.joint_data.shoulder_location,
          elbow_location: this.joint_data.elbow_location,
          wrist_location: this.joint_data.wrist_location,
          neurological_condition_status: this.joint_assessment
            .neurological_assessment,
          need_muscle_power_and_tone_assessment: this.joint_assessment
            .muscle_power_and_tone_assessment,
          deep_tendon_reflexes_status: this.deep_tendon_reflexes_status,
          superfecial_abdominal_reflexes_status: this
            .superfecial_abdominal_reflexes_status,
          superfecial_flexor_planter_reflexes_status: this
            .superfecial_flexor_planter_reflexes_status,
          superfecial_cremastric_reflexes_status: this
            .superfecial_cremastric_reflexes_status,
          superfecial_extensor_planter_reflexes_status: this
            .superfecial_extensor_planter_reflexes_status,
          observation_and_remarks: this.observation_and_remarks,
        };
  
        let knee_assessment = [
          this.knee_assessment_right,
          this.knee_assessment_left,
        ];
        let hip_assessment = [
          this.hip_assessment_right,
          this.hip_assessment_left,
        ];
        let ankle_assessment = [
          this.ankle_assessment_right,
          this.ankle_assessment_left,
        ];
        let shoulder_assessment = [
          this.shoulder_assessment_right,
          this.shoulder_assessment_left,
        ];
        let cervical_spine_assessment = [this.cervical_spine_assessment];
        let lumbar_spine_assessment = [this.lumbar_spine_assessment];
        let wrist_assessment = [
          this.wrist_assessment_right,
          this.wrist_assessment_left,
        ];
        let elbow_assessment = [
          this.elbow_assessment_right,
          this.elbow_assessment_left,
        ];
        let foot_assessment = [
          this.foot_assessment_right,
          this.foot_assessment_left,
        ];
        let muscle_power_and_tone = [
          this.muscle_power_and_tone_right,
          this.muscle_power_and_tone_left,
        ];
        let neuro_conditions_assessment = [
          this.neuro_conditions_assessment_right,
          this.neuro_conditions_assessment_left,
        ];
        let neurological_reflexes_grading = [
          this.neurological_reflexes_grading_right,
          this.neurological_reflexes_grading_left,
        ];
  
        bodyFormData.append("data", JSON.stringify(data));
        bodyFormData.append("knee_assessment", JSON.stringify(knee_assessment));
        bodyFormData.append("hip_assessment", JSON.stringify(hip_assessment));
        bodyFormData.append("ankle_assessment", JSON.stringify(ankle_assessment));
        bodyFormData.append(
          "shoulder_assessment",
          JSON.stringify(shoulder_assessment)
        );
        bodyFormData.append(
          "cervical_spine_assessment",
          JSON.stringify(cervical_spine_assessment)
        );
        bodyFormData.append(
          "lumbar_spine_assessment",
          JSON.stringify(lumbar_spine_assessment)
        );
        bodyFormData.append("wrist_assessment", JSON.stringify(wrist_assessment));
        bodyFormData.append("elbow_assessment", JSON.stringify(elbow_assessment));
        bodyFormData.append("foot_assessment", JSON.stringify(foot_assessment));
        bodyFormData.append(
          "muscle_power_and_tone",
          JSON.stringify(muscle_power_and_tone)
        );
        bodyFormData.append(
          "neuro_conditions_assessment",
          JSON.stringify(neuro_conditions_assessment)
        );
        bodyFormData.append(
          "neurological_reflexes_grading",
          JSON.stringify(neurological_reflexes_grading)
        );
  
        await CommonApi.post_data(
          "sahaj.joint.add_joint_assessment",
          bodyFormData
        ).then((res) => {
          this.showspinner = false;
          if (res && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            });
            this.$emit("close");
            this.update_patient_encounter("");
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
        });
      },
  
      /* Update Joint Assessment  */
      async update_joint_assessment() {
        this.$swal({
          text: "Updating Joint Assessment...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        var bodyFormData = new FormData();
        let data = {
          name: this.joint_assessment_id,
          patient: this.$route.params.patient_id,
          patient_name: this.dashboard_data.patient_name,
          doctor: this.user_id,
          doctor_name: this.user_name,
          date: new Date().toISOString().split("T")[0],
          patient_encounter: this.$route.params.encounter_id,
          knee_location: this.joint_data.knee_location,
          hip_location: this.joint_data.hip_location,
          ankle_location: this.joint_data.ankle_location,
          foot_location: this.joint_data.foot_location,
          cervical_spine: this.joint_data.cervical_spine,
          lumbar_spine: this.joint_data.lumbar_spine,
          shoulder_location: this.joint_data.shoulder_location,
          elbow_location: this.joint_data.elbow_location,
          wrist_location: this.joint_data.wrist_location,
          neurological_condition_status: this.joint_assessment
            .neurological_assessment,
          need_muscle_power_and_tone_assessment: this.joint_assessment
            .muscle_power_and_tone_assessment,
          deep_tendon_reflexes_status: this.deep_tendon_reflexes_status,
          superfecial_abdominal_reflexes_status: this
            .superfecial_abdominal_reflexes_status,
          superfecial_flexor_planter_reflexes_status: this
            .superfecial_flexor_planter_reflexes_status,
          superfecial_cremastric_reflexes_status: this
            .superfecial_cremastric_reflexes_status,
          superfecial_extensor_planter_reflexes_status: this
            .superfecial_extensor_planter_reflexes_status,
          observation_and_remarks: this.observation_and_remarks,
        };
  
        let knee_assessment = [
          this.knee_assessment_right,
          this.knee_assessment_left,
        ];
        let hip_assessment = [
          this.hip_assessment_right,
          this.hip_assessment_left,
        ];
        let ankle_assessment = [
          this.ankle_assessment_right,
          this.ankle_assessment_left,
        ];
        let shoulder_assessment = [
          this.shoulder_assessment_right,
          this.shoulder_assessment_left,
        ];
        let cervical_spine_assessment = [this.cervical_spine_assessment];
        let lumbar_spine_assessment = [this.lumbar_spine_assessment];
        let wrist_assessment = [
          this.wrist_assessment_right,
          this.wrist_assessment_left,
        ];
        let elbow_assessment = [
          this.elbow_assessment_right,
          this.elbow_assessment_left,
        ];
        let foot_assessment = [
          this.foot_assessment_right,
          this.foot_assessment_left,
        ];
        let muscle_power_and_tone = [
          this.muscle_power_and_tone_right,
          this.muscle_power_and_tone_left,
        ];
        let neuro_conditions_assessment = [
          this.neuro_conditions_assessment_right,
          this.neuro_conditions_assessment_left,
        ];
        let neurological_reflexes_grading = [
          this.neurological_reflexes_grading_right,
          this.neurological_reflexes_grading_left,
        ];
  
        bodyFormData.append("data", JSON.stringify(data));
        bodyFormData.append("knee_assessment", JSON.stringify(knee_assessment));
        bodyFormData.append("hip_assessment", JSON.stringify(hip_assessment));
        bodyFormData.append("ankle_assessment", JSON.stringify(ankle_assessment));
        bodyFormData.append(
          "shoulder_assessment",
          JSON.stringify(shoulder_assessment)
        );
        bodyFormData.append(
          "cervical_spine_assessment",
          JSON.stringify(cervical_spine_assessment)
        );
        bodyFormData.append(
          "lumbar_spine_assessment",
          JSON.stringify(lumbar_spine_assessment)
        );
        bodyFormData.append("wrist_assessment", JSON.stringify(wrist_assessment));
        bodyFormData.append("elbow_assessment", JSON.stringify(elbow_assessment));
        bodyFormData.append("foot_assessment", JSON.stringify(foot_assessment));
        bodyFormData.append(
          "muscle_power_and_tone",
          JSON.stringify(muscle_power_and_tone)
        );
        bodyFormData.append(
          "neuro_conditions_assessment",
          JSON.stringify(neuro_conditions_assessment)
        );
        bodyFormData.append(
          "neurological_reflexes_grading",
          JSON.stringify(neurological_reflexes_grading)
        );
  
        await CommonApi.post_data(
          "sahaj.joint.update_joint_assessment",
          bodyFormData
        ).then((res) => {
          this.showspinner = false;
          if (res && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            });
            this.$emit("close");
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
        });
      },
  
      /* Add Patient Encounter Data  */
      async add_patient_encounter_new(type) {
        this.$swal({
          text: "Adding Patient Encounter...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        var bodyFormData = new FormData();
        let data = {
          appointment: this.dashboard_data.appointment_id,
          patient: this.dashboard_data.patient_id,
          practitioner: this.user_id,
          patient_name: this.dashboard_data.patient_name,
        };
  
        // if (type === "dashboard") {
        (data.encounter_date = this.dashboard_data.encounter_date),
          (data.encounter_time = this.dashboard_data.encounter_time),
          (data.patient_came_with_history = this.dashboard_data.patient_history),
          (data.mode = this.dashboard_data.visit_type);
        bodyFormData.append("my_symptoms", JSON.stringify(this.complaint));
        // } else if (type === "Examinations") {
        (data.pallor = this.examination_data.pallor),
          (data.cyanosis = this.examination_data.cyanosis),
          (data.edema = this.examination_data.edema),
          (data.hydration = this.examination_data.hydration),
          (data.icterus = this.examination_data.icterus),
          (data.clubbing = this.examination_data.clubbing),
          (data.dysponea = this.examination_data.dysponea),
          (data.thyroid = this.examination_data.thyroid),
          (data.lymphadenopathy = this.examination_data.lymphadenopathy),
          (data.jvp = this.examination_data.jvp),
          (data.examination_of_breast = this.examination_data.examination_of_breast),
          (data.eye_opening = this.examination_data.eye_opening),
          (data.verbal_response = this.examination_data.verbal_response),
          (data.motor_response = this.examination_data.motor_response),
          (data.score = this.subtotal),
          (data.cardiovascular_system = this.examination_data.cardiovascular_system),
          (data.central_nervous_system = this.examination_data.central_nervous_system),
          (data.abdomen = this.examination_data.abdomen),
          (data.respiratory_system = this.examination_data.respiratory_system),
          (data.local_examination = this.examination_data.local_examination);
  
        // assessment data
        (data.knee_xray_diagnosis_left = this.pain_analysis_data.knee_xray_diagnosis_left);
        (data.knee_xray_diagnosis_right = this.pain_analysis_data.knee_xray_diagnosis_right);
        (data.deformity_left = this.pain_analysis_data.deformity_left);
        (data.deformity_right = this.pain_analysis_data.deformity_right);
        (data.xray_diagnosis_remarks = this.pain_analysis_data.xray_diagnosis_remarks);
        (data.mri_diagnosis_left = this.pain_analysis_data.mri_diagnosis_left);
        (data.mri_assessment_remarks = this.pain_analysis_data.mri_assessment_remarks);
        (data.svf_left = this.pain_analysis_data.svf_left);
        (data.svf_right = this.pain_analysis_data.svf_right);
        (data.pfo_left = this.pain_analysis_data.pfo_left);
        (data.pfo_right = this.pain_analysis_data.pfo_right);
        (data.hto_left = this.pain_analysis_data.hto_left);
        (data.hto_right = this.pain_analysis_data.hto_right);
        (data.dfo_left = this.pain_analysis_data.dfo_left);
        (data.dfo_right = this.pain_analysis_data.dfo_right);
        (data.arthroscopy_left = this.pain_analysis_data.arthroscopy_left);
        (data.arthoscopy_right = this.pain_analysis_data.arthoscopy_right);
        bodyFormData.append(
          "encounter_diagnosis",
          JSON.stringify(this.diagnosis)
        );
  
        (data.investigation_advice = this.selected_investigation_template),
          (data.exercise_advice = this.selected_exercise_advice_template),
          (data.surgery_advice = this.selected_surgery_template),
          (data.prescription = this.selected_prescription_template),
          (data.advise = this.selected_general_advice_template);
  
        data.knee = this.joint_data.knee ? 1 : 0;
        data.knee_location = this.joint_data.knee_location;
        data.hip = this.joint_data.hip ? 1 : 0;
        data.hip_location = this.joint_data.hip_location;
        data.ankle = this.joint_data.ankle ? 1 : 0;
        data.ankle_location = this.joint_data.ankle_location;
        data.foot = this.joint_data.foot ? 1 : 0;
        data.foot_location = this.joint_data.foot_location;
        data.cervical_spine = this.joint_data.cervical_spine ? 1 : 0;
        data.lumbar_spine = this.joint_data.lumbar_spine ? 1 : 0;
        data.shoulder = this.joint_data.shoulder ? 1 : 0;
        data.shoulder_location = this.joint_data.shoulder_location;
        data.elbow = this.joint_data.elbow ? 1 : 0;
        data.elbow_location = this.joint_data.elbow_location;
        data.forearm = this.joint_data.forearm ? 1 : 0;
        data.forearm_location = this.joint_data.forearm_location;
        data.wrist = this.joint_data.wrist ? 1 : 0;
        data.wrist_location = this.joint_data.wrist_location;
        data.finger = this.joint_data.finger ? 1 : 0;
        data.pain_scale = this.joint_data.pain_scale;
        data.period = this.assistive_device_using[0].period;
        data.days = this.assistive_device_using[0].days;
        bodyFormData.append("pain_analysis", JSON.stringify(this.pain_analysis));
        bodyFormData.append(
          "injury_history",
          JSON.stringify(this.injury_history)
        );
        delete this.assistive_device_using[0].period;
        delete this.assistive_device_using[0].days;
        bodyFormData.append(
          "assistive_device_using",
          JSON.stringify(this.assistive_device_using)
        );
        // }
  
        bodyFormData.append("data", JSON.stringify(data));
        await CommonApi.post_data(
          "sahaj.api.add_patient_encounter_new",
          bodyFormData
        ).then((res) => {
          this.showspinner = false;
          if (res && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            });
            this.$router.push("/doctor/patient-encounter");
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
        });
      },
  
      /* Update Patient Encouner Data  */
      async update_patient_encounter(type) {
        if (!this.validateAllDropdowns()) {
          this.$swal.fire({
            icon: "warning",
            title: "Warning",
            text: "Please select values in dropdowns before updating .",
            showConfirmButton: true,
          });
          return;
        }
        if (!this.validateAllDropdown()) {
          this.$swal.fire({
            icon: "warning",
            title: "Warning",
            text: "Please select values in dropdowns before updating .",
            showConfirmButton: true,
          });
          return;
        }
  
        this.$swal({
          text: "Updating Patient Encounter...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        var bodyFormData = new FormData();
        let data = {
          name: this.$route.params.encounter_id,
          practitioner: this.user_id,
        };
  
        (data.encounter_date = this.convertDate(
          this.dashboard_data.encounter_date
        )),
          (data.encounter_time = this.dashboard_data.encounter_time),
          (data.patient_came_with_history = this.dashboard_data.patient_history),
          (data.mode = this.dashboard_data.visit_type);
        bodyFormData.append("my_symptoms", JSON.stringify(this.complaint));
        (data.pallor = this.examination_data.pallor),
          (data.cyanosis = this.examination_data.cyanosis),
          (data.edema = this.examination_data.edema),
          (data.hydration = this.examination_data.hydration),
          (data.icterus = this.examination_data.icterus),
          (data.clubbing = this.examination_data.clubbing),
          (data.dysponea = this.examination_data.dysponea),
          (data.thyroid = this.examination_data.thyroid),
          (data.lymphadenopathy = this.examination_data.lymphadenopathy),
          (data.jvp = this.examination_data.jvp),
          (data.examination_of_breast = this.examination_data.examination_of_breast),
          (data.eye_opening = this.examination_data.eye_opening),
          (data.verbal_response = this.examination_data.verbal_response),
          (data.motor_response = this.examination_data.motor_response),
          (data.score = this.subtotal),
          (data.cardiovascular_system = this.examination_data.cardiovascular_system),
          (data.central_nervous_system = this.examination_data.central_nervous_system),
          (data.abdomen = this.examination_data.abdomen),
          (data.respiratory_system = this.examination_data.respiratory_system),
          (data.local_examination = this.examination_data.local_examination);
  
        // update assessment data
        (data.knee_xray_diagnosis_left = this.pain_analysis_data.knee_xray_diagnosis_left);
        (data.knee_xray_diagnosis_right = this.pain_analysis_data.knee_xray_diagnosis_right);
        (data.deformity_left = this.pain_analysis_data.deformity_left);
        (data.deformity_right = this.pain_analysis_data.deformity_right);
        (data.xray_diagnosis_remarks = this.pain_analysis_data.xray_diagnosis_remarks);
        (data.mri_diagnosis_left = this.pain_analysis_data.mri_diagnosis_left);
        (data.mri_diagnosis_right = this.pain_analysis_data.mri_diagnosis_right);
        (data.mri_assessment_remarks = this.pain_analysis_data.mri_assessment_remarks);
        (data.svf_left = this.pain_analysis_data.svf_left);
        (data.svf_right = this.pain_analysis_data.svf_right);
        (data.pfo_left = this.pain_analysis_data.pfo_left);
        (data.pfo_right = this.pain_analysis_data.pfo_right);
        (data.hto_left = this.pain_analysis_data.hto_left);
        (data.hto_right = this.pain_analysis_data.hto_right);
        (data.dfo_left = this.pain_analysis_data.dfo_left);
        (data.dfo_right = this.pain_analysis_data.dfo_right);
        (data.arthroscopy_left = this.pain_analysis_data.arthroscopy_left);
        (data.arthoscopy_right = this.pain_analysis_data.arthoscopy_right);

        bodyFormData.append(
          "encounter_diagnosis",
          JSON.stringify(this.diagnosis)
        );
  
        (data.investigation_advice = this.selected_investigation_template),
          (data.exercise_advice = this.selected_exercise_advice_template),
          (data.surgery_advice = this.selected_surgery_template),
          (data.prescription = this.selected_prescription_template),
          (data.advise = this.selected_general_advice_template);
  
        data.knee = this.joint_data.knee ? 1 : 0;
        data.knee_location = this.joint_data.knee_location;
        data.hip = this.joint_data.hip ? 1 : 0;
        data.hip_location = this.joint_data.hip_location;
        data.ankle = this.joint_data.ankle ? 1 : 0;
        data.ankle_location = this.joint_data.ankle_location;
        data.foot = this.joint_data.foot ? 1 : 0;
        data.foot_location = this.joint_data.foot_location;
        data.cervical_spine = this.joint_data.cervical_spine ? 1 : 0;
        data.lumbar_spine = this.joint_data.lumbar_spine ? 1 : 0;
        data.shoulder = this.joint_data.shoulder ? 1 : 0;
        data.shoulder_location = this.joint_data.shoulder_location;
        data.elbow = this.joint_data.elbow ? 1 : 0;
        data.elbow_location = this.joint_data.elbow_location;
        data.forearm = this.joint_data.forearm ? 1 : 0;
        data.forearm_location = this.joint_data.forearm_location;
        data.wrist = this.joint_data.wrist ? 1 : 0;
        data.wrist_location = this.joint_data.wrist_location;
        data.finger = this.joint_data.finger ? 1 : 0;
        data.pain_scale = this.joint_data.pain_scale;
        data.period = this.assistive_device_using[0].period;
        data.days = this.assistive_device_using[0].days;
        data.therapy_plan = this.final_all_Physio_exercise_advice_template_name;
        bodyFormData.append("pain_analysis", JSON.stringify(this.pain_analysis));
        bodyFormData.append(
          "injury_history",
          JSON.stringify(this.injury_history)
        );
        delete this.assistive_device_using[0].period;
        delete this.assistive_device_using[0].days;
        bodyFormData.append(
          "assistive_device_using",
          JSON.stringify(this.assistive_device_using)
        );
  
        bodyFormData.append("encounter_data", JSON.stringify(data));
        // final_all_Physio_exercise_advice_template
        bodyFormData.append(
          "exercise",
          JSON.stringify(this.final_all_Physio_exercise_advice_template)
        );
  
        await CommonApi.post_data(
          "sahaj.api.update_patient_encounter",
          bodyFormData
        ).then((res) => {
          this.showspinner = false;
          if (res && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            });
            this.get_patient_encounter_data();
            if (type === "dashboard") {
              this.active = "Details";
            } else if (type === "Examinations") {
              this.active = "Treatment";
            }
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
        });
      },
  
      /* Submit Patient Encouner Data  */
      async submit_patient_encounter() {
        this.$swal({
          text: "Submitting Patient Encounter...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        var bodyFormData = new FormData();
        let data = {
          name: this.$route.params.encounter_id,
          practitioner: this.user_id,
          appointment: this.dashboard_data.appointment_id,
          patient: this.dashboard_data.patient_id,
          patient_name: this.dashboard_data.patient_name,
        };
  
        (data.patient_came_with_history = this.dashboard_data.patient_history),
          (data.mode = this.dashboard_data.visit_type);
        bodyFormData.append("my_symptoms", JSON.stringify(this.complaint));
        (data.pallor = this.examination_data.pallor),
          (data.cyanosis = this.examination_data.cyanosis),
          (data.edema = this.examination_data.edema),
          (data.hydration = this.examination_data.hydration),
          (data.icterus = this.examination_data.icterus),
          (data.clubbing = this.examination_data.clubbing),
          (data.dysponea = this.examination_data.dysponea),
          (data.thyroid = this.examination_data.thyroid),
          (data.lymphadenopathy = this.examination_data.lymphadenopathy),
          (data.jvp = this.examination_data.jvp),
          (data.examination_of_breast = this.examination_data.examination_of_breast),
          (data.eye_opening = this.examination_data.eye_opening),
          (data.verbal_response = this.examination_data.verbal_response),
          (data.motor_response = this.examination_data.motor_response),
          (data.score = this.subtotal),
          (data.cardiovascular_system = this.examination_data.cardiovascular_system),
          (data.central_nervous_system = this.examination_data.central_nervous_system),
          (data.abdomen = this.examination_data.abdomen),
          (data.respiratory_system = this.examination_data.respiratory_system),
          (data.local_examination = this.examination_data.local_examination);
  
        // submit assessment data
        (data.knee_xray_diagnosis_left = this.pain_analysis_data.knee_xray_diagnosis_left);
        (data.knee_xray_diagnosis_right = this.pain_analysis_data.knee_xray_diagnosis_right);
        (data.deformity_left = this.pain_analysis_data.deformity_left);
        (data.deformity_right = this.pain_analysis_data.deformity_right);
        (data.xray_diagnosis_remarks = this.pain_analysis_data.xray_diagnosis_remarks);
        (data.mri_diagnosis_left = this.pain_analysis_data.mri_diagnosis_left);
        (data.mri_diagnosis_right = this.pain_analysis_data.mri_diagnosis_right);
        (data.mri_assessment_remarks = this.pain_analysis_data.mri_assessment_remarks);
        (data.svf_left = this.pain_analysis_data.svf_left);
        (data.svf_right = this.pain_analysis_data.svf_right);
        (data.pfo_left = this.pain_analysis_data.pfo_left);
        (data.pfo_right = this.pain_analysis_data.pfo_right);
        (data.hto_left = this.pain_analysis_data.hto_left);
        (data.hto_right = this.pain_analysis_data.hto_right);
        (data.dfo_left = this.pain_analysis_data.dfo_left);
        (data.dfo_right = this.pain_analysis_data.dfo_right);
        (data.arthroscopy_left = this.pain_analysis_data.arthroscopy_left);
        (data.arthoscopy_right = this.pain_analysis_data.arthoscopy_right);
  
        bodyFormData.append(
          "encounter_diagnosis",
          JSON.stringify(this.diagnosis)
        );

        (data.investigation_advice = this.selected_investigation_template),
          (data.exercise_advice = this.selected_exercise_advice_template),
          (data.surgery_advice = this.selected_surgery_template),
          (data.prescription = this.selected_prescription_template),
          (data.advise = this.selected_general_advice_template);
  
        data.knee = this.joint_data.knee ? 1 : 0;
        data.knee_location = this.joint_data.knee_location;
        data.hip = this.joint_data.hip ? 1 : 0;
        data.hip_location = this.joint_data.hip_location;
        data.ankle = this.joint_data.ankle ? 1 : 0;
        data.ankle_location = this.joint_data.ankle_location;
        data.foot = this.joint_data.foot ? 1 : 0;
        data.foot_location = this.joint_data.foot_location;
        data.cervical_spine = this.joint_data.cervical_spine ? 1 : 0;
        data.lumbar_spine = this.joint_data.lumbar_spine ? 1 : 0;
        data.shoulder = this.joint_data.shoulder ? 1 : 0;
        data.shoulder_location = this.joint_data.shoulder_location;
        data.elbow = this.joint_data.elbow ? 1 : 0;
        data.elbow_location = this.joint_data.elbow_location;
        data.forearm = this.joint_data.forearm ? 1 : 0;
        data.forearm_location = this.joint_data.forearm_location;
        data.wrist = this.joint_data.wrist ? 1 : 0;
        data.wrist_location = this.joint_data.wrist_location;
        data.finger = this.joint_data.finger ? 1 : 0;
        data.pain_scale = this.joint_data.pain_scale;
        data.period = this.assistive_device_using[0].period;
        data.days = this.assistive_device_using[0].days;
        bodyFormData.append("pain_analysis", JSON.stringify(this.pain_analysis));
        bodyFormData.append(
          "injury_history",
          JSON.stringify(this.injury_history)
        );
        delete this.assistive_device_using[0].period;
        delete this.assistive_device_using[0].days;
        bodyFormData.append(
          "assistive_device_using",
          JSON.stringify(this.assistive_device_using)
        );
  
        bodyFormData.append("data", JSON.stringify(data));
        await CommonApi.post_data(
          "sahaj.api.add_patient_encounter_submit",
          bodyFormData
        ).then((res) => {
          this.showspinner = false;
          if (res && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            });
            this.$router.push("/doctor/patient-encounter");
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
        });
      },
  
      async get_patient_encounter_data() {
        const params = new URLSearchParams();
        params.append("name", this.$route.params.encounter_id);
        await CommonApi.get_data(
          "sahaj.api.get_patient_encounter_data",
          params
        ).then((res) => {
          if (res.data[0].patient_age) {
            this.patient_age = res.data[0].patient_age.substring(0, 17);
          } else {
            this.patient_age = '';
          }
          // this.patient_age = res.data[0].patient_age;
          this.practitioner_names = res.data[0].practitioner_name;
          this.practitioner = res.data[0].practitioner;
          this.dashboard_data.patient_image = res.data[0].image;
          this.patient_therapy_plan_template = res.data[0].therapy_plan_template;
          this.patient_exercise = res.data[0].exercise;
          this.dashboard_data.visit_type = res.data[0].mode;
          this.dashboard_data.encounter_date = this.convertDate(
            res.data[0].encounter_date
          );
          this.dashboard_data.encounter_time = res.data[0].encounter_time;
          this.doc_status = res.data[0].docstatus;
  
          this.dashboard_data.visit_type = res.data[0].mode;
          this.dashboard_data.patient_history =
            res.data[0].patient_came_with_history;
  
          if (res.data[0].my_symptoms.length) {
            this.complaint = [];
            res.data[0].my_symptoms.map((item) =>
              this.complaint.push({
                complaint: item.my_symptoms,
              })
            );
          }
  
          this.examination_data.pallor = res.data[0].pallor;
          this.examination_data.cyanosis = res.data[0].cyanosis;
          this.examination_data.edema = res.data[0].edema;
          this.examination_data.hydration = res.data[0].hydration;
          this.examination_data.icterus = res.data[0].icterus;
          this.examination_data.clubbing = res.data[0].clubbing;
          this.examination_data.dysponea = res.data[0].dysponea;
          this.examination_data.thyroid = res.data[0].thyroid;
          this.examination_data.lymphadenopathy = res.data[0].lymphadenopathy;
          this.examination_data.jvp = res.data[0].jvp;
          this.examination_data.examination_of_breast =
            res.data[0].examination_of_breast;
          this.examination_data.eye_opening = res.data[0].eye_opening;
          this.examination_data.verbal_response = res.data[0].verbal_response;
          this.examination_data.motor_response = res.data[0].motor_response;
          this.examination_data.score = res.data[0].score;
          this.examination_data.cardiovascular_system =
            res.data[0].cardiovascular_system;
          this.examination_data.central_nervous_system =
            res.data[0].central_nervous_system;
          this.examination_data.abdomen = res.data[0].abdomen;
          this.examination_data.respiratory_system =
            res.data[0].respiratory_system;
          this.examination_data.local_examination = res.data[0].local_examination;
  
  
          // add assessment data 
          this.pain_analysis_data.knee_xray_diagnosis_left = res.data[0].knee_xray_diagnosis_left;
          this.pain_analysis_data.knee_xray_diagnosis_right = res.data[0].knee_xray_diagnosis_right;
          this.pain_analysis_data.deformity_left = res.data[0].deformity_left;
          this.pain_analysis_data.deformity_right = res.data[0].deformity_right;
          this.pain_analysis_data.xray_diagnosis_remarks = res.data[0].xray_diagnosis_remarks;
          this.pain_analysis_data.mri_diagnosis_left = res.data[0].mri_diagnosis_left;
          this.pain_analysis_data.mri_diagnosis_right = res.data[0].mri_diagnosis_right;
          this.pain_analysis_data.mri_assessment_remarks = res.data[0].mri_assessment_remarks;
          this.pain_analysis_data.svf_left = res.data[0].svf_left;
          this.pain_analysis_data.svf_right = res.data[0].svf_right;
          this.pain_analysis_data.pfo_left = res.data[0].pfo_left;
          this.pain_analysis_data.pfo_right = res.data[0].pfo_right;
          this.pain_analysis_data.hto_left = res.data[0].hto_left;
          this.pain_analysis_data.hto_right = res.data[0].hto_right;
          this.pain_analysis_data.dfo_left = res.data[0].dfo_left;
          this.pain_analysis_data.dfo_right = res.data[0].dfo_right;
          this.pain_analysis_data.arthroscopy_left = res.data[0].arthroscopy_left;
          this.pain_analysis_data.arthoscopy_right = res.data[0].arthoscopy_right;
  
  
  
          if (res.data[0].pain_analysis.length) {
            this.pain_analysis = [];
            res.data[0].pain_analysis.map((item) =>
              this.pain_analysis.push({
                joint: item.joint,
                location: item.location,
                intensity: item.intensity,
                nature: item.nature,
                period: item.period,
                pain_since: item.pain_since,
                timing: item.timing,
              })
            );
          }
  
          if (res.data[0].injury_history.length) {
            this.injury_history = [];
            res.data[0].injury_history.map((item) =>
              this.injury_history.push({
                injury_type: item.injury_type,
                year: item.year,
              })
            );
          }
  
          if (res.data[0].assistive_device_using.length) {
            this.assistive_device_using = [];
  
            res.data[0].assistive_device_using.map((item) =>
              this.assistive_device_using.push({
                assistive_device: item.assistive_device_using,
              })
            );
          } else {
            this.assistive_device_using.push({
              assistive_device: "",
            });
          }
  
          this.assistive_device_using[0].period = res.data[0].period;
          this.assistive_device_using[0].days = res.data[0].days;
  
          this.joint_data.knee = res.data[0].knee ? true : false;
          this.joint_data.knee_location = res.data[0].knee_location;
          this.joint_data.hip = res.data[0].hip ? true : false;
          this.joint_data.hip_location = res.data[0].knee_location;
          this.joint_data.ankle = res.data[0].ankle ? true : false;
          this.joint_data.ankle_location = res.data[0].ankle_location;
          this.joint_data.foot = res.data[0].foot ? true : false;
          this.joint_data.foot_location = res.data[0].foot_location;
          this.joint_data.cervical_spine = res.data[0].cervical_spine
            ? true
            : false;
          this.joint_data.lumbar_spine = res.data[0].lumbar_spine ? true : false;
          this.joint_data.shoulder = res.data[0].shoulder ? true : false;
          this.joint_data.shoulder_location = res.data[0].shoulder_location;
          this.joint_data.elbow = res.data[0].elbow ? true : false;
          this.joint_data.elbow_location = res.data[0].elbow_location;
          this.joint_data.forearm = res.data[0].forearm ? true : false;
          this.joint_data.forearm_location = res.data[0].forearm_location;
          this.joint_data.wrist = res.data[0].wrist ? true : false;
          this.joint_data.wrist_location = res.data[0].wrist_location;
          this.joint_data.finger = res.data[0].finger ? true : false;
          this.joint_data.pain_scale = res.data[0].pain_scale;
          this.joint_assessment_id = res.data[0].joint_assessment;
  
          if (this.joint_data.knee) {
            this.selected_joint = "Knee";
          } else if (this.joint_data.hip) {
            this.selected_joint = "Hip";
          } else if (this.joint_data.ankle) {
            this.selected_joint = "Ankle";
          } else if (this.joint_data.foot) {
            this.selected_joint = "Foot";
          } else if (this.joint_data.shoulder) {
            this.selected_joint = "Shoulder";
          } else if (this.joint_data.elbow) {
            this.selected_joint = "Elbow";
          } else if (this.joint_data.forearm) {
            this.selected_joint = "Forearm";
          } else if (this.joint_data.wrist) {
            this.selected_joint = "Wrist";
          }

          (this.selected_investigation_template =
            res.data[0].investigation_advice),
            (this.selected_exercise_advice_template =
              res.data[0].exercise_advice),
            (this.selected_surgery_template = res.data[0].surgery_advice),
            (this.selected_prescription_template = res.data[0].prescription),
            (this.selected_general_advice_template = res.data[0].advise);
  
          if (res.data[0].encounter_diagnosis.length) {
            this.diagnosis = [];
            res.data[0].encounter_diagnosis.map((item) =>
              this.diagnosis.push({
                diagnosis: item.encounter_diagnosis,
              })
            );
          }
  
          if (this.joint_assessment_id !== null) {
            this.get_joint_assessment_details(this.joint_assessment_id);
          }
        });
        await this.get_all_treatment_plan_templates_list(this.practitioner);
        await this.get_investigation_advice_templates(this.practitioner);
        await this.get_medical_prescription_templates_list(this.practitioner);
        await this.get_surgery_advice_templates(this.practitioner);
        await this.get_general_advice_templates_list(this.practitioner);
        await this.get_exercise_templates_list(this.practitioner);
        await this.get_physio_exercise_templates_list(this.practitioner);
        await this.get_patient_documents(this.practitioner);
        await this.get_diagnosis(this.practitioner);
        await this.get_complaints_dr(this.practitioner);
      },
  
      /* Get Joint Assessment Data  */
      async get_joint_assessment_details(joint_assessment_id) {
        const params = new URLSearchParams();
        params.append("name", joint_assessment_id);
        await CommonApi.get_data(
          "sahaj.joint.get_joint_assessment_details",
          params
        ).then((res) => {
          if (res) {
            this.showspinner = false;
            (this.deep_tendon_reflexes_status =
              res.data[0].deep_tendon_reflexes_status),
              (this.superfecial_abdominal_reflexes_status =
                res.data[0].superfecial_abdominal_reflexes_status),
              (this.superfecial_flexor_planter_reflexes_status =
                res.data[0].superfecial_flexor_planter_reflexes_status),
              (this.superfecial_cremastric_reflexes_status =
                res.data[0].superfecial_cremastric_reflexes_status),
              (this.superfecial_extensor_planter_reflexes_status =
                res.data[0].superfecial_extensor_planter_reflexes_status),
              (this.observation_and_remarks =
                res.data[0].observation_and_remarks);
            this.joint_assessment.neurological_assessment =
              res.data[0].neurological_condition_status;
            this.joint_assessment.muscle_power_and_tone_assessment =
              res.data[0].need_muscle_power_and_tone_assessment;
  
            res.data[0].knee_assessment.map((data) => {
              if (data.location === "Right") {
                this.knee_assessment_right.laxity_status_examination =
                  data.laxity_status_examination;
                this.knee_assessment_right.deformity = data.deformity;
                this.knee_assessment_right.measurement_by_verniar_calipers =
                  data.measurement_by_verniar_calipers;
                this.knee_assessment_right.effusion = data.effusion;
                this.knee_assessment_right.osteophytes = data.osteophytes;
                this.knee_assessment_right.loose_body = data.loose_body;
                this.knee_assessment_right.tenderness_status =
                  data.tenderness_status;
                this.knee_assessment_right.muscle_girth_4_inches_above_joint_line =
                  data.muscle_girth_4_inches_above_joint_line;
                this.knee_assessment_right.range_of_motion = data.range_of_motion;
                this.knee_assessment_right.muscle_girth_4_inches_below_joint_line =
                  data.muscle_girth_4_inches_below_joint_line;
                this.knee_assessment_right.visual_analog_scale =
                  data.visual_analog_scale;
                this.knee_assessment_right.extension_deformity =
                  data.extension_deformity;
                this.knee_assessment_right.medial_rotation = data.medial_rotation;
                this.knee_assessment_right.flexion_deformity =
                  data.flexion_deformity;
                this.knee_assessment_right.lateral_rotation =
                  data.lateral_rotation;
                this.knee_assessment_right.laxity_by_lachmeter =
                  data.laxity_by_lachmeter;
                this.knee_assessment_right.extension = data.extension;
                this.knee_assessment_right.flexion = data.flexion;
                this.knee_assessment_right.koos_score = data.koos_score;
              } else {
                this.knee_assessment_left.laxity_status_examination =
                  data.laxity_status_examination;
                this.knee_assessment_left.deformity = data.deformity;
                this.knee_assessment_left.measurement_by_verniar_calipers =
                  data.measurement_by_verniar_calipers;
                this.knee_assessment_left.effusion = data.effusion;
                this.knee_assessment_left.tenderness_status =
                  data.tenderness_status;
                this.knee_assessment_left.muscle_girth_4_inches_above_joint_line =
                  data.muscle_girth_4_inches_above_joint_line;
                this.knee_assessment_left.range_of_motion = data.range_of_motion;
                this.knee_assessment_left.muscle_girth_4_inches_below_joint_line =
                  data.muscle_girth_4_inches_below_joint_line;
                this.knee_assessment_left.visual_analog_scale =
                  data.visual_analog_scale;
                this.knee_assessment_left.extension_deformity =
                  data.extension_deformity;
                this.knee_assessment_left.medial_rotation = data.medial_rotation;
                this.knee_assessment_left.flexion_deformity =
                  data.flexion_deformity;
                this.knee_assessment_left.lateral_rotation =
                  data.lateral_rotation;
                this.knee_assessment_left.laxity_by_lachmeter =
                  data.laxity_by_lachmeter;
                this.knee_assessment_left.extension = data.extension;
                this.knee_assessment_left.flexion = data.flexion;
                this.knee_assessment_left.koos_score = data.koos_score;
              }
            });
  
            res.data[0].hip_assessment.map((data) => {
              if (data.location === "Right") {
                this.hip_assessment_right.visual_analog_scale =
                  data.visual_analog_scale;
                (this.hip_assessment_right.abduction = data.abduction),
                  (this.hip_assessment_right.extension = data.extension),
                  (this.hip_assessment_right.flexion = data.flexion),
                  (this.hip_assessment_right.adduction = data.adduction),
                  (this.hip_assessment_right.range_of_motion =
                    data.range_of_motion),
                  (this.hip_assessment_right.hip_womac = data.hip_womac),
                  (this.hip_assessment_right.medial_rotation =
                    data.medial_rotation),
                  (this.hip_assessment_right.hip_hoos = data.hip_hoos),
                  (this.hip_assessment_right.extension_deformity =
                    data.extension_deformity),
                  (this.hip_assessment_right.hip_hoos_junior =
                    data.hip_hoos_junior);
              } else {
                this.hip_assessment_left.visual_analog_scale =
                  data.visual_analog_scale;
                (this.hip_assessment_left.abduction = data.abduction),
                  (this.hip_assessment_left.extension = data.extension),
                  (this.hip_assessment_left.flexion = data.flexion),
                  (this.hip_assessment_left.adduction = data.adduction),
                  (this.hip_assessment_left.range_of_motion =
                    data.range_of_motion),
                  (this.hip_assessment_left.hip_womac = data.hip_womac),
                  (this.hip_assessment_left.medial_rotation =
                    data.medial_rotation),
                  (this.hip_assessment_left.hip_hoos = data.hip_hoos),
                  (this.hip_assessment_left.extension_deformity =
                    data.extension_deformity),
                  (this.hip_assessment_left.hip_hoos_junior =
                    data.hip_hoos_junior);
              }
            });
  
            res.data[0].ankle_assessment.map((data) => {
              if (data.location === "Right") {
                this.ankle_assessment_right.visual_analog_scale =
                  data.visual_analog_scale;
                this.ankle_assessment_right.ankle_eversion = data.ankle_eversion;
                this.ankle_assessment_right.dorsiflexion = data.dorsiflexion;
                this.ankle_assessment_right.ankle_inversion =
                  data.ankle_inversion;
                this.ankle_assessment_right.faam = data.faam;
                this.ankle_assessment_right.plantarflexion = data.plantarflexion;
                this.ankle_assessment_right.maq = data.maq;
              } else {
                this.ankle_assessment_left.visual_analog_scale =
                  data.visual_analog_scale;
                this.ankle_assessment_left.ankle_eversion = data.ankle_eversion;
                this.ankle_assessment_left.dorsiflexion = data.dorsiflexion;
                this.ankle_assessment_left.ankle_inversion = data.ankle_inversion;
                this.ankle_assessment_left.faam = data.faam;
                this.ankle_assessment_left.plantarflexion = data.plantarflexion;
                this.ankle_assessment_left.maq = data.maq;
              }
            });
  
            res.data[0].shoulder_assessment.map((data) => {
              if (data.location === "Right") {
                this.shoulder_assessment_right.visual_analog_scale =
                  data.visual_analog_scale;
                this.shoulder_assessment_right.external_rotation =
                  data.external_rotation;
                this.shoulder_assessment_right.extension = data.extension;
                this.shoulder_assessment_right.flexion = data.flexion;
                this.shoulder_assessment_right.internal_rotation =
                  data.internal_rotation;
                this.shoulder_assessment_right.abduction = data.abduction;
                this.shoulder_assessment_right.pain_disability_index =
                  data.pain_disability_index;
                this.shoulder_assessment_right.adduction = data.adduction;
                this.shoulder_assessment_right.shoulder_hoos = data.shoulder_hoos;
              } else {
                this.shoulder_assessment_left.visual_analog_scale =
                  data.visual_analog_scale;
                this.shoulder_assessment_left.external_rotation =
                  data.external_rotation;
                this.shoulder_assessment_left.extension = data.extension;
                this.shoulder_assessment_left.flexion = data.flexion;
                this.shoulder_assessment_left.internal_rotation =
                  data.internal_rotation;
                this.shoulder_assessment_left.abduction = data.abduction;
                this.shoulder_assessment_left.pain_disability_index =
                  data.pain_disability_index;
                this.shoulder_assessment_left.adduction = data.adduction;
                this.shoulder_assessment_left.shoulder_hoos = data.shoulder_hoos;
              }
            });
  
            res.data[0].cervical_spine_assessment.map((data) => {
              this.cervical_spine_assessment.visual_analog_scale =
                data.visual_analog_scale;
              this.cervical_spine_assessment.rotation = data.rotation;
              this.cervical_spine_assessment.extension = data.extension;
              this.cervical_spine_assessment.neck_disability_index =
                data.neck_disability_index;
              this.cervical_spine_assessment.flexion = data.flexion;
              this.cervical_spine_assessment.lateral_flexion =
                data.lateral_flexion;
              this.cervical_spine_assessment.bournemouth_questionnaire =
                data.bournemouth_questionnaire;
            });
  
            res.data[0].lumbar_spine_assessment.map((data) => {
              this.lumbar_spine_assessment.visual_analog_scale =
                data.visual_analog_scale;
              this.lumbar_spine_assessment.quebec_disability_scale =
                data.rotation;
              this.lumbar_spine_assessment.extension = data.extension;
              this.lumbar_spine_assessment.lumbar_spine_muscle_power =
                data.neck_disability_index;
              this.lumbar_spine_assessment.flexion = data.flexion;
              this.lumbar_spine_assessment.lateral_flexion = data.lateral_flexion;
              this.lumbar_spine_assessment.fingertip_to_floor =
                data.bournemouth_questionnaire;
              this.lumbar_spine_assessment.rotation = data.rotation;
              this.lumbar_spine_assessment.lumbar_spine_pain_functional_scale =
                data.lumbar_spine_pain_functional_scale;
              this.lumbar_spine_assessment.lumbar_spine_lateral_flexion =
                data.lumbar_spine_lateral_flexion;
            });
  
            res.data[0].wrist_assessment.map((data) => {
              if (data.location === "Right") {
                this.wrist_assessment_right.visual_analog_scale =
                  data.visual_analog_scale;
                this.wrist_assessment_right.ulner_deviation_0_to_30 =
                  data.ulner_deviation_0_to_30;
                this.wrist_assessment_right.range_of_motion =
                  data.range_of_motion;
                this.wrist_assessment_right.radial_deviation_0_to_20 =
                  data.radial_deviation_0_to_20;
                this.wrist_assessment_right.dorsi_flexion_0_to_60 =
                  data.dorsi_flexion_0_to_60;
                this.wrist_assessment_right.disabilities_of_arm_shoulder_and_hand_dash =
                  data.disabilities_of_arm_shoulder_and_hand_dash;
                this.wrist_assessment_right.palmer_flexion_0_to_60 =
                  data.palmer_flexion_0_to_60;
              } else {
                this.wrist_assessment_left.visual_analog_scale =
                  data.visual_analog_scale;
                this.wrist_assessment_left.ulner_deviation_0_to_30 =
                  data.ulner_deviation_0_to_30;
                this.wrist_assessment_left.range_of_motion = data.range_of_motion;
                this.wrist_assessment_left.radial_deviation_0_to_20 =
                  data.radial_deviation_0_to_20;
                this.wrist_assessment_left.dorsi_flexion_0_to_60 =
                  data.dorsi_flexion_0_to_60;
                this.wrist_assessment_left.disabilities_of_arm_shoulder_and_hand_dash =
                  data.disabilities_of_arm_shoulder_and_hand_dash;
                this.wrist_assessment_left.palmer_flexion_0_to_60 =
                  data.palmer_flexion_0_to_60;
              }
            });
  
            res.data[0].elbow_assessment.map((data) => {
              if (data.location === "Right") {
                this.elbow_assessment_right.visual_analog_scale =
                  data.visual_analog_scale;
                this.elbow_assessment_right.extension = data.extension;
                this.elbow_assessment_right.flexion = data.flexion;
                this.elbow_assessment_right.disabilities_of_arm_shoulder_and_hand_dash =
                  data.disabilities_of_arm_shoulder_and_hand_dash;
              } else {
                this.elbow_assessment_left.visual_analog_scale =
                  data.visual_analog_scale;
                this.elbow_assessment_left.extension = data.extension;
                this.elbow_assessment_left.flexion = data.flexion;
                this.elbow_assessment_left.disabilities_of_arm_shoulder_and_hand_dash =
                  data.disabilities_of_arm_shoulder_and_hand_dash;
              }
            });
  
            res.data[0].foot_assessment.map((data) => {
              if (data.location === "Right") {
                (this.foot_assessment_right.visual_analog_scale =
                  data.visual_analog_scale),
                  (this.foot_assessment_right.function_index =
                    data.function_index);
              } else {
                (this.foot_assessment_left.visual_analog_scale =
                  data.visual_analog_scale),
                  (this.foot_assessment_left.function_index =
                    data.function_index);
              }
            });
  
            res.data[0].muscle_power_and_tone.map((data) => {
              if (data.location === "Right") {
                this.muscle_power_and_tone_right.joint = data.joint;
                this.muscle_power_and_tone_right.muscle = data.muscle;
                this.muscle_power_and_tone_right.tone = data.tone;
                this.muscle_power_and_tone_right.power = data.power;
              } else {
                this.muscle_power_and_tone_left.joint = data.joint;
                this.muscle_power_and_tone_left.muscle = data.muscle;
                this.muscle_power_and_tone_left.tone = data.tone;
                this.muscle_power_and_tone_left.power = data.power;
              }
            });
  
            res.data[0].neuro_conditions_assessment.map((data) => {
              if (data.location === "Right") {
                this.neuro_conditions_assessment_right.neuro_condition_type =
                  data.neuro_condition_type;
                this.neuro_conditions_assessment_right.date_of_assessment =
                  data.date_of_assessment;
                this.neuro_conditions_assessment_right.period = data.period;
                this.neuro_conditions_assessment_right.observation =
                  data.observation;
              } else {
                this.neuro_conditions_assessment_left.neuro_condition_type =
                  data.neuro_condition_type;
                this.neuro_conditions_assessment_left.date_of_assessment =
                  data.date_of_assessment;
                this.neuro_conditions_assessment_left.period = data.period;
                this.neuro_conditions_assessment_left.observation =
                  data.observation;
              }
            });
  
            res.data[0].neurological_reflexes_grading.map((data) => {
              if (data.location === "Right") {
                this.neurological_reflexes_grading_right.reflex = data.reflex;
                this.neurological_reflexes_grading_right.grading = data.grading;
              } else {
                this.neurological_reflexes_grading_left.reflex = data.reflex;
                this.neurological_reflexes_grading_left.grading = data.grading;
              }
            });
          } else {
            this.showspinner = false;
          }
        });
      },
  
      /* Get Patient All Vital  */
      async get_patient_key_vital_all() {
        const params = new URLSearchParams();
        params.append("patient", this.$route.params.patient_id);
        await CommonApi.get_data(
          "sahaj.api.get_patient_key_vital_all",
          params
        ).then((res) => {
          if (res) {
            this.showspinner = false;
  
            const formatDate = (dateString) => {
              const signsDate = new Date(dateString);
              return `${signsDate.getDate().toString().padStart(2, '0')}-${(signsDate.getMonth() + 1).toString().padStart(2, '0')}-${signsDate.getFullYear()}`;
            };
  
            res.pulse_history_all.map((data) => {
              this.pulse_data.push(data.pulse);
              this.pulse_dates.push(formatDate(data.signs_date));
            });
  
            res.temperature_history_all.map((data) => {
              this.temp_data.push(data.temperature);
              this.temp_dates.push(formatDate(data.signs_date));
            });
  
            res.bp_all.map((data) => {
              this.bp_data.push(data.bp);
              this.bp_dates.push(formatDate(data.signs_date));
            });
  
            res.fasting_blood_sugar_fbs_history_all.map((data) => {
              this.fasting_data.push(data.fasting_blood_sugar_fbs);
              this.fasting_dates.push(formatDate(data.signs_date));
            });
  
            res.random_blood_sugar_rbs_history_all.map((data) => {
              this.random_data.push(data.random_blood_sugar_rbs);
              this.random_dates.push(formatDate(data.signs_date));
            });
  
            res.hba1c_history_all.map((data) => {
              this.hba1c_data.push(data.hba1c);
              this.hba1c_dates.push(formatDate(data.signs_date));
            });
  
            res.weight_history_all.map((data) => {
              this.weight_data.push(data.weight);
              this.weight_dates.push(formatDate(data.signs_date));
            });
  
            res.bmi_history_all.map((data) => {
              this.bmi_data.push(data.bmi);
              this.bmi_dates.push(formatDate(data.signs_date));
            });
          } else {
            this.showspinner = false;
            this.temperature_history_data = [];
          }
        });
      },
  
  
      /* Add New Template  */
      async add_new_templates() {
        this.$swal({
          text: "Adding Template...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        await CommonApi.post_data(
          "sahaj.template.add_templates",
          this.add_templates
        ).then((res) => {
          this.showspinner = false;
          if (res && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            });
            this.get_all_treatment_plan_templates_list();
            this.get_investigation_advice_templates();
            this.get_medical_prescription_templates_list();
            this.get_surgery_advice_templates();
            this.get_general_advice_templates_list();
            this.get_exercise_templates_list();
            this.$emit("close");
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
          this.add_templates.category = "";
          this.add_templates.template_name = "";
          this.add_templates.description = "";
        });
      },
  
      /* Add New Surgery  */
      async add_surgery() {
        this.$swal({
          text: "Adding Surgery...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        let data = {
          template: this.new_surgery,
        };
        await CommonApi.post_data("sahaj.api.add_clinical_procedure", data).then(
          (res) => {
            this.showspinner = false;
            if (res && res.status_code === 200) {
              this.$swal.fire({
                icon: "success",
                title: "Success",
                text: res.message,
                showConfirmButton: true,
              });
              this.get_diagnosis();
              // this.surgery_template.push({ procedure: this.new_surgery });
              this.$emit("close");
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Error",
                text: res.message,
                showConfirmButton: true,
              });
            }
            this.new_surgery = "";
          }
        );
      },
  
      /* Add New Diagnosis  */
      async add_diagnosis() {
        this.$swal({
          text: "Adding Diagnosis...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        let data = {
          diagnosis: this.new_diagnosis,
          practitioner: this.user_id,
        };
        await CommonApi.post_data("sahaj.api.add_diagnosis_dr", data).then(
          (res) => {
            this.showspinner = false;
            if (res && res.status_code === 200) {
              this.$swal.fire({
                icon: "success",
                title: "Success",
                text: res.message,
                showConfirmButton: true,
              });
              this.get_diagnosis();
              this.diagnosis.push({ diagnosis: this.new_diagnosis });
              this.$emit("close");
            } else {
              this.$swal.fire({
                icon: "warning",
                title: "Warning",
                text: res.message,
                showConfirmButton: true,
              });
            }
            this.new_diagnosis = "";
          }
        );
      },
  
      /* Add New lab Test  */
      async add_lab_test() {
        this.$swal({
          text: "Adding lab Test...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        let data = {
          lab_test_name: this.new_labtest,
        };
        await CommonApi.post_data("sahaj.api.add_lab_test", data).then((res) => {
          this.showspinner = false;
          if (res && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            });
            this.get_lab_test();
            // this.lab_test.push({ lab_test_name: this.new_labtest });
            this.$emit("close");
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
          this.new_labtest = "";
        });
      },
  
      /* Add New Symptoms  */
      async add_symptoms() {
        this.$swal({
          text: "Adding Symptoms...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        let data = {
          complaint: this.new_complaint,
          practitioner: this.user_id,
        };
        await CommonApi.post_data("sahaj.api.add_complaints_dr", data).then(
          (res) => {
            this.showspinner = false;
            if (res && res.status_code === 200) {
              this.$swal.fire({
                icon: "success",
                title: "Success",
                text: res.message,
                showConfirmButton: true,
              });
              this.get_complaints_dr();
              this.complaint.push({ complaint: this.new_complaint });
              this.$emit("close");
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Error",
                text: res.message,
                showConfirmButton: true,
              });
            }
            this.new_complaint = "";
          }
        );
      },
  
      /* Add Vitals  */
      async add_vitals_signs() {
        this.$swal({
          text: "Adding Vitals...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        let data = {
          patient: this.$route.params.patient_id,
          attendant_name: this.user_name,
          encounter: this.$route.params.encounter_id,
          ...this.add_vitals,
        };
        await CommonApi.post_data("sahaj.api.add_vital_signs", data).then(
          (res) => {
            this.showspinner = false;
            if (res && res.status_code === 200) {
              this.$swal.fire({
                icon: "success",
                title: "Success",
                text: res.message,
                showConfirmButton: true,
              });
              this.get_patient_key_vital_last();
              this.get_patient_key_vital_all();
              this.$emit("close");
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Error",
                text: res.message,
                showConfirmButton: true,
              });
            }
            this.add_vitals.pulse = "";
            this.add_vitals.bp_systolic = "";
            this.add_vitals.bp_diastolic = "";
            this.add_vitals.temperature = "";
            this.add_vitals.height_in_feet = "";
            this.add_vitals.weight = "";
            this.add_vitals.random_blood_sugar_rbs = "";
            this.add_vitals.fasting_blood_sugar_fbs = "";
            this.add_vitals.HbA1C = "";
          }
        );
      },
  
      /* Get Patient Profile */
      async get_patient_profile() {
        const params = new URLSearchParams();
        params.append("name", this.$route.params.patient_id);
        await CommonApi.get_data(
          "sahaj.finalapi.get_patient_profile",
          params
        ).then((res) => {
          this.showspinner = false;
          if (res && res.status_code === 200) {
            this.dashboard_data.patient_name = res.data.patient_name;
            this.dashboard_data.patient_mobile = res.data.mobile;
            this.dashboard_data.gender = res.data.sex;
            this.dashboard_data.dob = res.data.dob;
          }
        });
      },
  
      /* Get Visit Types */
      async get_encounter_mode() {
        await CommonApi.get_data("sahaj.api.get_appointment_type").then((res) => {
          this.visit_types = res.data;
        });
      },
  
      /* Get Symptoms */
      async get_complaints_dr(practitionerName) {
        const params = new URLSearchParams();
        params.append("practitioner", practitionerName);
        await CommonApi.get_data("sahaj.api.get_complaints_dr", params).then(
          (res) => {
            this.all_symptoms = res.data;
          }
        );
      },
  
      /* Get Genders */
      async get_gender() {
        await CommonApi.get_data("sahaj.api.get_gender").then((res) => {
          this.genders = res.data;
        });
      },
  
      /* Get Eye Opening */
      async get_eye_opening() {
        await CommonApi.get_data("sahaj.api.get_eye_opening").then((res) => {
          this.eye_opening = res.message;
        });
      },
  
      /* Get Verbal Response */
      async get_verbal_response() {
        await CommonApi.get_data("sahaj.api.get_verbal_response").then((res) => {
          this.verbal_response = res.message;
        });
      },
  
      /* Get Motar Response */
      async get_motor_response() {
        await CommonApi.get_data("sahaj.api.get_motor_response").then((res) => {
          this.motar_response = res.message;
        });
      },
  
      /* Get Cardiovascular System */
      async get_cardiovascular_system() {
        await CommonApi.get_data("sahaj.api.get_cardiovascular_system").then(
          (res) => {
            this.cardiovascular_system = res.message;
          }
        );
      },
  
      /* Get Abdomen */
      async get_abdomen() {
        await CommonApi.get_data("sahaj.api.get_abdomen").then((res) => {
          this.adbomen = res.message;
        });
      },
  
      /* Get Central Nervous System */
      async get_central_nervous_system() {
        await CommonApi.get_data("sahaj.api.get_central_nervous_system").then(
          (res) => {
            this.central_nervous_system = res.message;
          }
        );
      },
  
      /* Get Respiratory System */
      async get_respiratory_system() {
        await CommonApi.get_data("sahaj.api.get_respiratory_system").then(
          (res) => {
            this.respiratory_system = res.message;
          }
        );
      },
  
      /* Get Joint Location System */
      async get_joints_location() {
        await CommonApi.get_data("sahaj.api.get_joints_location").then((res) => {
          this.knee_locations = res.message;
        });
      },
  
      /* Get Pain Intensity */
      async get_pain_intensity() {
        await CommonApi.get_data("sahaj.api.get_pain_intensity").then((res) => {
          this.pain_intensity = res.message;
        });
      },
  
      /* Get Assessment Diagnosis */
      async get_knee_xray_diagnosis() {
        await CommonApi.get_data("sahaj.api.knee_xray_diagnosis").then((res) => {
          this.knee_xray_diagnosis = res.message;
        });
      },
  
      /* Get Assessment Deformity */
      async get_knee_xray_deformity() {
        await CommonApi.get_data("sahaj.api.get_deformity").then((res) => {
          this.knee_xray_deformity = res.message;
        });
      },
  
      /* Get Assessment Mri Diagnosis */
      async get_mri_diagnosis() {
        await CommonApi.get_data("sahaj.api.get_mri_diagnosis").then((res) => {
          this.mri_diagnosis = res.message;
        });
      },
  
      /* Get Pain Nature */
      async get_pain_nature() {
        await CommonApi.get_data("sahaj.api.get_pain_nature").then((res) => {
          this.pain_nature = res.message;
        });
      },
  
      /* Get Pain Since */
      async get_pain_since() {
        await CommonApi.get_data("sahaj.api.get_pain_since").then((res) => {
          this.pain_since = res.message;
        });
      },
  
      /* Get Patient Timing */
      async get_pain_timing() {
        await CommonApi.get_data("sahaj.api.get_pain_timing").then((res) => {
          this.pain_timing = res.message;
        });
      },
  
      /* Get Injury Types */
      async get_injury_type() {
        await CommonApi.get_data("sahaj.api.get_injury_type").then((res) => {
          this.injury_types = res.data;
        });
      },
  
      validateAllDropdowns() {
        for (let i = 1; i < this.diagnosis.length; i++) {
          const value = this.diagnosis[i].diagnosis;
          if (!value || value.trim() === "") {
            return false; // Invalid dropdown found
          }
        }
        return true; // All dropdowns are valid
      },
  
      validateAllDropdown() {
        for (let i = 1; i < this.complaint.length; i++) {
          const value = this.complaint[i].complaint;
          if (!value || value.trim() === "") {
            return false; // Invalid dropdown found
          }
        }
        return true; // All dropdowns are valid
      },
  
  
  
      /* Get Assistive Device Days */
      async get_assistive_device_days() {
        await CommonApi.get_data("sahaj.api.get_assistive_device_days").then(
          (res) => {
            this.assistive_device_days = res.message;
          }
        );
      },
    },
  };
  </script>
  <style scoped>
  
  a[disabled="disabled"] {
    pointer-events: none;
    cursor: default;
  }
  
  .clinical_bold {
    font-size: 20px;
    color: black
  }
  </style>
  
  
  <!-- 
  @click="viewappointmentdata(item.name,false)" -->


// WEBPACK FOOTER //
// src/components/kneexpert/hospital/UpdatePatientEncounter.vue